import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import moment from 'moment';
import Stamp from '../assests/stamp.jpeg'
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch'
import {
    getTaskById,
    taskChecked,
    taskFinalisation,
    updateSubmitTask,
    updateTaskRemarks,
    updateTaskByID,
    dial,
    waive,
} from '../actions/taskActions';
import {
    GET_TASK_BY_ID_RESET,
    TASK_CHECKED_RESET,
    TASK_FINALISATION_RESET,
    TASK_UPDATE_REMARKS_RESET,
    UPDATE_TASK_BY_ID_RESET,
    DIAL_RESET
} from '../constants/taskConstants';

import Loading from '../components/Loading'
import Button from '../components/Button'
import Input from '../components/Input'
import Select from '../components/Select'
import FileCopyOutlined from '@material-ui/icons/FileCopyOutlined'
import PictureAsPdfOutlined from '@material-ui/icons/PictureAsPdfOutlined'
import Collections from "@material-ui/icons/Collections";
import BlockOutlined from '@material-ui/icons/BlockOutlined'
import Call from '@material-ui/icons/Call'
import JsPDF from 'jspdf'
import axios from 'axios'



const TaskById = () => {

    let params = useParams()
    let id = ''
    if (params.id) {
        id = params.id.replace(':', '')
    }

    // * States
    const navigate = useNavigate();
    const [isChecked, setIsChecked] = useState(false)
    const [isEditing, setIsEditing] = useState(false);
    const [name, setName] = useState('')
    const [mobile, setMobile] = useState('')
    const [address, setAddress] = useState('')
    const [branch, setBranch] = useState('')
    const [financeAmount, setFinanceAmount] = useState('')
    const [loanNumber, setLoanNumber] = useState('')
    const [loanType, setLoanType] = useState('')
    const [allocationRemarks, setAllocationRemarks] = useState('')
    const [assignedTo, setAssignedTo] = useState('')
    const [users, setUsers] = useState([])
    const [usersOptions, setUsersOptions] = useState([])
    const [customer, setCustomer] = useState('')
    const [customerOptions, setCustomerOptions] = useState([])
    const [type, setType] = useState('')
    const [receiptDate, setReceiptDate] = useState('')
    const [finalModal, setFinalModal] = useState(false)
    const [confirmModal, setConfirmModal] = useState(false)
    const [showSummary, setShowSummary] = useState(false)
    const [calling, setCalling] = useState(true)
    // * Calling
    const [callingModal, setCallingModal] = useState(false)
    const [number, setNumber] = useState('')
    // * Task Details
    const [assignedByName, setAssignedByName] = useState('')
    const [assignedToName, setAssignedToName] = useState('')
    const [finalisedByName, setFinalisedByName] = useState('')
    const [finalisedOn, setFinalisedOn] = useState('')
    const [taskData, setTaskData] = useState(null)
    const [taskRemark, setTaskRemark] = useState(null)
    // * Task Form
    const [taskStatus, setTaskStatus] = useState('')
    const [taskAddressFound, setTaskAddressFound] = useState('')
    const [customerAvailability, setCustomerAvailability] = useState('')
    const [showCustomerAvailability, setShowCustomerAvailability] = useState(false)
    const [shopAvailability, setShopAvailability] = useState('')
    const [showShopAvailability, setShowShopAvailability] = useState(false)
    const [signboardAvailabilty, setSignboardAvailabilty] = useState('')
    const [showSignboardAvailabilty, setShowSignboardAvailabilty] = useState(false)
    const [neighbourRemarks, setNeighbourRemarks] = useState('')
    const [showNeighbourRemarks, setShowNeighbourRemarks] = useState(false)
    const [showTaskReason, setShowTaskReason] = useState(false)
    const [taskReason, setTaskReason] = useState('')
    const [showIncompleteAddress, setShowIncompleteAddress] = useState(false)
    const [taskIncompleteAddress, setTaskIncompleteAddress] = useState('')
    const [showTaskInfoStatus, setShowTaskInfoStatus] = useState(false)
    const [taskInfoStatus, setTaskInfoStatus] = useState('')
    const [showTaskInfoAction, setShowTaskInfoAction] = useState(false)
    const [taskInfoAction, setTaskInfoAction] = useState('')
    const [showTaskPersonMet, setShowTaskPersonMet] = useState(false)
    const [taskPersonMet, setTaskPersonMet] = useState('')
    const [showTaskFeedback, setShowTaskFeedback] = useState(false)
    const [taskFeedback, setFeedback] = useState('')
    const [subReason, setSubReason] = useState('');
    const [
        showTaskRelationshipWithApplicant,
        setShowTaskRelationshipWithApplicant,
    ] = useState(false)
    const [taskRelationshipWithApplicant, setTaskRelationshipWithApplicant] =
        useState('')
    const [
        showTaskRelationshipWithApplicantDetails,
        setShowTaskRelationshipWithApplicantDetails,
    ] = useState(false)
    const [
        taskRelationshipWithApplicantDetails,
        setTaskRelationshipWithApplicantDetails,
    ] = useState('')
    const [showTaskApplicantAge, setShowTaskApplicantAge] = useState(false)
    const [taskApplicantAge, setTaskApplicantAge] = useState('')
    const [showTaskAddressChange, setShowTaskAddressChange] = useState(false)
    const [taskAddressChange, setTaskAddressChange] = useState('')
    const [showTaskEducationQualification, setShowTaskEducationQualification] =
        useState(false)
    const [taskEducationQualification, setTaskEducationQualification] =
        useState('')
    const [showTaskIDSeen, setShowTaskIDSeen] = useState(false)
    const [taskIDSeen, setTaskIDSeen] = useState('')
    const [showTaskIDProofType, setShowTaskIDProofType] = useState(false)
    const [taskIDProofType, setTaskIDProofType] = useState('')
    const [showTaskAddressProofSeen, setShowTaskAddressProofSeen] =
        useState(false)
    const [taskAddressProofSeen, setTaskAddressProofSeen] = useState('')
    const [showTaskAddressProofType, setShowTaskAddressProofType] =
        useState(false)
    const [taskAddressProofType, setTaskAddressProofType] = useState('')
    const [showTaskMaritalStatus, setShowTaskMaritalStatus] = useState(false)
    const [taskMaritalStatus, setTaskMaritalStatus] = useState('')
    const [showTaskNumberOfFamilyMembers, setShowTaskNumberOfFamilyMembers] =
        useState(false)
    const [taskNumberOfFamilyMembers, setTaskNumberOfFamilyMembers] = useState('')
    const [showTaskNumberOfDependents, setShowTaskNumberOfDependents] =
        useState(false)
    const [taskNumberOfDependents, setTaskNumberOfDependents] = useState('')
    const [showTaskTypeOfFamily, setShowTaskTypeOfFamily] = useState(false)
    const [taskTypeOfFamily, setTaskTypeOfFamily] = useState('')
    const [showTaskTypeOfFamilyDetails, setShowTaskTypeOfFamilyDetails] =
        useState(false)
    const [taskTypeOfFamilyDetails, setTaskTypeOfFamilyDetails] = useState('')
    const [showTaskOccupation, setShowTaskOccupation] = useState(false)
    const [taskOccupation, setTaskOccupation] = useState('')
    const [showTaskOccupationDetails, setShowTaskOccupationDetails] =
        useState(false)
    const [taskOccupationDetails, setTaskOccupationDetails] = useState('')
    const [showTaskResidenceOwnedBy, setShowTaskResidenceOwnedBy] =
        useState(false)
    const [taskResidenceOwnedBy, setTaskResidenceOwnedBy] = useState('')
    const [showTaskResidenceOwnedByDetails, setShowTaskResidenceOwnedByDetails] =
        useState(false)
    const [taskResidenceOwnedByDetails, setTaskResidenceOwnedByDetails] =
        useState('')
    const [showTaskTenureOfStay, setShowTaskTenureOfStay] = useState(false)
    const [taskTenureOfStay, setTaskTenureOfStay] = useState('')
    const [showTaskNamePlateSeen, setShowTaskNamePlateSeen] = useState(false)
    const [taskNamePlateSeen, setTaskNamePlateSeen] = useState('')
    const [
        showTaskNameMentionedOnNamePlate,
        setShowTaskNameMentionedOnNamePlate,
    ] = useState(false)
    const [taskNameMentionedOnNamePlate, setTaskNameMentionedOnNamePlate] =
        useState('')
    const [showTaskArea, setShowTaskArea] = useState(false)
    const [taskArea, setTaskArea] = useState('')
    const [showTaskFloorVisited, setShowTaskFloorVisited] = useState(false)
    const [taskFloorVisited, setTaskFloorVisited] = useState('')
    const [showTaskTypeOfHouse, setShowTaskTypeOfHouse] = useState(false)
    const [taskTypeOfHouse, setTaskTypeOfHouse] = useState('')
    const [showTaskFurnishingOfTheHouse, setShowTaskFurnishingOfTheHouse] =
        useState(false)
    const [taskFurnishingOfTheHouse, setTaskFurnishingOfTheHouse] = useState('')
    const [showTaskAssetsSeen, setShowTaskAssetsSeen] = useState(false)
    const [taskTelevision, setTaskTelevision] = useState(false)
    const [taskLaptop, setTaskLaptop] = useState(false)
    const [taskRefrigerator, setTaskRefrigerator] = useState(false)
    const [taskComputer, setTaskComputer] = useState(false)
    const [taskAirConditioner, setTaskAirConditioner] = useState(false)
    const [showTaskLocalityStatus, setShowTaskLocalityStatus] = useState(false)
    const [taskLocalityStatus, setTaskLocalityStatus] = useState('')
    const [showTaskLocalityType, setShowTaskLocalityType] = useState(false)
    const [taskLocalityType, setTaskLocalityType] = useState('')
    const [showTaskLocatingTheAddress, setShowTaskLocatingTheAddress] =
        useState(false)
    const [taskLocatingTheAddress, setTaskLocatingTheAddress] = useState('')
    const [showTaskLandmark, setShowTaskLandmark] = useState(false)
    const [taskLandmark, setTaskLandmark] = useState('')
    const [showTaskAreaType, setShowTaskAreaType] = useState(false)
    const [taskAreaType, setTaskAreaType] = useState('')
    const [showTaskResidenceAccessedBy, setShowTaskResidenceAccessedBy] =
        useState(false)
    const [taskResidenceAccessedBy, setTaskResidenceAccessedBy] = useState('')
    const [showTaskAreaTypeDetails, setShowTaskAreaTypeDetails] = useState(false)
    const [taskAreaTypeDetails, setTaskAreaTypeDetails] = useState('')
    const [showTaskPreviousVisitDone, setShowTaskPreviousVisitDone] =
        useState(false)
    const [taskPreviousVisitDone, setTaskPreviousVisitDone] = useState(false)
    const [showTaskPreviousVisitCount, setShowTaskPreviousVisitCount] =
        useState(false)
    const [taskPreviousVisitCount, setTaskPreviousVisitCount] = useState('')
    const [showTaskPreviousVisitMetPerson, setShowTaskPreviousVisitMetPerson] =
        useState(false)
    const [taskPreviousVisitMetPerson, setTaskPreviousVisitMetPerson] =
        useState('')
    const [showTaskRouteMap, setShowTaskRouteMap] = useState(false)
    const [taskRouteMap, setTaskRouteMap] = useState('')
    const [showTaskColorOfBuilding, setShowTaskColorOfBuilding] = useState(false)
    const [taskColorOfBuilding, setTaskColorOfBuilding] = useState('')
    const [showTaskColorOfGate, setShowTaskColorOfGate] = useState(false)
    const [taskColorOfGate, setTaskColorOfGate] = useState('')
    const [showTaskFirstNeighbourName, setShowTaskFirstNeighbourName] =
        useState(false)
    const [taskFirstNeighbourName, setTaskFirstNeighbourName] = useState('')
    const [showTaskFirstNeighbourAge, setShowTaskFirstNeighbourAge] =
        useState(false)
    const [taskFirstNeighbourAge, setTaskFirstNeighbourAge] = useState('')
    const [showTaskFirstNeighbourAddress, setShowTaskFirstNeighbourAddress] =
        useState(false)
    const [taskFirstNeighbourAddress, setTaskFirstNeighbourAddress] = useState('')
    const [showTaskFirstNeighbourFeedback, setShowTaskFirstNeighbourFeedback] =
        useState(false)
    const [taskFirstNeighbourFeedback, setTaskFirstNeighbourFeedback] =
        useState('')
    const [showTaskSecondNeighbourName, setShowTaskSecondNeighbourName] =
        useState(false)
    const [taskSecondNeighbourName, setTaskSecondNeighbourName] = useState('')
    const [showTaskSecondNeighbourAge, setShowTaskSecondNeighbourAge] =
        useState(false)
    const [taskSecondNeighbourAge, setTaskSecondNeighbourAge] = useState('')
    const [showTaskSecondNeighbourAddress, setShowTaskSecondNeighbourAddress] =
        useState(false)
    const [taskSecondNeighbourAddress, setTaskSecondNeighbourAddress] =
        useState('')
    const [showTaskSecondNeighbourFeedback, setShowTaskSecondNeighbourFeedback] =
        useState(false)
    const [taskSecondNeighbourFeedback, setTaskSecondNeighbourFeedback] =
        useState('')
    const [showTaskNotes, setShowTaskNotes] = useState(false)
    const [taskNotes, setTaskNotes] = useState('')
    const [finalisationStatus, setFinalisationStatus] = useState('')
    const [showFinalisationRemarks, setShowFinalisationRemarks] = useState(false)
    const [showSubReason, setShowSubReason] = useState(false)
    const [finalisationRemarks, setFinalisationRemarks] = useState('')
    // * Office
    const [showTaskDesignationOfPersonMet, setShowTaskDesignationOfPersonMet] =
        useState(false)
    const [taskDesignationOfPersonMet, setTaskDesignationOfPersonMet] =
        useState('')
    const [showTaskNameBoardSeen, setShowTaskNameBoardSeen] = useState(false)
    const [taskNameBoardSeen, setTaskNameBoardSeen] = useState('')
    const [
        showTaskNameMentionedOnNameBoard,
        setShowTaskNameMentionedOnNameBoard,
    ] = useState(false)
    const [taskNameMentionedOnNameBoard, setTaskNameMentionedOnNameBoard] =
        useState('')
    const [showTaskOccupationOffice, setShowTaskOccupationOffice] =
        useState(false)
    const [taskOccupationOffice, setTaskOccupationOffice] = useState('')
    const [showTaskOccupationOthers, setShowTaskOccupationOthers] =
        useState(false)
    const [taskOccupationOthers, setTaskOccupationOthers] = useState('')
    const [showTaskBusinessPremisesOwnedBy, setShowTaskBusinessPremisesOwnedBy] =
        useState(false)
    const [taskBusinessPremisesOwnedBy, setTaskBusinessPremisesOwnedBy] =
        useState('')
    const [showTaskRentAmount, setShowTaskRentAmount] = useState(false)
    const [taskRentAmount, setTaskRentAmount] = useState('')
    const [showTaskLandloadName, setShowTaskLandlordName] = useState(false)
    const [taskLandlordName, setTaskLandlordName] = useState('')
    const [showTaskWorkingSince, setShowTaskWorkingSince] = useState(false)
    const [taskWorkingSince, setTaskWorkingSince] = useState('')
    const [showTaskTotalEmployees, setShowTaskTotalEmployees] = useState(false)
    const [taskTotalEmployees, setTaskTotalEmployees] = useState(0)
    const [showTaskEmployeesSeen, setShowTaskEmployeesSeen] = useState(false)
    const [taskEmployeesSeen, setTaskEmployeesSeen] = useState(0)
    const [showTaskApplicantDesignation, setShowTaskApplicantDesignation] =
        useState(false)
    const [taskApplicantDesignation, setTaskApplicantDesignation] = useState('')
    const [showTaskApplicantDepartment, setShowTaskApplicantDepartment] =
        useState(false)
    const [taskApplicantDepartment, setTaskApplicantDepartment] = useState('')
    const [showTaskTypeOfOrganisation, setShowTaskTypeOfOrganisation] =
        useState(false)
    const [taskTypeOfOrganisation, setTaskTypeOfOrganisation] = useState('')
    const [showTaskEntryRestricted, setShowTaskEntryRestricted] = useState(false)
    const [taskEntryRestricted, setTaskEntryRestricted] = useState('')
    const [showTaskNatureOfBusiness, setShowTaskNatureOfBusiness] =
        useState(false)
    const [taskNatureOfBusiness, setTaskNatureOfBusiness] = useState('')
    const [showTaskNatureOfBusinessDetails, setShowTaskNatureOfBusinessDetails] =
        useState(false)
    const [taskNatureOfBusinessDetails, setTaskNatureOfBusinessDetails] =
        useState('')
    const [showTaskTypeOfOffice, setShowTaskTypeOfOffice] = useState(false)
    const [taskTypeOfOffice, setTaskTypeOfOffice] = useState('')
    const [showTaskLevelOfActivity, setShowTaskLevelOfActivity] = useState(false)
    const [taskLevelOfActivity, setTaskLevelOfActivity] = useState('')
    const [showTaskStockSeen, setShowTaskStockSeen] = useState(false)
    const [taskStockSeen, setTaskStockSeen] = useState('')
    const [showTaskFurnishingOfOffice, setShowTaskFurnishingOfOffice] =
        useState(false)
    const [taskFurnishingOfOffice, setTaskFurnishingOfOffice] = useState('')
    const [taskTelephone, setTaskTelephone] = useState(false)
    const [taskFax, setTaskFax] = useState(false)

    const [tasksUpdateOption, setTasksUpdateOption] = useState(false)
    const [taskSummaryOption, setTaskSummaryOption] = useState(false)
    const [addAllocationOption, setAddAllocationOption] = useState(false)
    const [loading, setLoading] = useState(true)

    //image
    const [popup, setPopup] = useState(false);
    const [photographsDetails, setPhotographsDetails] = useState([])
    const [imageModal, setImageModal] = useState(false)
    const [imageToDisplay, setImageToDisplay] = useState(null)
    const [totalImages, setTotalImages] = useState([])
    const [imageIndex, setImageIndex] = useState(0)

    const escFunction = useCallback((event) => {
        if (event.key === 'Escape') {
            closeImageModal()
        }
        //  else if (event.keyCode === 39) {
        //   let index = imageIndex
        //   setImageIndex(index + 1)
        // } else if (event.keyCode === 37) {
        //   let index = imageIndex
        //   setImageIndex(index - 1)
        // }
    }, [])

    useEffect(() => {
        document.addEventListener('keydown', escFunction, false)

        return () => {
            document.removeEventListener('keydown', escFunction, false)
        }
    }, [])

    useEffect(() => {
        setImageToDisplay(totalImages[imageIndex])
    }, [imageIndex])

    // * Image modal
    const openImageModal = (image) => {
        setImageToDisplay(image)
        setImageModal(true)
    }

    const closeImageModal = () => {
        setImageToDisplay(null)
        setImageModal(false)
    }

    useEffect(() => {
        if (imageToDisplay) {
            setImageIndex(totalImages.indexOf(imageToDisplay))
        }
    }, [imageToDisplay])

    // * Open Add User Modal
    const openFinalModal = () => {
        setFinalModal(true)
    }

    // * Close Modal
    const closeFinalModal = () => {
        setFinalisationRemarks('')
        setFinalisationStatus('')
        setSubReason('')
        setFinalModal(false)
    }

    // * Visual logic
    useEffect(() => {
        if (taskAddressFound === 'Yes') {
            setShowTaskInfoStatus(true)
            setShowTaskInfoAction(true)
            setShowTaskReason(false)
            setShowIncompleteAddress(false)
            setShowTaskNotes(true)
            setShowTaskFeedback(true)
            setShowTaskRouteMap(true)
            setShowTaskColorOfBuilding(true)
            setShowTaskColorOfGate(true)
            setShowCustomerAvailability(true)
            setShowShopAvailability(true)
            setShowSignboardAvailabilty(true)
            setShowNeighbourRemarks(true)
        } else if (taskAddressFound === 'No') {
            setShowCustomerAvailability(true)
            setShowShopAvailability(true)
            setShowSignboardAvailabilty(true)
            setShowNeighbourRemarks(true)
            setShowTaskReason(true)
            setShowTaskInfoStatus(false)
            setShowTaskInfoAction(false)
            setShowTaskPersonMet(false)
            setShowTaskFeedback(true)
            setShowTaskRelationshipWithApplicant(false)
            setShowTaskRelationshipWithApplicantDetails(false)
            setShowTaskApplicantAge(false)
            setShowTaskAddressChange(false)
            setShowTaskEducationQualification(false)
            setShowTaskIDSeen(false)
            setShowTaskIDProofType(false)
            setShowTaskAddressProofSeen(false)
            setShowTaskAddressProofType(false)
            setShowTaskMaritalStatus(false)
            setShowTaskNumberOfFamilyMembers(false)
            setShowTaskNumberOfDependents(false)
            setShowTaskTypeOfFamily(false)
            setShowTaskTypeOfFamilyDetails(false)
            setShowTaskOccupation(false)
            setShowTaskOccupationDetails(false)
            setShowTaskResidenceOwnedBy(false)
            setShowTaskResidenceOwnedByDetails(false)
            setShowTaskTenureOfStay(false)
            setShowTaskNamePlateSeen(false)
            setShowTaskNameMentionedOnNamePlate(false)
            setShowTaskArea(false)
            setShowTaskFloorVisited(false)
            setShowTaskTypeOfHouse(false)
            setShowTaskFurnishingOfTheHouse(false)
            setShowTaskAssetsSeen(false)
            setShowTaskLocalityStatus(false)
            setShowTaskLocalityType(false)
            setShowTaskLocatingTheAddress(false)
            setShowTaskLandmark(false)
            setShowTaskAreaType(false)
            setShowTaskResidenceAccessedBy(false)
            setShowTaskAreaTypeDetails(false)
            setShowTaskPreviousVisitDone(false)
            setShowTaskPreviousVisitCount(false)
            setShowTaskPreviousVisitMetPerson(false)
            setShowTaskRouteMap(false)
            setShowTaskColorOfBuilding(false)
            setShowTaskColorOfGate(false)
            setShowTaskFirstNeighbourName(false)
            setShowTaskFirstNeighbourAge(false)
            setShowTaskFirstNeighbourAddress(false)
            setShowTaskFirstNeighbourFeedback(false)
            setShowTaskSecondNeighbourName(false)
            setShowTaskSecondNeighbourAge(false)
            setShowTaskSecondNeighbourAddress(false)
            setShowTaskSecondNeighbourFeedback(false)
            setShowTaskDesignationOfPersonMet(false)
            setShowTaskNameBoardSeen(false)
            setShowTaskNameMentionedOnNameBoard(false)
            setShowTaskOccupationOffice(false)
            setShowTaskOccupationOthers(false)
            setShowTaskBusinessPremisesOwnedBy(false)
            setShowTaskRentAmount(false)
            setShowTaskLandlordName(false)
            setShowTaskWorkingSince(false)
            setShowTaskTotalEmployees(false)
            setShowTaskEmployeesSeen(false)
            setShowTaskApplicantDesignation(false)
            setShowTaskApplicantDepartment(false)
            setShowTaskTypeOfOrganisation(false)
            setShowTaskEntryRestricted(false)
            setShowTaskEntryRestricted(false)
            setShowTaskNatureOfBusiness(false)
            setShowTaskNatureOfBusinessDetails(false)
            setShowTaskTypeOfOffice(false)
            setShowTaskLevelOfActivity(false)
            setShowTaskStockSeen(false)
            setShowTaskFurnishingOfOffice(false)
        } else if (taskAddressFound === 'Short Form') {
            setShowCustomerAvailability(true)
            setShowShopAvailability(true)
            setShowSignboardAvailabilty(true)
            setShowNeighbourRemarks(true)
            setShowTaskNotes(true)
            setShowTaskReason(false)
            setShowTaskInfoStatus(false)
            setShowTaskInfoAction(false)
            setShowTaskPersonMet(false)
            setShowTaskFeedback(false)
            setShowTaskRelationshipWithApplicant(false)
            setShowTaskRelationshipWithApplicantDetails(false)
            setShowTaskApplicantAge(false)
            setShowTaskAddressChange(false)
            setShowTaskEducationQualification(false)
            setShowTaskIDSeen(false)
            setShowTaskIDProofType(false)
            setShowTaskAddressProofSeen(false)
            setShowTaskAddressProofType(false)
            setShowTaskMaritalStatus(false)
            setShowTaskNumberOfFamilyMembers(false)
            setShowTaskNumberOfDependents(false)
            setShowTaskTypeOfFamily(false)
            setShowTaskTypeOfFamilyDetails(false)
            setShowTaskOccupation(false)
            setShowTaskOccupationDetails(false)
            setShowTaskResidenceOwnedBy(false)
            setShowTaskResidenceOwnedByDetails(false)
            setShowTaskTenureOfStay(false)
            setShowTaskNamePlateSeen(false)
            setShowTaskNameMentionedOnNamePlate(false)
            setShowTaskArea(false)
            setShowTaskFloorVisited(false)
            setShowTaskTypeOfHouse(false)
            setShowTaskFurnishingOfTheHouse(false)
            setShowTaskAssetsSeen(false)
            setShowTaskLocalityStatus(false)
            setShowTaskLocalityType(false)
            setShowTaskLocatingTheAddress(false)
            setShowTaskLandmark(false)
            setShowTaskAreaType(false)
            setShowTaskResidenceAccessedBy(false)
            setShowTaskAreaTypeDetails(false)
            setShowTaskPreviousVisitDone(false)
            setShowTaskPreviousVisitCount(false)
            setShowTaskPreviousVisitMetPerson(false)
            setShowTaskRouteMap(false)
            setShowTaskColorOfBuilding(false)
            setShowTaskColorOfGate(false)
            setShowTaskFirstNeighbourName(false)
            setShowTaskFirstNeighbourAge(false)
            setShowTaskFirstNeighbourAddress(false)
            setShowTaskFirstNeighbourFeedback(false)
            setShowTaskSecondNeighbourName(false)
            setShowTaskSecondNeighbourAge(false)
            setShowTaskSecondNeighbourAddress(false)
            setShowTaskSecondNeighbourFeedback(false)
            setShowTaskDesignationOfPersonMet(false)
            setShowTaskNameBoardSeen(false)
            setShowTaskNameMentionedOnNameBoard(false)
            setShowTaskOccupationOffice(false)
            setShowTaskOccupationOthers(false)
            setShowTaskBusinessPremisesOwnedBy(false)
            setShowTaskRentAmount(false)
            setShowTaskLandlordName(false)
            setShowTaskWorkingSince(false)
            setShowTaskTotalEmployees(false)
            setShowTaskEmployeesSeen(false)
            setShowTaskApplicantDesignation(false)
            setShowTaskApplicantDepartment(false)
            setShowTaskTypeOfOrganisation(false)
            setShowTaskEntryRestricted(false)
            setShowTaskEntryRestricted(false)
            setShowTaskNatureOfBusiness(false)
            setShowTaskNatureOfBusinessDetails(false)
            setShowTaskTypeOfOffice(false)
            setShowTaskLevelOfActivity(false)
            setShowTaskStockSeen(false)
            setShowTaskFurnishingOfOffice(false)
        }
    }, [taskAddressFound])

    useEffect(() => {
        if (taskInfoStatus === 'Open Form') {
            setShowCustomerAvailability(true)
            setShowShopAvailability(true)
            setShowSignboardAvailabilty(true)
            setShowNeighbourRemarks(true)
            setShowTaskPersonMet(true)
            setShowTaskRelationshipWithApplicant(true)
            // setShowTaskFeedback(true)
            setShowTaskApplicantAge(true)
            setShowTaskAddressChange(true)
            setShowTaskEducationQualification(true)
            setShowTaskIDSeen(true)
            setShowTaskAddressProofSeen(true)
            setShowTaskMaritalStatus(true)
            setShowTaskNumberOfFamilyMembers(true)
            setShowTaskNumberOfDependents(true)
            setShowTaskTypeOfFamily(true)
            setShowTaskOccupation(true)
            setShowTaskResidenceOwnedBy(true)
            setShowTaskTenureOfStay(true)
            setShowTaskNamePlateSeen(true)
            setShowTaskArea(true)
            setShowTaskFloorVisited(true)
            setShowTaskTypeOfHouse(true)
            setShowTaskFurnishingOfTheHouse(true)
            setShowTaskLocalityStatus(true)
            setShowTaskLocalityType(true)
            setShowTaskLocatingTheAddress(true)
            setShowTaskAreaType(true)
            setShowTaskResidenceAccessedBy(true)
            setShowTaskPreviousVisitDone(true)
            setShowTaskFirstNeighbourName(true)
            setShowTaskFirstNeighbourAge(true)
            setShowTaskFirstNeighbourAddress(true)
            setShowTaskFirstNeighbourFeedback(true)
            setShowTaskSecondNeighbourName(true)
            setShowTaskSecondNeighbourAge(true)
            setShowTaskSecondNeighbourAddress(true)
            setShowTaskSecondNeighbourFeedback(true)
            setShowTaskDesignationOfPersonMet(true)
            setShowTaskNameBoardSeen(true)
            setShowTaskOccupationOffice(true)
            setShowTaskNatureOfBusiness(true)
            setShowTaskNatureOfBusinessDetails(true)
            setShowTaskTypeOfOffice(true)
            setShowTaskLevelOfActivity(true)
            setShowTaskStockSeen(true)
            setShowTaskFurnishingOfOffice(true)
            setShowTaskTypeOfOrganisation(true)
        } else {
            if (
                taskInfoStatus === 'Shifted' ||
                taskInfoStatus === 'No Such Person' ||
                taskInfoStatus === 'Entry Not Permitted' ||
                taskInfoStatus === 'Refused To Provide Details' ||
                taskInfoStatus === 'Cancel'
            ) {
                setShowCustomerAvailability(true)
                setShowShopAvailability(true)
                setShowSignboardAvailabilty(true)
                setShowNeighbourRemarks(true)
                setShowTaskPersonMet(true)
                setTaskDesignationOfPersonMet(true)
                setShowTaskFirstNeighbourName(true)
                setShowTaskFirstNeighbourAge(true)
                setShowTaskFirstNeighbourAddress(true)
                setShowTaskFirstNeighbourFeedback(true)
                setShowTaskSecondNeighbourName(true)
                setShowTaskSecondNeighbourAge(true)
                setShowTaskSecondNeighbourAddress(true)
                setShowTaskSecondNeighbourFeedback(true)
            } else {
                setShowTaskPersonMet(false)
            }

            if (
                taskInfoStatus === 'Refused To Provide Details' ||
                taskInfoStatus === 'Cancel'
            ) {
                setShowTaskRelationshipWithApplicant(true)
                setTaskDesignationOfPersonMet(true)
                setShowCustomerAvailability(true)
                setShowShopAvailability(true)
                setShowSignboardAvailabilty(true)
                setShowNeighbourRemarks(true)
            } else {
                setShowTaskRelationshipWithApplicant(false)
            }

            setShowTaskApplicantAge(false)
            setShowTaskAddressChange(false)
            setShowTaskEducationQualification(false)
            setShowTaskIDSeen(false)
            setShowTaskIDProofType(false)
            setShowTaskAddressProofSeen(false)
            setShowTaskAddressProofType(false)
            setShowTaskMaritalStatus(false)
            setShowTaskNumberOfFamilyMembers(false)
            setShowTaskNumberOfDependents(false)
            setShowTaskTypeOfFamily(false)
            setShowTaskTypeOfFamilyDetails(false)
            setShowTaskOccupation(false)
            setShowTaskOccupationDetails(false)
            setShowTaskResidenceOwnedBy(false)
            setShowTaskResidenceOwnedByDetails(false)
            setShowTaskTenureOfStay(false)
            setShowTaskNamePlateSeen(false)
            setShowTaskNameMentionedOnNamePlate(false)
            setShowTaskArea(false)
            setShowTaskFloorVisited(false)
            setShowTaskTypeOfHouse(false)
            setShowTaskFurnishingOfTheHouse(false)
            setShowTaskAssetsSeen(false)
            setTaskTelevision(false)
            setTaskLaptop(false)
            setTaskRefrigerator(false)
            setTaskComputer(false)
            setTaskAirConditioner(false)
            setShowTaskLocalityStatus(false)
            setShowTaskLocalityType(false)
            setShowTaskLocatingTheAddress(false)
            setShowTaskLandmark(false)
            setShowTaskAreaType(false)
            setShowTaskResidenceAccessedBy(false)
            setShowTaskAreaTypeDetails(false)
            setShowTaskPreviousVisitDone(false)
            setShowTaskPreviousVisitCount(false)
            setShowTaskPreviousVisitMetPerson(false)

            setTaskDesignationOfPersonMet(false)
            setShowTaskNameBoardSeen(false)
            setShowTaskNameMentionedOnNameBoard(false)
            setShowTaskOccupationOffice(false)
            setShowTaskOccupationOthers(false)
            setShowTaskBusinessPremisesOwnedBy(false)
            setShowTaskRentAmount(false)
            setShowTaskLandlordName(false)
            setShowTaskWorkingSince(false)
            setShowTaskTotalEmployees(false)
            setShowTaskEmployeesSeen(false)
            setShowTaskApplicantDesignation(false)
            setShowTaskApplicantDepartment(false)
            setShowTaskTypeOfOrganisation(false)
            setShowTaskEntryRestricted(false)
            setShowTaskEntryRestricted(false)
            setShowTaskNatureOfBusiness(false)
            setShowTaskNatureOfBusinessDetails(false)
            setShowTaskTypeOfOffice(false)
            setShowTaskLevelOfActivity(false)
            setShowTaskStockSeen(false)
            setShowTaskFurnishingOfOffice(false)
        }
    }, [taskInfoStatus])

    useEffect(() => {
        if (taskInfoStatus === 'Lock') {
            setShowTaskFirstNeighbourName(true)
            setShowTaskFirstNeighbourAge(true)
            setShowTaskFirstNeighbourAddress(true)
            setShowTaskFirstNeighbourFeedback(true)
            setShowTaskSecondNeighbourName(true)
            setShowTaskSecondNeighbourAge(true)
            setShowTaskSecondNeighbourAddress(true)
            setShowTaskSecondNeighbourFeedback(true)
            setShowCustomerAvailability(true)
            setShowShopAvailability(true)
            setShowSignboardAvailabilty(true)
            setShowNeighbourRemarks(true)
        }
    }, [taskInfoStatus])

    useEffect(() => {
        if (taskReason === 'Transfer') {
            setShowTaskNotes(false)
        } else if (
            taskReason === 'Address Not Found' ||
            taskReason === 'Wrong Address' ||
            taskReason === 'Incomplete Address'
        ) {
            setShowTaskNotes(true)
        }
    }, [taskReason])

    useEffect(() => {
        if (taskReason === 'Incomplete Address') {
            setShowIncompleteAddress(true)
        } else {
            setShowIncompleteAddress(false)
        }
    }, [taskReason])

    useEffect(() => {
        if (taskRelationshipWithApplicant === 'Others') {
            setShowTaskRelationshipWithApplicantDetails(true)
        } else {
            setShowTaskRelationshipWithApplicantDetails(false)
        }
    }, [taskRelationshipWithApplicant])

    useEffect(() => {
        if (taskIDSeen === 'Yes') {
            setShowTaskIDProofType(true)
        } else {
            setShowTaskIDProofType(false)
        }
    }, [taskIDSeen])

    useEffect(() => {
        if (taskAddressProofSeen === 'Yes') {
            setShowTaskAddressProofType(true)
        } else {
            setShowTaskAddressProofType(false)
        }
    }, [taskAddressProofSeen])

    useEffect(() => {
        if (taskTypeOfFamily === 'Others') {
            setShowTaskTypeOfFamilyDetails(true)
        } else {
            setShowTaskTypeOfFamilyDetails(false)
        }
    }, [taskTypeOfFamily])

    useEffect(() => {
        if (taskOccupation === 'Others' || taskOccupation === 'Self Employed') {
            setShowTaskOccupationDetails(true)
        } else {
            setShowTaskOccupationDetails(false)
        }
    }, [taskOccupation])

    useEffect(() => {
        if (taskResidenceOwnedBy === 'Others') {
            setShowTaskResidenceOwnedByDetails(true)
            setShowTaskRentAmount(false)
            setShowTaskLandlordName(false)
        } else if (taskResidenceOwnedBy === 'Rented') {
            setShowTaskResidenceOwnedByDetails(false)
            setShowTaskRentAmount(true)
            setShowTaskLandlordName(true)
        } else {
            setShowTaskResidenceOwnedByDetails(false)
            setShowTaskRentAmount(false)
            setShowTaskLandlordName(false)
        }
    }, [taskResidenceOwnedBy])

    useEffect(() => {
        if (taskNamePlateSeen === 'Yes') {
            setShowTaskNameMentionedOnNamePlate(true)
        } else {
            setShowTaskNameMentionedOnNamePlate(false)
        }
    }, [taskNamePlateSeen])

    useEffect(() => {
        if (type === 'Residence') {
            if (
                taskFurnishingOfTheHouse === 'Door Step Verification' ||
                taskFurnishingOfTheHouse === '' ||
                !taskFurnishingOfTheHouse
            ) {
                setShowTaskAssetsSeen(false)
                setTaskTelevision(false)
                setTaskLaptop(false)
                setTaskComputer(false)
                setTaskRefrigerator(false)
                setTaskAirConditioner(false)
            } else {
                setShowTaskAssetsSeen(true)
            }
        } else {
            if (
                taskFurnishingOfOffice === 'Door Step Verification' ||
                taskFurnishingOfOffice === '' ||
                !taskFurnishingOfOffice
            ) {
                setShowTaskAssetsSeen(false)
                setTaskTelephone(false)
                setTaskLaptop(false)
                setTaskComputer(false)
                setTaskFax(false)
                setTaskAirConditioner(false)
            } else {
                setShowTaskAssetsSeen(true)
            }
        }
    }, [taskFurnishingOfTheHouse, taskFurnishingOfOffice])

    useEffect(() => {
        if (
            taskLocatingTheAddress === 'Difficult' ||
            taskLocatingTheAddress === 'Landmark Required'
        ) {
            setShowTaskLandmark(true)
        } else {
            setShowTaskLandmark(false)
        }
    }, [taskLocatingTheAddress])

    useEffect(() => {
        if (taskAreaType === 'Community Dominated Area') {
            setShowTaskAreaTypeDetails(true)
        } else {
            setShowTaskAreaTypeDetails(false)
        }
    }, [taskAreaType])

    useEffect(() => {
        if (taskPreviousVisitDone === 'Yes') {
            setShowTaskPreviousVisitCount(true)
            setShowTaskPreviousVisitMetPerson(true)
        } else {
            setShowTaskPreviousVisitCount(false)
            setShowTaskPreviousVisitMetPerson(false)
        }
    }, [taskPreviousVisitDone])

    useEffect(() => {
        if (taskNameBoardSeen === 'Yes') {
            setShowTaskNameMentionedOnNameBoard(true)
        } else {
            setShowTaskNameMentionedOnNameBoard(false)
        }
    }, [taskNameBoardSeen])

    useEffect(() => {
        if (taskOccupationOffice === 'Others') {
            setShowTaskOccupationOthers(true)
            setShowTaskBusinessPremisesOwnedBy(false)
            setShowTaskWorkingSince(false)
            setShowTaskTotalEmployees(false)
            setShowTaskEmployeesSeen(false)
            setShowTaskApplicantDesignation(false)
            setShowTaskApplicantDepartment(false)
            // setShowTaskTypeOfOrganisation(false)
            setShowTaskEntryRestricted(false)
            setShowTaskRentAmount(false)
            setShowTaskLandlordName(false)
            setShowTaskEntryRestricted(false)
        } else if (taskOccupationOffice === 'Salaried') {
            setShowTaskOccupationOthers(false)
            setShowTaskBusinessPremisesOwnedBy(false)
            setShowTaskWorkingSince(true)
            setShowTaskTotalEmployees(true)
            setShowTaskEmployeesSeen(true)
            setShowTaskApplicantDesignation(true)
            setShowTaskApplicantDepartment(true)
            // setShowTaskTypeOfOrganisation(true)
            setShowTaskEntryRestricted(true)
            setShowTaskRentAmount(false)
            setShowTaskLandlordName(false)
            setShowTaskEntryRestricted(true)
        } else if (taskOccupationOffice === 'Business / Self Employed') {
            setShowTaskOccupationOthers(false)
            setShowTaskBusinessPremisesOwnedBy(true)
            setShowTaskWorkingSince(true)
            setShowTaskTotalEmployees(true)
            setShowTaskEmployeesSeen(true)
            setShowTaskApplicantDesignation(false)
            setShowTaskApplicantDepartment(false)
            // setShowTaskTypeOfOrganisation(false)
            setShowTaskEntryRestricted(false)
            setShowTaskEntryRestricted(false)
        } else {
            setShowTaskOccupationOthers(false)
            setShowTaskBusinessPremisesOwnedBy(false)
            setShowTaskWorkingSince(false)
            setShowTaskTotalEmployees(false)
            setShowTaskEmployeesSeen(false)
            setShowTaskApplicantDesignation(false)
            setShowTaskApplicantDepartment(false)
            // setShowTaskTypeOfOrganisation(false)
            setShowTaskEntryRestricted(false)
            setShowTaskRentAmount(false)
            setShowTaskLandlordName(false)
            setShowTaskEntryRestricted(false)
        }
    }, [taskOccupationOffice])

    useEffect(() => {
        if (taskBusinessPremisesOwnedBy === 'Rented') {
            setShowTaskRentAmount(true)
            setShowTaskLandlordName(true)
        } else {
            setShowTaskRentAmount(false)
            setShowTaskLandlordName(false)
        }
    }, [taskBusinessPremisesOwnedBy])

    // * Initialization
    const dispatch = useDispatch()

    // * Check for auth
    const userLogin = useSelector((state) => state.userLogin)
    const { loadingUserInfo, userInfo } = userLogin

    useEffect(() => {
        // * Check if user info exists
        if (!userInfo) {
            navigate('/');
        }
    }, [userInfo])

    // * Check for role
    const getRoleInfo = useSelector((state) => state.getRoleInfo)
    const { loadingGetRole, getRoleData } = getRoleInfo

    useEffect(() => {
        if (getRoleData) {
            // setDetailsView(getRoleData.tasksDetailsView)
            setTasksUpdateOption(getRoleData.tasksUpdate)
            setTaskSummaryOption(getRoleData.taskSummary)
            setAddAllocationOption(getRoleData.tasksAddAllocation)
            setCalling(getRoleData.calling)
            if (!getRoleData.tasksDetailsView) {
                navigate('/');
            }
        }
    }, [userInfo, getRoleData])

    // * On Start
    useEffect(() => {
        dispatch(getTaskById(id))
    }, [id])

    const getTaskIdInfo = useSelector((state) => state.getTaskIdInfo);
    const { loadingGetTaskIdInfo, errorGetTaskIdInfo, getTaskIdData } = getTaskIdInfo;

    useEffect(() => {
        dispatch({ type: GET_TASK_BY_ID_RESET });
        if (getTaskIdData) {
            setName(getTaskIdData.task.name)
            setMobile(getTaskIdData.task.mobile)
            setAddress(getTaskIdData.task.address)
            setLoanNumber(getTaskIdData.task.loanID)
            setLoanType(getTaskIdData.task.loanType)
            setReceiptDate(getTaskIdData.task.joinedOn)
            setAssignedTo(getTaskIdData.task.assignTo)
            setCustomer(getTaskIdData.task.customer._id)
            setType(getTaskIdData.task.type)
            setAllocationRemarks(getTaskIdData.task.allocationRemarks)
            setUsers(getTaskIdData.users)

            setAssignedByName(getTaskIdData.task.assignBy)
            setAssignedToName(getTaskIdData.assignToName)
            setFinalisedByName(getTaskIdData.finalisationByName)
            setFinalisedOn(getTaskIdData.task.finalisationOn)
            setIsChecked(getTaskIdData.task.isChecked)
            setTaskData(getTaskIdData.task)


            setTaskStatus(getTaskIdData.task.status)

            // * Information
            if (getTaskIdData.task.information) {
                setCustomerAvailability(getTaskIdData.task.information.customerAvailability)
                setShopAvailability(getTaskIdData.task.information.shopAvailability)
                setSignboardAvailabilty(getTaskIdData.task.information.signboardAvailabilty)
                setNeighbourRemarks(getTaskIdData.task.information.neighbourRemarks)
                setPhotographsDetails(getTaskIdData.task.information.photographsDetails)
                setTaskAddressFound(getTaskIdData.task.information.addressFoundDropdownValue)
                setTaskInfoStatus(getTaskIdData.task.information.actionDropdownValue)
                setTaskInfoAction(getTaskIdData.task.information.statusDropdownValue)
                setTaskPersonMet(getTaskIdData.task.information.personMet)
                setFeedback(getTaskIdData.task.information.feedback)
                setTaskRelationshipWithApplicant(
                    getTaskIdData.task.information.relationshipWithApplicant
                )
                setTaskRelationshipWithApplicantDetails(
                    getTaskIdData.task.information.relationshipWithApplicantDetails
                )
                setTaskApplicantAge(getTaskIdData.task.information.applicantAge)
                setTaskAddressChange(getTaskIdData.task.information.addressChange)
                setTaskEducationQualification(
                    getTaskIdData.task.information.educationQualification
                )
                setTaskIDSeen(getTaskIdData.task.information.idProofSeen)
                setTaskIDProofType(getTaskIdData.task.information.idProofType)
                setTaskAddressProofSeen(
                    getTaskIdData.task.information.addressProofSeen
                )
                setTaskAddressProofType(
                    getTaskIdData.task.information.addressProofType
                )
                setTaskMaritalStatus(getTaskIdData.task.information.maritalStatus)
                setTaskNumberOfFamilyMembers(
                    getTaskIdData.task.information.numberOfFamilyMembers
                )
                setTaskNumberOfDependents(
                    getTaskIdData.task.information.numberOfDependents
                )
                setTaskTypeOfFamily(getTaskIdData.task.information.typeOfFamily)
                setTaskTypeOfFamilyDetails(
                    getTaskIdData.task.information.typeOfFamilyDetails
                )
                setTaskOccupation(getTaskIdData.task.information.occupation)
                setTaskOccupationDetails(
                    getTaskIdData.task.information.occupationDetails
                )
                setTaskResidenceOwnedBy(
                    getTaskIdData.task.information.residenceOwnBy
                )
                setTaskResidenceOwnedByDetails(
                    getTaskIdData.task.information.residenceOwnByDetails
                )
                setTaskTenureOfStay(getTaskIdData.task.information.tenureOfStay)
                setTaskNamePlateSeen(getTaskIdData.task.information.namePlateSeen)
                setTaskNameMentionedOnNamePlate(
                    getTaskIdData.task.information.nameMentionedOnNamePlate
                )
                setTaskArea(getTaskIdData.task.information.area)
                setTaskFloorVisited(getTaskIdData.task.information.floorVisited)
                setTaskTypeOfHouse(getTaskIdData.task.information.typeOfHouse)
                setTaskFurnishingOfTheHouse(
                    getTaskIdData.task.information.furnishingOfHouse
                )
                setTaskTelevision(getTaskIdData.task.information.televisionChecked)
                setTaskLaptop(getTaskIdData.task.information.laptopChecked)
                setTaskComputer(getTaskIdData.task.information.computerChecked)
                setTaskRefrigerator(getTaskIdData.task.information.refrigeratorChecked)
                setTaskAirConditioner(getTaskIdData.task.information.airConditionerChecked)
                setTaskLocalityStatus(getTaskIdData.task.information.localityStatus)
                setTaskLocalityType(getTaskIdData.task.information.localityType)
                setTaskLocatingTheAddress(
                    getTaskIdData.task.information.locatingTheAddress
                )
                setTaskLandmark(getTaskIdData.task.information.landmark)
                setTaskAreaType(getTaskIdData.task.information.areaType)
                setTaskAreaTypeDetails(getTaskIdData.task.information.areaTypeDetails)
                setTaskPreviousVisitDone(
                    getTaskIdData.task.information.previousVisitDoneOnThisAddress
                )
                setTaskPreviousVisitCount(
                    getTaskIdData.task.information.numberOfTimesVisited
                )
                setTaskPreviousVisitMetPerson(
                    getTaskIdData.task.information.previousVisitMetPerson
                )
                setTaskRouteMap(getTaskIdData.task.information.routeMap)
                setTaskColorOfBuilding(getTaskIdData.task.information.colorOfBuilding)
                setTaskColorOfGate(getTaskIdData.task.information.colorOfGate)
                setTaskFirstNeighbourName(
                    getTaskIdData.task.information.firstNeighbourName
                )
                setTaskFirstNeighbourAge(
                    getTaskIdData.task.information.firstNeighbourAge
                )
                setTaskFirstNeighbourAddress(
                    getTaskIdData.task.information.firstNeighbourAddress
                )
                setTaskFirstNeighbourFeedback(
                    getTaskIdData.task.information.firstNeighbourFeedback
                )
                setTaskSecondNeighbourName(
                    getTaskIdData.task.information.secondNeighbourName
                )
                setTaskSecondNeighbourAge(
                    getTaskIdData.task.information.secondNeighbourAge
                )
                setTaskSecondNeighbourAddress(
                    getTaskIdData.task.information.secondNeighbourAddress
                )
                setTaskSecondNeighbourFeedback(
                    getTaskIdData.task.information.secondNeighbourFeedback
                )
                setTaskReason(getTaskIdData.task.information.reasonDropdownValue)
                setTaskIncompleteAddress(getTaskIdData.task.information.incompleteAddress)
                setTaskNotes(getTaskIdData.task.information.note)
                setTaskDesignationOfPersonMet(
                    getTaskIdData.task.information.designationOfPersonMet
                )
                setTaskNameBoardSeen(getTaskIdData.task.information.nameBoardSeen)
                setTaskNameMentionedOnNameBoard(
                    getTaskIdData.task.information.nameMentionedOnNameBoard
                )
                setTaskOccupationOffice(getTaskIdData.task.information.occupation)
                setTaskOccupationOthers(
                    getTaskIdData.task.information.occupationOthers
                )
                setTaskBusinessPremisesOwnedBy(
                    getTaskIdData.task.information.businessPremisesOwnedBy
                )
                setTaskRentAmount(getTaskIdData.task.information.rentAmount)
                setTaskLandlordName(getTaskIdData.task.information.landlordName)
                setTaskWorkingSince(getTaskIdData.task.information.workingSince)
                setTaskTotalEmployees(getTaskIdData.task.information.totalEmployees)
                setTaskEmployeesSeen(getTaskIdData.task.information.employeesSeen)
                setTaskApplicantDesignation(
                    getTaskIdData.task.information.applicantDesignation
                )
                setTaskApplicantDepartment(
                    getTaskIdData.task.information.applicantDepartment
                )
                setTaskTypeOfOrganisation(
                    getTaskIdData.task.information.typeOfOrganisation
                )
                setTaskEntryRestricted(getTaskIdData.task.information.entryRestricted)
                setTaskNatureOfBusiness(
                    getTaskIdData.task.information.natureOfBusiness
                )
                setTaskNatureOfBusinessDetails(
                    getTaskIdData.task.information.natureOfBusinessDetails
                )
                setTaskTypeOfOffice(getTaskIdData.task.information.typeOfOffice)
                setTaskLevelOfActivity(getTaskIdData.task.information.levelOfActivity)
                setTaskStockSeen(getTaskIdData.task.information.stockSeen)
                setTaskFurnishingOfOffice(
                    getTaskIdData.task.information.furnishingOfOffice
                )
                setTaskTelephone(getTaskIdData.task.information.telephoneChecked)
                setTaskFax(getTaskIdData.task.information.faxChecked)
                setTaskResidenceAccessedBy(
                    getTaskIdData.task.information.residenceAccessedBy
                )
                setTotalImages([
                    ...getTaskIdData.task.documents,
                    ...getTaskIdData.task.photographs,
                ])
            }

            // * Remark
            setTaskRemark(getTaskIdData.task.remarks)

            // * Finalisation
            setFinalisationStatus(getTaskIdData.task.finalisationStatus)
            setFinalisationRemarks(getTaskIdData.task.finalisationRemarks)
            setSubReason(getTaskIdData.task.subReason)

        } else if (errorGetTaskIdInfo) {
            setLoading(false);
            if (errorGetTaskIdInfo.includes('Cast')) {
                // Handle error appropriately
            }
            toast(errorGetTaskIdInfo, {
                type: 'error',
                hideProgressBar: true,
                autoClose: 2000,
            });
        }
    }, [dispatch, getTaskIdData, errorGetTaskIdInfo]);

    // if (loading || !taskData) {
    //     return <Loading />;
    // }

    // * Show or hide task summary
    useEffect(() => {
        if (taskStatus === 'Finalisation Pending' || taskStatus === 'Completed' || taskStatus === "Job Done" || taskStatus === "Sent To Bank") {
            if (taskSummaryOption && isChecked) {
                setShowSummary(true)
            } else {
                setShowSummary(false)
            }
        } else {
            setShowSummary(false)
        }
    }, [taskStatus, taskReason, taskSummaryOption, isChecked])

    useEffect(() => {
        if (finalisationStatus === 'Negative' || finalisationStatus === 'Refer') {
            setShowFinalisationRemarks(true);
            setShowSubReason(finalisationStatus === 'Negative');
        } else {
            setShowFinalisationRemarks(false);
            setShowSubReason(false);
        }
    }, [finalisationStatus]);

    const summaryHandler = () => {
        dispatch(taskChecked(id))
    }

    const taskCheckedInfo = useSelector((state) => state.taskCheckedInfo)
    const { loadingTaskCheckedInfo, errorTaskCheckedInfo, taskCheckedData } =
        taskCheckedInfo

    useEffect(() => {
        dispatch({ type: TASK_CHECKED_RESET })
        if (taskCheckedData) {
            toast(taskCheckedData.msg, {
                type: 'success',
                hideProgressBar: true,
                autoClose: 2000,
            })
            setIsChecked(true)
            setConfirmModal(false)
        } else if (errorTaskCheckedInfo) {
            toast(errorTaskCheckedInfo, {
                type: 'error',
                hideProgressBar: true,
                autoClose: 2000,
            })
        }
    }, [taskCheckedData, errorTaskCheckedInfo])

    // * Update Residence
    const updateResidence = () => {
        // * Validation
        if (taskAddressFound === 'No') {
            // if (!taskReason) {
            //     toast('Reason is mandatory in a negative case', {
            //         type: 'error',
            //         hideProgressBar: true,
            //         autoClose: 2000,
            //     })
            //     return
            // }

            if (
                taskReason === 'Address Not Found' ||
                taskReason === 'Wrong Address'
            ) {
                if (!taskNotes) {
                    toast('Notes are are mandatory', {
                        type: 'error',
                        hideProgressBar: true,
                        autoClose: 2000,
                    })
                    return
                }
            }

            // * Dispatch
            dispatch(
                updateSubmitTask(id, {
                    addressFoundDropdownValue: 'No',
                    reasonDropdownValue: taskReason,
                    note: taskNotes,
                    customerAvailability: customerAvailability,
                    shopAvailability: shopAvailability,
                    signboardAvailabilty: signboardAvailabilty,
                    neighbourRemarks: neighbourRemarks,
                    photographsDetails: photographsDetails,
                })
            )
        } else if (taskAddressFound === 'Short Form') {
            dispatch(
                updateSubmitTask(id, {
                    addressFoundDropdownValue: 'Short Form',
                    customerAvailability: customerAvailability,
                    shopAvailability: shopAvailability,
                    signboardAvailabilty: signboardAvailabilty,
                    neighbourRemarks: neighbourRemarks,
                    photographsDetails: photographsDetails,
                    note: taskNotes
                })
            )

        } else if (taskAddressFound === 'Yes') {
            // if (!taskInfoStatus) {
            //     toast('Status is mandatory in a positive case', {
            //         type: 'error',
            //         hideProgressBar: true,
            //         autoClose: 2000,
            //     })
            //     return
            // }

            // * If shifted
            if (
                taskInfoStatus === 'Shifted' ||
                taskInfoStatus === 'No Such Person' ||
                taskInfoStatus === 'Entry Not Permitted'
            ) {
                if (
                    !taskPersonMet ||
                    !taskColorOfBuilding ||
                    !taskColorOfGate ||
                    !taskNotes ||
                    !taskRouteMap
                ) {
                    toast('All the fields are mandatory', {
                        type: 'error',
                        hideProgressBar: true,
                        autoClose: 2000,
                    })
                    return
                }
            } else if (taskInfoStatus === 'Lock') {
                if (
                    !taskColorOfBuilding ||
                    !taskColorOfGate ||
                    !taskNotes ||
                    !taskRouteMap
                ) {
                    toast('All the fields are mandatory', {
                        type: 'error',
                        hideProgressBar: true,
                        autoClose: 2000,
                    })
                    return
                }
            } else if (
                taskInfoStatus === 'Refused To Provide Details' ||
                taskInfoStatus === 'Cancel'
            ) {
                if (
                    !taskPersonMet ||
                    !taskRelationshipWithApplicant ||
                    !taskColorOfBuilding ||
                    !taskColorOfGate ||
                    !taskNotes ||
                    !taskRouteMap
                ) {
                    toast('All the fields are mandatory', {
                        type: 'error',
                        hideProgressBar: true,
                        autoClose: 2000,
                    })
                    return
                }

                if (taskRelationshipWithApplicant === 'Others') {
                    if (!taskRelationshipWithApplicantDetails) {
                        toast('Relationship with applicant is required', {
                            type: 'error',
                            hideProgressBar: true,
                            autoClose: 2000,
                        })
                        return
                    }
                }
            } else {
                // * Positive
                // if (
                //     !taskPersonMet ||
                //     !taskRelationshipWithApplicant ||
                //     !taskFirstNeighbourName ||
                //     !taskFirstNeighbourAge ||
                //     !taskFirstNeighbourAddress ||
                //     !taskFirstNeighbourFeedback ||
                //     !taskSecondNeighbourName ||
                //     !taskSecondNeighbourAge ||
                //     !taskSecondNeighbourAddress ||
                //     !taskSecondNeighbourFeedback ||
                //     !taskApplicantAge ||
                //     !taskEducationQualification ||
                //     !taskIDSeen ||
                //     !taskAddressProofSeen ||
                //     !taskMaritalStatus ||
                //     !taskNumberOfFamilyMembers ||
                //     !taskNumberOfDependents ||
                //     !taskTypeOfFamily ||
                //     !taskOccupation ||
                //     !taskResidenceOwnedBy ||
                //     !taskTenureOfStay ||
                //     !taskNamePlateSeen ||
                //     !taskArea ||
                //     !taskFloorVisited ||
                //     !taskTypeOfHouse ||
                //     !taskLocalityStatus ||
                //     !taskLocalityType ||
                //     !taskLocatingTheAddress ||
                //     !taskAreaType ||
                //     !taskResidenceAccessedBy ||
                //     !taskPreviousVisitDone ||
                //     !taskColorOfBuilding ||
                //     !taskColorOfGate ||
                //     !taskRouteMap ||
                //     !taskNotes
                // ) {
                //     toast('All the fields are mandatory', {
                //         type: 'error',
                //         hideProgressBar: true,
                //         autoClose: 2000,
                //     })
                //     return
                // }

                if (taskRelationshipWithApplicant === 'Others') {
                    if (!taskRelationshipWithApplicantDetails) {
                        toast('Relationship with applicant is required', {
                            type: 'error',
                            hideProgressBar: true,
                            autoClose: 2000,
                        })
                        return
                    }
                }

                // if (taskIDSeen === 'Yes') {
                //   if (!taskIDProofType) {
                //     toast('ID Proof Type is mandatory', {
                //       type: 'error',
                //       hideProgressBar: true,
                //       autoClose: 2000,
                //     })
                //     return
                //   }
                // }

                if (taskAddressProofSeen === 'Yes') {
                    if (!taskAddressProofType) {
                        toast('Address Proof Type is mandatory', {
                            type: 'error',
                            hideProgressBar: true,
                            autoClose: 2000,
                        })
                        return
                    }
                }

                if (taskTypeOfFamily === 'Others') {
                    if (!taskTypeOfFamilyDetails) {
                        toast('Type of Family is mandatory', {
                            type: 'error',
                            hideProgressBar: true,
                            autoClose: 2000,
                        })
                        return
                    }
                }

                if (taskOccupation === 'Others') {
                    if (!taskOccupationDetails) {
                        toast('Occupation is mandatory', {
                            type: 'error',
                            hideProgressBar: true,
                            autoClose: 2000,
                        })
                        return
                    }
                }

                if (taskResidenceOwnedBy === 'Others') {
                    if (!taskResidenceOwnedByDetails) {
                        toast('Residence Owned By is mandatory', {
                            type: 'error',
                            hideProgressBar: true,
                            autoClose: 2000,
                        })
                        return
                    }
                }

                if (taskNamePlateSeen === 'Yes') {
                    if (!taskNameMentionedOnNamePlate) {
                        toast('Name mentioned on name plate is mandatory', {
                            type: 'error',
                            hideProgressBar: true,
                            autoClose: 2000,
                        })
                        return
                    }
                }

                if (
                    taskLocatingTheAddress === 'Difficult' ||
                    taskLocatingTheAddress === 'Landmark Required'
                ) {
                    if (!taskLandmark) {
                        toast('Landmark is mandatory', {
                            type: 'error',
                            hideProgressBar: true,
                            autoClose: 2000,
                        })
                        return
                    }
                }

                if (taskPreviousVisitDone === 'Yes') {
                    if (!taskPreviousVisitCount || !taskPreviousVisitMetPerson) {
                        toast('Previous visit details are mandatory', {
                            type: 'error',
                            hideProgressBar: true,
                            autoClose: 2000,
                        })
                        return
                    }
                }
            }
            // * dispatch
            dispatch(
                updateSubmitTask(id, {
                    addressFoundDropdownValue: 'Yes',
                    actionDropdownValue: taskInfoStatus,
                    customerAvailability: customerAvailability,
                    shopAvailability: shopAvailability,
                    signboardAvailabilty: signboardAvailabilty,
                    neighbourRemarks: neighbourRemarks,
                    personMet: taskPersonMet,
                    relationshipWithApplicant: taskRelationshipWithApplicant,
                    relationshipWithApplicantDetails:
                        taskRelationshipWithApplicantDetails,
                    applicantAge: taskApplicantAge,
                    addressChange: taskAddressChange,
                    educationQualification: taskEducationQualification,
                    idSeen: taskIDSeen,
                    idProofType: taskIDProofType,
                    addressProofSeen: taskAddressProofSeen,
                    addressProofType: taskAddressProofType,
                    maritalStatus: taskMaritalStatus,
                    numberOfFamilyMembers: taskNumberOfFamilyMembers,
                    numberOfDependents: taskNumberOfDependents,
                    typeOfFamily: taskTypeOfFamily,
                    typeOfFamilyDetails: taskTypeOfFamilyDetails,
                    occupation: taskOccupation,
                    residenceOwnedBy: taskResidenceOwnedBy,
                    occupationDetails: taskOccupationDetails,
                    residenceOwnedByDetails: taskResidenceOwnedByDetails,
                    tenureOfStay: taskTenureOfStay,
                    namePlateSeen: taskNamePlateSeen,
                    nameMentionedOnNamePlate: taskNameMentionedOnNamePlate,
                    area: taskArea,
                    floorVisited: taskFloorVisited,
                    typeOfHouse: taskTypeOfHouse,
                    furnishingOfTheHouse: taskFurnishingOfTheHouse,
                    television: Boolean(taskTelevision),
                    laptop: Boolean(taskLaptop),
                    computer: Boolean(taskComputer),
                    refrigerator: Boolean(taskRefrigerator),
                    airConditioner: Boolean(taskAirConditioner),
                    localityStatus: taskLocalityStatus,
                    localityType: taskLocalityType,
                    locatingTheAddress: taskLocatingTheAddress,
                    landmark: taskLandmark,
                    areaType: taskAreaType,
                    residenceAccessedBy: taskResidenceAccessedBy,
                    areaTypeDetails: taskAreaTypeDetails,
                    previousVisitDone: taskPreviousVisitDone,
                    previousVisitCount: taskPreviousVisitCount,
                    previousVisitMetPerson: taskPreviousVisitMetPerson,
                    routeMap: taskRouteMap,
                    colorOfBuilding: taskColorOfBuilding,
                    colorOfGate: taskColorOfGate,
                    note: taskNotes,
                    firstNeighbourName: taskFirstNeighbourName,
                    firstNeighbourAge: taskFirstNeighbourAge,
                    firstNeighbourAddress: taskFirstNeighbourAddress,
                    firstNeighbourFeedback: taskFirstNeighbourFeedback,
                    secondNeighbourName: taskSecondNeighbourName,
                    secondNeighbourAge: taskSecondNeighbourAge,
                    secondNeighbourAddress: taskSecondNeighbourAddress,
                    secondNeighbourFeedback: taskSecondNeighbourFeedback,
                    photographsDetails: photographsDetails,
                })
            )
        } else {
            console.log('Invalid value for taskAddressFound:', taskAddressFound);
            toast('Please select address found from the dropdown', {
                type: 'error',
                hideProgressBar: true,
                autoClose: 2000,
            })
        }
    }

    // * Users
    useEffect(() => {
        if (users.length > 0) {
            let data = []
            users.forEach((item) => {
                data.push({
                    id: item._id,
                    title: `${item.identifier} - ${item.name}`,
                })
            })
            setUsersOptions(data)
        }
    }, [users])

    // * Customers
    useEffect(() => {
        let data = []
        userInfo.customers.map((item) => {
            data.push({
                id: item._id,
                title: item.name,
            })
        })
        setCustomerOptions(data)
    }, [])

    // * Update Task Allocation
    const updateTaskAllocation = () => {
        if (!name || !mobile || !address || !customer || !type) {
            toast('All the fields with * are mandatory', {
                type: 'error',
                hideProgressBar: true,
                autoClose: 2000,
            })
            return
        }

        if (addAllocationOption === true && !assignedTo) {
            toast('Please select a user from the dropdown to allocate to', {
                type: 'error',
                hideProgressBar: true,
                autoClose: 2000,
            })
            return
        }

        dispatch(
            updateTaskByID(
                id,
                name,
                mobile,
                address,
                loanType,
                branch,
                financeAmount,
                type,
                loanNumber,
                receiptDate,
                allocationRemarks,
                addAllocationOption === true ? assignedTo : '' // * Only in case allocator
            )
        )
    }

    const updateTaskByIDInfo = useSelector((state) => state.updateTaskByIDInfo)
    const {
        loadingUpdateTaskByIDInfo,
        errorUpdateTaskByIDInfo,
        updateTaskByIDData,
    } = updateTaskByIDInfo

    useEffect(() => {
        dispatch({ type: UPDATE_TASK_BY_ID_RESET })
        if (updateTaskByIDData) {
            toast('Task updated successfully', {
                type: 'success',
                hideProgressBar: true,
                autoClose: 2000,
            })
            setTimeout(() => {
                dispatch(getTaskById(id))
            }, 1000)
        } else if (errorUpdateTaskByIDInfo) {
            toast(errorUpdateTaskByIDInfo, {
                type: 'error',
                hideProgressBar: true,
                autoClose: 2000,
            })
        }
    }, [updateTaskByIDData, errorUpdateTaskByIDInfo])

    // * Update Office
    const updateOffice = () => {
        // * Validation
        if (taskAddressFound === 'No') {
            if (!taskReason) {
                toast('Reason is mandatory in a negative case', {
                    type: 'error',
                    hideProgressBar: true,
                    autoClose: 2000,
                })
                return
            }

            if (
                taskReason === 'Address Not Found' ||
                taskReason === 'Wrong Address'
            ) {
                if (!taskNotes) {
                    toast('Notes are are mandatory', {
                        type: 'error',
                        hideProgressBar: true,
                        autoClose: 2000,
                    })
                    return
                }
            }

            // * Dispatch
            dispatch(
                updateSubmitTask(id, {
                    addressFound: 'No',
                    reason: taskReason,
                    notes: taskNotes,
                })
            )
        } else if (taskAddressFound === 'Yes') {
            if (!taskInfoStatus) {
                toast('Status is mandatory in a positive case', {
                    type: 'error',
                    hideProgressBar: true,
                    autoClose: 2000,
                })
                return
            }

            // * If shifted
            if (
                taskInfoStatus === 'Shifted' ||
                taskInfoStatus === 'No Such Person' ||
                taskInfoStatus === 'Entry Not Permitted'
            ) {
                if (
                    !taskPersonMet ||
                    !taskColorOfBuilding ||
                    !taskColorOfGate ||
                    !taskNotes ||
                    !taskRouteMap
                ) {
                    toast('All the fields are mandatory', {
                        type: 'error',
                        hideProgressBar: true,
                        autoClose: 2000,
                    })
                    return
                }
            } else if (taskInfoStatus === 'Lock') {
                if (
                    !taskColorOfBuilding ||
                    !taskColorOfGate ||
                    !taskNotes ||
                    !taskRouteMap
                ) {
                    toast('All the fields are mandatory', {
                        type: 'error',
                        hideProgressBar: true,
                        autoClose: 2000,
                    })
                    return
                }
            } else if (
                taskInfoStatus === 'Refused To Provide Details' ||
                taskInfoStatus === 'Cancel'
            ) {
                if (
                    !taskPersonMet ||
                    !taskDesignationOfPersonMet ||
                    !taskColorOfBuilding ||
                    !taskColorOfGate ||
                    !taskNotes ||
                    !taskRouteMap
                ) {
                    toast('All the fields are mandatory', {
                        type: 'error',
                        hideProgressBar: true,
                        autoClose: 2000,
                    })
                    return
                }
            } else {
                // * Positive
                if (
                    !taskPersonMet ||
                    !taskDesignationOfPersonMet ||
                    !taskFirstNeighbourName ||
                    !taskFirstNeighbourAge ||
                    !taskFirstNeighbourAddress ||
                    !taskFirstNeighbourFeedback ||
                    !taskSecondNeighbourName ||
                    !taskSecondNeighbourAge ||
                    !taskSecondNeighbourAddress ||
                    !taskSecondNeighbourFeedback ||
                    !taskApplicantAge ||
                    !taskEducationQualification ||
                    !taskIDSeen ||
                    !taskNameBoardSeen ||
                    !taskArea ||
                    !taskOccupation ||
                    !taskNatureOfBusiness ||
                    !taskTypeOfOffice ||
                    !taskLocalityStatus ||
                    !taskLocalityType ||
                    !taskLevelOfActivity ||
                    !taskStockSeen ||
                    !taskFurnishingOfOffice ||
                    !taskLocatingTheAddress ||
                    !taskPreviousVisitDone ||
                    !taskColorOfBuilding ||
                    !taskColorOfGate ||
                    !taskRouteMap ||
                    !taskNotes
                ) {
                    toast('All the fields are mandatory', {
                        type: 'error',
                        hideProgressBar: true,
                        autoClose: 2000,
                    })
                    return
                }

                // if (taskIDSeen === 'Yes') {
                //   if (!taskIDProofType) {
                //     toast('ID Proof Type is mandatory', {
                //       type: 'error',
                //       hideProgressBar: true,
                //       autoClose: 2000,
                //     })
                //     return
                //   }
                // }

                if (taskNameBoardSeen === 'Yes') {
                    if (!taskNameMentionedOnNameBoard) {
                        toast('Name mentioned on name board is mandatory', {
                            type: 'error',
                            hideProgressBar: true,
                            autoClose: 2000,
                        })
                        return
                    }
                }

                if (taskOccupation === 'Salaried') {
                    if (
                        !taskApplicantDesignation ||
                        !taskApplicantDepartment ||
                        !taskTypeOfOrganisation ||
                        !taskEntryRestricted ||
                        !taskWorkingSince ||
                        !taskTotalEmployees ||
                        !taskEmployeesSeen
                    ) {
                        toast('All the fields are mandatory', {
                            type: 'error',
                            hideProgressBar: true,
                            autoClose: 2000,
                        })
                        return
                    }
                } else if (taskOccupation === 'Business / Self Employed') {
                    if (
                        !taskBusinessPremisesOwnedBy ||
                        !taskWorkingSince ||
                        !taskTotalEmployees ||
                        !taskEmployeesSeen
                    ) {
                        toast('All the fields are mandatory', {
                            type: 'error',
                            hideProgressBar: true,
                            autoClose: 2000,
                        })
                        return
                    }
                } else {
                    if (!taskOccupationOthers) {
                        toast('All the fields are mandatory', {
                            type: 'error',
                            hideProgressBar: true,
                            autoClose: 2000,
                        })
                        return
                    }
                }

                if (taskBusinessPremisesOwnedBy === 'Rented') {
                    if (!taskRentAmount || !taskLandlordName) {
                        toast('All the fields are mandatory', {
                            type: 'error',
                            hideProgressBar: true,
                            autoClose: 2000,
                        })
                        return
                    }
                }

                if (taskNatureOfBusiness === 'Others') {
                    if (!taskNatureOfBusinessDetails) {
                        toast('All the fields are mandatory', {
                            type: 'error',
                            hideProgressBar: true,
                            autoClose: 2000,
                        })
                        return
                    }
                }

                if (
                    taskLocatingTheAddress === 'Difficult' ||
                    taskLocatingTheAddress === 'Landmark Required'
                ) {
                    if (!taskLandmark) {
                        toast('Landmark is mandatory', {
                            type: 'error',
                            hideProgressBar: true,
                            autoClose: 2000,
                        })
                        return
                    }
                }

                if (taskPreviousVisitDone === 'Yes') {
                    if (!taskPreviousVisitCount || !taskPreviousVisitMetPerson) {
                        toast('Previous visit details are mandatory', {
                            type: 'error',
                            hideProgressBar: true,
                            autoClose: 2000,
                        })
                        return
                    }
                }
            }

            dispatch(
                updateSubmitTask(id, {
                    addressFound: 'Yes',
                    status: taskInfoStatus,
                    personMet: taskPersonMet,
                    designationOfPersonMet: taskDesignationOfPersonMet,
                    applicantAge: taskApplicantAge,
                    addressChange: taskAddressChange,
                    educationQualification: taskEducationQualification,
                    idSeen: taskIDSeen,
                    idProofType: taskIDProofType,
                    nameBoardSeen: taskNameBoardSeen,
                    nameMentionedOnNameBoard: taskNameMentionedOnNameBoard,
                    area: taskArea,
                    occupation: taskOccupationOffice,
                    occupationOthers: taskOccupationOthers,
                    applicantDesignation: taskApplicantDesignation,
                    applicantDepartment: taskApplicantDepartment,
                    typeOfOrganisation: taskTypeOfOrganisation,
                    entryRestricted: taskEntryRestricted,
                    businessPremisesOwnedBy: taskBusinessPremisesOwnedBy,
                    rentAmount: taskRentAmount,
                    landlordName: taskLandlordName,
                    workingSince: taskWorkingSince,
                    totalEmployees: taskTotalEmployees,
                    employeesSeen: taskEmployeesSeen,
                    natureOfBusiness: taskNatureOfBusiness,
                    natureOfBusinessDetails: taskNatureOfBusinessDetails,
                    typeOfOffice: taskTypeOfOffice,
                    localityStatus: taskLocalityStatus,
                    localityType: taskLocalityType,
                    levelOfActivity: taskLevelOfActivity,
                    stockSeen: taskStockSeen,
                    furnishingOfOffice: taskFurnishingOfOffice,
                    telephone: Boolean(taskTelephone),
                    laptop: Boolean(taskLaptop),
                    computer: Boolean(taskComputer),
                    fax: Boolean(taskFax),
                    airConditioner: Boolean(taskAirConditioner),
                    locatingTheAddress: taskLocatingTheAddress,
                    landmark: taskLandmark,
                    previousVisitDone: taskPreviousVisitDone,
                    previousVisitCount: taskPreviousVisitCount,
                    previousVisitMetPerson: taskPreviousVisitMetPerson,
                    routeMap: taskRouteMap,
                    colorOfBuilding: taskColorOfBuilding,
                    colorOfGate: taskColorOfGate,
                    notes: taskNotes,
                    firstNeighbourName: taskFirstNeighbourName,
                    firstNeighbourAge: taskFirstNeighbourAge,
                    firstNeighbourAddress: taskFirstNeighbourAddress,
                    firstNeighbourFeedback: taskFirstNeighbourFeedback,
                    secondNeighbourName: taskSecondNeighbourAddress,
                    secondNeighbourAge: taskSecondNeighbourAge,
                    secondNeighbourAddress: taskSecondNeighbourAddress,
                    secondNeighbourFeedback: taskSecondNeighbourFeedback,
                })
            )
        } else {
            toast('Please select address found from the dropdown', {
                type: 'error',
                hideProgressBar: true,
                autoClose: 2000,
            })
        }
    }

    const taskUpdateSubmitInfo = useSelector(
        (state) => state.taskUpdateSubmitInfo
    )
    const {
        loadingUpdateSubmitTask,
        errorUpdateSubmitTask,
        updateSubmitTaskData,
    } = taskUpdateSubmitInfo

    useEffect(() => {
        if (updateSubmitTaskData) {
            toast(updateSubmitTaskData.msg, {
                type: 'success',
                hideProgressBar: true,
                autoClose: 2000,
            })
            setTimeout(() => {
                dispatch(getTaskById(id))
            }, 1000)
        } else if (errorUpdateSubmitTask) {
            toast(errorUpdateSubmitTask, {
                type: 'error',
                hideProgressBar: true,
                autoClose: 2000,
            })
        }
    }, [updateSubmitTaskData])

    // * Update remarks
    const updateRemarks = () => {
        if (!taskRemark) {
            toast('Remark is mandatory', {
                type: 'error',
                hideProgressBar: true,
                autoClose: 2000,
            })
        } else {
            dispatch(updateTaskRemarks(id, taskRemark))
        }
    }

    const taskUpdateRemarksInfo = useSelector(
        (state) => state.taskUpdateRemarksInfo
    )
    const {
        loadingUpdateRemarksTask,
        errorUpdateRemarksTask,
        updateRemarksTaskData,
    } = taskUpdateRemarksInfo

    useEffect(() => {
        dispatch({ type: TASK_UPDATE_REMARKS_RESET })
        if (updateRemarksTaskData) {
            toast(updateRemarksTaskData.msg, {
                type: 'success',
                hideProgressBar: true,
                autoClose: 2000,
            })
            setTimeout(() => {
                dispatch(getTaskById(id))
            }, 1000)
        } else if (errorUpdateRemarksTask) {
            toast(errorUpdateRemarksTask, {
                type: 'error',
                hideProgressBar: true,
                autoClose: 2000,
            })
        }
    }, [updateRemarksTaskData, errorUpdateRemarksTask])

    // * Update Finalisation
    const updateFinalisation = () => {
        if (finalisationStatus === '') {
            toast('Final Status is mandatory', {
                type: 'error',
                hideProgressBar: true,
                autoClose: 2000,
            })
            return
        }

        if (finalisationStatus === 'Negative') {
            if (!finalisationRemarks) {
                toast('Negative Reason is mandatory', {
                    type: 'error',
                    hideProgressBar: true,
                    autoClose: 2000,
                })
                return
            }
            if (hasSubOptions() && !subReason) {
                toast('Sub Reason is mandatory', {
                    type: 'error',
                    hideProgressBar: true,
                    autoClose: 2000,
                })
                return
            }
        }

        if (finalisationStatus === 'Refer' && !finalisationRemarks) {
            toast('Finalisation Remarks are mandatory for Refer status', {
                type: 'error',
                hideProgressBar: true,
                autoClose: 2000,
            })
            return
        }

        let finalisationData = {
            finalisationStatus,
            finalisationRemarks,
        }

        if (finalisationStatus === 'Negative') {
            finalisationData.subReason = subReason
        }

        dispatch(taskFinalisation(id, finalisationData))
    }

    const taskFinalisationInfo = useSelector(
        (state) => state.taskFinalisationInfo
    )
    const {
        loadingTaskFinalisation,
        errorTaskFinalisation,
        taskFinalisationData,
    } = taskFinalisationInfo

    useEffect(() => {
        dispatch({ type: TASK_FINALISATION_RESET })
        if (taskFinalisationData) {
            console.log('Task finalisation successful:', taskFinalisationData) // Debug log
            toast(taskFinalisationData.msg, {
                type: 'success',
                hideProgressBar: true,
                autoClose: 2000,
            })
            setFinalModal(false)
            setTimeout(() => {
                dispatch(getTaskById(id))
            }, 1000)
        } else if (errorTaskFinalisation) {
            console.log('Task finalisation error:', errorTaskFinalisation) // Debug log
            toast(errorTaskFinalisation, {
                type: 'error',
                hideProgressBar: true,
                autoClose: 2000,
            })
        }
    }, [taskFinalisationData, errorTaskFinalisation])



    // * Print PDF
    const printPDF = async () => {
        if (taskData.type === 'Residence') {
            try {
                const response = await axios.get(
                    'https://pro.golog.tech/api/tasks/download/' + id,
                    { responseType: 'blob' }
                )
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', taskData.taskID + '.pdf') //or any other extension
                document.body.appendChild(link)
                link.click()
            } catch (error) {
                toast(
                    error.response && error.response.data.message
                        ? error.response.data.message
                        : error.message,
                    {
                        type: 'error',
                        hideProgressBar: true,
                        autoClose: 2000,
                    }
                )
            }
        } else {
            const report = new JsPDF('portrait', 'pt', 'a4')
            let reportDiv = document.querySelector('#report')
            reportDiv.style.display = 'flex'
            report.html(reportDiv).then(async () => {
                report.save(taskData.taskID + '.pdf')
                reportDiv.style.display = 'none'
            })
        }
    }

    const handleNotFired = () => {
        dispatch(taskFinalisation(id, {
            status: 'Not Fired',  // This will update the main status field
            finalisationRemarks: 'Task marked as Not Fired',
            subReason: ''
        }))
    }

    // Handle Mapping
    const handleMapping = () => {
        dispatch(taskFinalisation(id, {
            status: 'Mapping',  // This will update the main status field
            finalisationRemarks: 'Task marked as Mapping',
            subReason: ''
        }))
    }



    // * Print PDF
    const printVendorPDF = async () => {
        const report = new JsPDF('portrait', 'pt', 'a4')
        let reportDiv = document.querySelector('#vendorReport')
        reportDiv.style.display = 'flex'
        report.html(reportDiv).then(async () => {
            report.save(taskData.taskID + '.pdf')
            reportDiv.style.display = 'none'
        })
    }


    // * Calling
    const callingHandler = () => {
        if (!number) {
            toast('Enter a valid number to dial', {
                type: 'error',
                hideProgressBar: true,
                autoClose: 2000,
            })
        } else {
            dispatch(dial(id, number))
        }
    }

    const closeCallingModal = () => {
        setNumber('')
        setCallingModal(false)
    }

    const dialInfo = useSelector((state) => state.dialInfo)
    const { loadingDial, errorDial, dialData } = dialInfo

    useEffect(() => {
        dispatch({ type: DIAL_RESET })
        if (dialData) {
            toast(dialData.msg, {
                type: 'success',
                hideProgressBar: true,
                autoClose: 2000,
            })

            closeCallingModal()
        } else if (errorDial) {
            toast(errorDial, {
                type: 'error',
                hideProgressBar: true,
                autoClose: 2000,
            })
        }
    }, [dialData, errorDial])

    // * Call listened
    const [callsToListen, setCallsToListen] = useState(0)
    const [callsListened, setCallsListened] = useState([])
    useEffect(() => {
        if (taskData && taskData.calls) { // Check if taskData and taskData.calls are not undefined/null
            let count = 0;
            taskData.calls.forEach((item) => {
                if (item.id !== '' && item.status === 'Call dialled successfully') {
                    count++;
                }
            });
            setCallsToListen(count);
        }
    }, [taskData]);

    const addCallListened = (id) => {
        if (!callsListened.includes(id)) {
            setCallsListened([...callsListened, id])
        }
    }

    const keyHandler = (e) => {
        if (e.key === 'ArrowLeft') {
            if (imageIndex !== 0) {
                setImageIndex(imageIndex - 1)
            }
        } else if (e.key === 'ArrowRight') {
            if (imageIndex !== totalImages.length - 1) {
                setImageIndex(imageIndex + 1)
            }
        }
    }

    // * Waive
    const waiveTaskInfo = useSelector((state) => state.waiveTaskInfo)
    const { loadingWaiveTask, waiveTaskData, errorWaiveTask } = waiveTaskInfo

    useEffect(() => {
        if (waiveTaskData) {
            toast(waiveTaskData.msg, {
                type: 'success',
                hideProgressBar: true,
                autoClose: 2000,
            })
        } else if (errorWaiveTask) {
            toast(errorWaiveTask, {
                type: 'error',
                hideProgressBar: true,
                autoClose: 2000,
            })
        }
    }, [waiveTaskData, errorWaiveTask])

    const isWithinThreeMonths = () => {
        if (!taskData || !taskData.joinedOn) return false;
        const joinedDate = moment(taskData.joinedOn);
        const threeMonthsLater = joinedDate.clone().add(3, 'months');
        return moment().isBefore(threeMonthsLater);
    };

    const negativeOptions = {
        Residence: [
            {
                id: "NO CONFIRMATION",
                title: "NO CONFIRMATION",
                subOptions: ["MULTIPLE DOOR OF SAME ADDRESS", "NO EXACT CONFIRMATION IF AP STAY OR NOT"]
            },
            {
                id: "NEGATIVE AREA",
                title: "NEGATIVE AREA",
                subOptions: ["COMMUNITY DOMINATED AREA", "SLUM LOCALITY", "AREA LISTED BY BANK AS NEGATIVE", "VILLAGE LOCALITY"]
            },
            {
                id: "NEGATIVE PROFILE",
                title: "NEGATIVE PROFILE",
                subOptions: ["POLITICAL LINK", "POLICE LINK", "ADVOCATE", "PROPERTY DEALER"]
            },
            {
                id: "INCOMPLETE ADDRESS",
                title: "INCOMPLETE ADDRESS",
                subOptions: ["REQUIRED BLOCK", "SECTOR OR SUBLOCALITY", "HOUSE NUMBER", "GALI NUMBER"]
            },
            {
                id: "ADDRESS NOT TRACEABLE",
                title: "ADDRESS NOT TRACEABLE",
                subOptions: ["VILLAGE LOCALITY REQUIRED", "HOUSE OWNER NAME", "HUSBAND/FATHER NAME", "HOUSE NUMBER NOT IN SEQUENCE"]
            },
            {
                id: "POOR SET UP",
                title: "POOR SET UP",
                subOptions: ["HOUSE NUMBER NOT IN SEQUENCE", "LOW STANDARD OF LIVING", "POOR EXTERIOR CONDITION"]
            },
            {
                id: "DOESN'T STAY",
                title: "DOESN'T STAY",
                subOptions: ["RELATIVE ADDRESS", "FRIEND ADDRESS", "GIVEN OFFICE ADDRESS AS RESIDENCE", "ENTRY RESTRICTED WITHOUT APPROVAL GATED SOCIETY"]
            },
            { id: "DOOR LOCKED", title: "DOOR LOCKED" },
            { id: "NO SUCH PERSON", title: "NO SUCH PERSON" },
            { id: "APPLICANT SHIFTED", title: "APPLICANT SHIFTED" },
            { id: "TEMPORARY RESIDENCE", title: "TEMPORARY RESIDENCE" },
            { id: "ENTRY RESTRICTED", title: "ENTRY RESTRICTED" },
            { id: "DOUBTFUL CPV", title: "DOUBTFUL CPV" },
            { id: "ADDRESS CORRECTION", title: "ADDRESS CORRECTION" },
            { id: "WRONG ADDRESS", title: "WRONG ADDRESS" },
            { id: "REFUSE FOR VERIFICATION", title: "REFUSE FOR VERIFICATION" },
            { id: "CANCEL THE LOAN", title: "CANCEL THE LOAN" },
            { id: "RELATIVES HOUSE", title: "RELATIVES HOUSE" },
            { id: "OTHERS", title: "OTHERS" }
        ],
        Office: [
            {
                id: "NO OFFICE SETUP",
                title: "NO OFFICE SETUP",
                subOptions: ["REGISTER ADDRESS", "RESIDENCE ADDRESS GIVEN AS OFFICE"]
            },
            {
                id: "INCOMPLETE ADDRESS",
                title: "INCOMPLETE ADDRESS",
                subOptions: ["REQUIRED BLOCK", "SECTOR OR SUBLOCALITY", "HOUSE NUMBER", "GALI NUMBER"]
            },
            {
                id: "ADDRESS NOT TRACEABLE",
                title: "ADDRESS NOT TRACEABLE",
                subOptions: ["VILLAGE LOCALITY REQUIRED", "HOUSE OWNER NAME", "HUSBAND/FATHER NAME", "HOUSE NUMBER NOT IN SEQUENCE"]
            },
            {
                id: "TEMPORARY SET UP",
                title: "TEMPORARY SET UP",
                subOptions: ["ROAD SIDE VENDOR", "LABOUR CONTRACTOR AT THE GIVEN ADDRESS", "TEEN SHED SET UP / KIOSK ON ROAD"]
            },
            {
                id: "NEGATIVE AREA",
                title: "NEGATIVE AREA",
                subOptions: ["COMMUNITY DOMINATED AREA", "SLUM LOCALITY", "AREA LISTED BY BANK AS NEGATIVE", "VILLAGE LOCALITY"]
            },
            {
                id: "NEGATIVE PROFILE",
                title: "NEGATIVE PROFILE",
                subOptions: ["POLITICAL LINK", "POLICE LINK", "ADVOCATE", "PROPERTY DEALER"]
            },
            { id: "OFFICE SHIFTED", title: "OFFICE SHIFTED" },
            { id: "LEFT THE JOB", title: "LEFT THE JOB" },
            { id: "NO CONFIRMATION", title: "NO CONFIRMATION" },
            { id: "ENTRY RESTRICTED", title: "ENTRY RESTRICTED" },
            { id: "NO ACTIVITY", title: "NO ACTIVITY" },
            { id: "NO/LOW ACTIVITY", title: "NO/LOW ACTIVITY" },
            { id: "NO/LOW STOCK", title: "NO/LOW STOCK" },
            { id: "NAME BOARD MISMATCH", title: "NAME BOARD MISMATCH" },
            { id: "REFUSE FOR VERIFICATION", title: "REFUSE FOR VERIFICATION" },
            { id: "CANCEL THE LOAN", title: "CANCEL THE LOAN" },
            { id: "ADDRESS CORRECTION", title: "ADDRESS CORRECTION" },
            { id: "WRONG ADDRESS", title: "WRONG ADDRESS" },
            { id: "PICTURES NOT ALLOWED", title: "PICTURES NOT ALLOWED" },
            { id: "REFUSE TO SHOW ACTIVITY", title: "REFUSE TO SHOW ACTIVITY" },
            { id: "SET UP INCOMPLETE", title: "SET UP INCOMPLETE" },
            { id: "OTHERS", title: "OTHERS" }
        ]
    };

    const showNegativeDropdown = taskData && (taskData.type === 'Residence' || taskData.type === 'Office') && finalisationStatus === 'Negative';

    const getNegativeOptions = () => {
        return negativeOptions[taskData.type] || [];
    };

    const handleReasonChange = (value) => {
        setFinalisationRemarks(value);
        setSubReason('');
    };

    const handleSubReasonChange = (value) => {
        setSubReason(value);
    };

    const getSelectedOption = () => {
        return getNegativeOptions().find(option => option.id === finalisationRemarks);
    };

    const hasSubOptions = () => {
        const selectedOption = getSelectedOption();
        return selectedOption && selectedOption.subOptions;
    };

    return (
        <div
            className='w-full h-full'
            onKeyDown={(e) => keyHandler(e)}
            tabIndex={0}
        >
            <div className='flex flex-row justify-between items-center'>
                {type !== 'Collections' ? (
                    <>
                        {userInfo.role.taskSummary === true ? (
                            <h1 className='text-2xl font-semibold'>
                                {taskData &&
                                    `${taskData.taskID.toString()} (${taskData.status} [${taskData.visitTat
                                    } hrs] - ${taskData.finalisationStatus} [${taskData.finalisationTat
                                    } hrs])`}
                            </h1>
                        ) : (
                            <h1 className='text-2xl font-semibold'>
                                {taskData && `${taskData.taskID.toString()} (${taskData.status})`}
                            </h1>
                        )}
                    </>
                ) : (
                    <h1 className='text-2xl font-semibold'>
                        {taskData && `${taskData.taskID.toString()}`}
                    </h1>
                )}
                {type !== 'Collections' && (
                    <div className='flex flex-row gap-5'>
                        {tasksUpdateOption && (
                            <>
                                {(taskStatus === "Finalisation Pending" || taskStatus === "Visit Pending" || taskStatus === "In Progress") && (
                                    <Button
                                        text={<BlockOutlined />}
                                        custom='py-2 bg-yellow-500 hover:bg-yellow-600 text-black'
                                        onClick={() => dispatch(
                                            (id))}
                                        disabled={loadingWaiveTask}
                                    />
                                )}
                            </>
                        )}
                        {calling && (
                            <Button
                                text={<Call />}
                                custom='py-2 bg-green-500 hover:bg-green-600'
                                onClick={() => setCallingModal(true)}
                            />
                        )}
                        {(taskStatus === "Finalisation Pending" || taskStatus === "Completed" || taskStatus === "Job Done" || taskStatus === "Sent To Bank") && (
                            <Button
                                text={<Collections />}
                                custom="py-2 bg-purple-500 hover:bg-purple-600"
                                onClick={() => setPopup(true)}
                            />
                        )}

                        {/* Add the Not Fired button here - always visible */}
                        {(taskStatus === "Finalisation Pending" || taskStatus === "Visit Pending") && (
                            <Button
                                text="Not Fired"
                                custom="py-2 bg-orange-500 hover:bg-orange-600"
                                onClick={handleNotFired}
                            />
                        )}
                        {(taskStatus === "Unassigned" || taskStatus === "Visit Pending") && (
                            <Button
                                text="Mapping"
                                custom="py-2 bg-blue-500 hover:bg-blue-600"
                                onClick={handleMapping}
                            />
                        )}
                        {(taskStatus === "Completed" || taskStatus === "Job Done" || taskStatus === "Sent To Bank") && (isWithinThreeMonths() || userInfo?.role?.name === "Super Admin") && (
                            <Button
                                text={<PictureAsPdfOutlined />}
                                custom='py-2 bg-red-500 hover:bg-red-600'
                                onClick={printPDF}
                            />
                        )}
                        <Button
                            text={<PictureAsPdfOutlined />}
                            custom='py-2 bg-blue-500 hover:bg-blue-600'
                            onClick={printVendorPDF}
                        />
                    </div>
                )}
            </div>
            <div className='bg-white shadow-md rounded px-8 py-4 my-4'>
                <h3 className='font-semibold text-md'>Allocation Details</h3>
                <div className='flex flex-wrap w-full py-4 gap-5 items-center'>
                    <div className='flex flex-col'>
                        <label className='text-sm mb-2' htmlFor='name'>
                            Name
                        </label>
                        <Input
                            placeholder='Name'
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            disabled={
                                !tasksUpdateOption ||
                                taskStatus === 'Finalisation Pending' ||
                                taskStatus === '`Completed`' || taskStatus === 'In Progress'
                            }
                        />
                    </div>
                    <div className='flex flex-col'>
                        <label className='text-sm mb-2' htmlFor='name'>
                            Mobile *
                        </label>
                        <Input
                            placeholder='Mobile'
                            value={mobile}
                            onChange={(e) => setMobile(e.target.value)}
                            disabled={
                                !tasksUpdateOption ||
                                taskStatus === 'Finalisation Pending' ||
                                taskStatus === 'Completed' || taskStatus === 'In Progress'
                            }
                        />
                    </div>
                    <div className='flex flex-col'>
                        <label className='text-sm mb-2' htmlFor='name'>
                            Branch
                        </label>
                        <Input
                            placeholder='Branch'
                            value={branch}
                            onChange={(e) => setBranch(e.target.value)}
                            disabled={
                                !tasksUpdateOption ||
                                taskStatus === 'Finalisation Pending' ||
                                taskStatus === 'Completed' || taskStatus === 'In Progress'
                            }
                        />
                    </div>
                    <div className='flex flex-col'>
                        <label className='text-sm mb-2' htmlFor='name'>
                            Finance Amount
                        </label>
                        <Input
                            placeholder='Finance Amount'
                            value={financeAmount}
                            onChange={(e) => setFinanceAmount(e.target.value)}
                            disabled={
                                !tasksUpdateOption ||
                                taskStatus === 'Finalisation Pending' ||
                                taskStatus === 'Completed' || taskStatus === 'In Progress'
                            }
                        />
                    </div>
                    <div className='flex flex-col'>
                        <label className='text-sm mb-2' htmlFor='name'>
                            Loan Number
                        </label>
                        <Input
                            placeholder='Loan Number'
                            value={loanNumber}
                            onChange={(e) => setLoanNumber(e.target.value)}
                            disabled={
                                !tasksUpdateOption ||
                                taskStatus === 'Finalisation Pending' ||
                                taskStatus === 'Completed' || taskStatus === 'In Progress'
                            }
                        />
                    </div>
                    <div className='flex flex-col'>
                        <label className='text-sm mb-2' htmlFor='name'>
                            Loan Type
                        </label>
                        <Input
                            placeholder='Loan Type'
                            value={loanType}
                            onChange={(e) => setLoanType(e.target.value)}
                            disabled={
                                !tasksUpdateOption ||
                                taskStatus === 'Finalisation Pending' ||
                                taskStatus === 'Completed' || taskStatus === 'In Progress'
                            }
                        />
                    </div>
                    <div className='flex flex-col'>
                        <label className='text-sm mb-2' htmlFor='name'>
                            Receipt Date
                        </label>
                        <Input
                            placeholder='Receipt Date'
                            value={receiptDate}
                            onChange={(e) => setReceiptDate(e.target.value)}
                            disabled={
                                !tasksUpdateOption ||
                                taskStatus === 'Finalisation Pending' ||
                                taskStatus === 'Completed' || taskStatus === 'In Progress'
                            }
                        />
                    </div>
                    {addAllocationOption && (
                        <div className='flex flex-col'>
                            <label className='text-sm mb-2' htmlFor='name'>
                                Assigned To *
                            </label>
                            <Select

                                name='User *'
                                value={assignedTo}
                                onChange={(e) => setAssignedTo(e.target.value)}
                                options={usersOptions}
                                disabled={
                                    !tasksUpdateOption ||
                                    taskStatus === 'Finalisation Pending' ||
                                    taskStatus === 'Completed' || taskStatus === 'In Progress'
                                }
                            />
                        </div>
                    )}
                    <div className='flex flex-col'>
                        <label className='text-sm mb-2' htmlFor='name'>
                            Customer *
                        </label>
                        <Select

                            name='Customer *'
                            value={customer}
                            onChange={(e) => setCustomer(e.target.value)}
                            options={customerOptions}
                            disabled={
                                !tasksUpdateOption ||
                                taskStatus === 'Finalisation Pending' ||
                                taskStatus === 'Completed' || taskStatus === 'In Progress'
                            }
                        />
                    </div>
                    <div className='flex flex-col'>
                        <label className='text-sm mb-2' htmlFor='name'>
                            Case Type *
                        </label>
                        <Select
                            name='Case Type *'
                            value={type}
                            onChange={(e) => setType(e.target.value)}
                            options={[
                                { id: 'Residence', title: 'Residence' },
                                { id: 'Office', title: 'Office' },
                                { id: 'Short', title: 'Short' },
                            ]}
                            disabled={
                                !tasksUpdateOption ||
                                taskStatus === 'Finalisation Pending' ||
                                taskStatus === 'Completed' || taskStatus === 'In Progress'
                            }
                        />
                    </div>
                    <div className='flex flex-col w-full'>
                        <label className='text-sm mb-2' htmlFor='name'>
                            Address *
                        </label>
                        <Input
                            placeholder='Address'
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                            disabled={
                                !tasksUpdateOption ||
                                taskStatus === 'Finalisation Pending' ||
                                taskStatus === 'Completed' || taskStatus === 'In Progress'
                            }
                        />
                    </div>
                    <div className='flex flex-col w-full'>
                        <label className='text-sm mb-2' htmlFor='name'>
                            Allocation Remarks
                        </label>
                        <textarea
                            className='block appearance-none w-full bg-gray-100 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 text-sm'
                            placeholder='Allocation Remarks'
                            rows={4}
                            onChange={(e) => setAllocationRemarks(e.target.value)}
                            disabled={
                                !tasksUpdateOption ||
                                taskStatus === 'Finalisation Pending' ||
                                taskStatus === 'Completed' || taskStatus === 'In Progress'
                            }
                            value={allocationRemarks}
                        >
                            {allocationRemarks}
                        </textarea>
                    </div>
                    <p className='text-sm w-full'>
                        All the fields with * are mandatory
                    </p>
                    {taskStatus !== 'Finalisation Pending' &&
                        taskStatus !== 'Completed' && taskStatus !== 'In Progress' && (
                            <Button
                                text='Update'
                                custom='py-2'
                                onClick={updateTaskAllocation}
                                disabled={!tasksUpdateOption || loadingUpdateTaskByIDInfo}
                            />
                        )}
                </div>
            </div>
            {taskData &&
                (taskData.status === 'Finalisation Pending' ||
                    taskData.status === 'Completed' || taskStatus === "Job Done" || taskStatus === "Sent To Bank"
                ) && userInfo.role.taskSummary === true && (
                    <div className='bg-white shadow-md rounded px-8 py-4 w-full'>
                        <h3 className='font-semibold text-md'>Summary</h3>
                        <div className='flex flex-wrap w-full py-4 gap-5 items-center'>
                            <div className='flex flex-col w-full mb-2'>
                                <h3 className='font-semibold text-sm underline mb-2'>
                                    Allocation Summary
                                </h3>
                                <div className='flex flex-row'>
                                    <p className='text-sm mr-2'>Allocation done by:</p>
                                    <p className='text-sm font-semibold'>{assignedByName}</p>
                                </div>
                                <div className='flex flex-row'>
                                    <p className='text-sm mr-2'>Allocation address: </p>
                                    <p className='text-sm font-semibold'>{address}</p>
                                </div>
                                <div className='flex flex-row'>
                                    <p className='text-sm mr-2'>Allocation address Lat/Lng: </p>
                                    <p className='text-sm font-semibold'>
                                        {taskData?.addressLocation?.latitude && taskData?.addressLocation?.longitude ? (
                                            `${taskData.addressLocation.latitude} ${taskData.addressLocation.longitude}`
                                        ) : (
                                            <span className="text-red-500">Latitude or longitude not available</span>
                                        )}
                                    </p>
                                </div>
                                <div className='flex flex-row'>
                                    <p className='text-sm mr-2'>Allocated on: </p>
                                    <p className='text-sm font-semibold'>
                                        {taskData && taskData.joinedOn}
                                    </p>
                                </div>
                            </div>
                            {taskData && taskData.calls.length > 0 && (
                                <div className='flex flex-col w-full mb-0'>
                                    <h3 className='font-semibold text-sm underline mb-2'>
                                        Calling Summary
                                    </h3>
                                    <div className='flex flex-row mb-2'>
                                        <p className='text-sm mr-2'>Total attempts:</p>
                                        <p className='text-sm font-semibold'>
                                            {taskData && taskData.calls.length}
                                        </p>
                                    </div>
                                    {taskData &&
                                        taskData.calls.map((item, index) => (
                                            <div
                                                className='flex flex-row justify-between w-full mb-4'
                                                key={index}
                                            >
                                                <div className='flex flex-col'>
                                                    <div className='flex flex-row'>
                                                        <p className='text-sm mr-2'>
                                                            Call {index + 1} status:
                                                        </p>
                                                        <p className='text-sm font-semibold'>
                                                            {item.status}
                                                        </p>
                                                    </div>
                                                    <div className='flex flex-row'>
                                                        <p className='text-sm mr-2'>
                                                            Call {index + 1} Type:
                                                        </p>
                                                        <p className='text-sm font-semibold'>
                                                            {item.type}
                                                        </p>
                                                    </div>
                                                    {item.type === 'Field' && (
                                                        <>
                                                            <div className='flex flex-row'>
                                                                <p className='text-sm mr-2'>
                                                                    Call {index + 1} address:{' '}
                                                                </p>
                                                                <p className='text-sm font-semibold'>
                                                                    {item.location.address}
                                                                </p>
                                                            </div>
                                                            <div className='flex flex-row'>
                                                                <p className='text-sm mr-2'>
                                                                    Call {index + 1} distance from allocated
                                                                    address:{' '}
                                                                </p>
                                                                <p className='text-sm font-semibold'>
                                                                    {item.location.distance} km
                                                                </p>
                                                            </div>
                                                        </>
                                                    )}
                                                    <div className='flex flex-row'>
                                                        <p className='text-sm mr-2'>
                                                            Call {index + 1} done on:{' '}
                                                        </p>
                                                        <p className='text-sm font-semibold'>
                                                            {item.calledOn}
                                                        </p>
                                                    </div>
                                                </div>
                                                {item.id && (
                                                    <audio
                                                        controls
                                                        controlsList='nodownload nofullscreen noplaybackrate'
                                                        disableRemotePlayback
                                                        disableKeyboardControls
                                                        className='my-2'
                                                        onEnded={(e) => addCallListened(item.id)}
                                                        tabindex="-1"
                                                    >
                                                        {moment().format('YYYY-MM-DD').toString() ===
                                                            item.calledOn.split(' ')[0] ? (
                                                            <source
                                                                src={`https://crm2.cloud-connect.in/node2/recordings/0/100270/auto_rec/${item.id}.wav`}
                                                                type='audio/wav'
                                                            />
                                                        ) : (
                                                            <source
                                                                src={`https://hrms.mser.co.in/mp3/${item.id}.mp3`}
                                                                type='audio/mp3'
                                                            />
                                                        )}
                                                    </audio>
                                                )}
                                            </div>
                                        ))}
                                </div>
                            )}
                            <div className='flex flex-col w-full'>
                                <h3 className='font-semibold text-sm underline mb-2'>
                                    Field Visit Summary
                                </h3>
                                <div className='flex flex-row'>
                                    <p className='text-sm mr-2'>Done by:</p>
                                    <p className='text-sm font-semibold'>{assignedToName}</p>
                                </div>
                                {/* <div className='flex flex-row'>
                                    <p className='text-sm mr-2'>Performed address: </p>
                                    <p className='text-sm font-semibold'>
                                        <p className='text-sm font-semibold'>{address}</p>
                                    </p>
                                </div> */}
                                <div className='flex flex-row'>
                                    <p className='text-sm mr-2'>Performed address:</p>
                                    <p className='text-sm font-semibold'>
                                        {taskData && taskData.visitLocation.address}
                                    </p>
                                </div>
                                <div className='flex flex-row'>
                                    <p className='text-sm mr-2'>Performed address Lat/Lng: </p>
                                    <p className='text-sm font-semibold'>
                                        {taskData && taskData.visitLocation.latitude}{' '}
                                        {taskData && taskData.visitLocation.longitude}
                                    </p>
                                </div>
                                <div className='flex flex-row'>
                                    <p className='text-sm mr-2'>
                                        Distance from allocated address:{' '}
                                    </p>
                                    <p className='text-sm font-semibold'>
                                        {taskData && taskData.visitLocation.distance} km
                                    </p>
                                </div>
                                <div className='flex flex-row'>
                                    <p className='text-sm mr-2'>Visit started on: </p>
                                    <p className='text-sm font-semibold'>
                                        <p className='text-sm font-semibold'>
                                            {taskData && taskData.visitStartedOn}
                                        </p>
                                    </p>
                                </div>
                                <div className='flex flex-row'>
                                    <p className='text-sm mr-2'>Visit finished on: </p>
                                    <p className='text-sm font-semibold'>
                                        <p className='text-sm font-semibold'>
                                            {taskData && taskData.visitFinishedOn}
                                        </p>
                                    </p>
                                </div>
                            </div>
                            {taskStatus === 'Completed' && (
                                <div className='flex flex-col w-full'>
                                    <h3 className='font-semibold text-sm underline mb-2'>
                                        Finalisation Summary
                                    </h3>
                                    <div className='flex flex-row'>
                                        <p className='text-sm mr-2'>Finalisation done by:</p>
                                        <p className='text-sm font-semibold'>{finalisedByName}</p>
                                    </div>
                                    <div className='flex flex-row'>
                                        <p className='text-sm mr-2'>Finalised on: </p>
                                        <p className='text-sm font-semibold'>{finalisedOn}</p>
                                    </div>
                                </div>
                            )}
                            {!showSummary && type !== 'Colection' && (
                                <div>
                                    <Button
                                        text='Proceed'
                                        custom='py-2'
                                        onClick={() => setConfirmModal(true)}
                                        disabled={callsToListen !== callsListened.length}
                                    />
                                    {userInfo.role.settings === true && (
                                        <Button
                                            text='Bypass Call'
                                            custom='py-2 ml-2'
                                            onClick={() => setCallsToListen(callsListened.length)}
                                            disabled={callsToListen === callsListened.length}
                                        />
                                    )}
                                </div>
                            )}
                            {taskData.taskHistory.length > 0 && (
                                <div className='bg-white shadow-md rounded px-8 py-4 my-4 w-full'>
                                    <h3 className='font-semibold text-md'>Task History</h3>
                                    {taskData.taskHistory.map((item, index) => (
                                        <div className='flex flex-col mt-5'>
                                            <p className='text-sm'>
                                                {index + 1}. {item.visitedOn}
                                            </p>
                                            <p className='text-sm ml-3 mt-2'>Status: {item.status}</p>
                                            <p className='text-sm ml-3'>Person Met: {item.personMet}</p>
                                            <p className='text-sm ml-3'>Feedback: {item.notes}</p>
                                        </div>
                                    ))}
                                </div>
                            )}
                            {showSummary && type !== 'Collections' && (
                                <>
                                    <div className='bg-white shadow-md rounded px-8 py-4 my-4 w-full'>
                                        <h3 className='font-semibold text-md'>Form Details</h3>
                                        <div className='flex flex-wrap md:flex-row justify-between gap-5 py-4 w-full'>
                                            <div className='flex flex-col'>
                                                <label className='text-sm mb-2' htmlFor='name'>
                                                    Address Found *
                                                </label>
                                                <Select
                                                    name='Address Found'
                                                    value={taskAddressFound}
                                                    onChange={(e) => setTaskAddressFound(e.target.value)}
                                                    options={[
                                                        { id: 'Yes', title: 'Yes' },
                                                        { id: 'No', title: 'No' },
                                                        { id: 'Short Form', title: 'Short Form' },
                                                    ]}
                                                    disabled={!taskSummaryOption}
                                                />
                                            </div>
                                            {showTaskInfoStatus && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        Status *
                                                    </label>
                                                    <Select
                                                        name='Status'
                                                        value={taskInfoStatus}
                                                        onChange={(e) => setTaskInfoStatus(e.target.value)}
                                                        options={[
                                                            { id: 'Open Form', title: 'Open Form' },
                                                            { id: 'Shifted', title: 'Shifted' },
                                                            { id: 'No Such Person', title: 'No Such Person' },
                                                            { id: 'Lock', title: 'Lock' },
                                                            {
                                                                id: 'Refused To Provide Details',
                                                                title: 'Refused To Provide Details',
                                                            },
                                                            {
                                                                id: 'Entry Not Permitted',
                                                                title: 'Entry Not Permitted',
                                                            },
                                                            { id: 'Cancel', title: 'Cancel' },
                                                        ]}
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {showCustomerAvailability && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        Customer Availability
                                                    </label>
                                                    <Select
                                                        name='Customer Availability'
                                                        value={customerAvailability}
                                                        onChange={(e) => setCustomerAvailability(e.target.value)}
                                                        options={[
                                                            { id: 'Yes', title: 'Yes' },
                                                            { id: 'No', title: 'No' },
                                                            { id: 'N/A', title: 'N/A' },
                                                        ]}
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {showShopAvailability && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        Shop / Establishment Availability
                                                    </label>
                                                    <Select
                                                        name='Shop / Establishment Availability'
                                                        value={shopAvailability}
                                                        onChange={(e) => setShopAvailability(e.target.value)}
                                                        options={[
                                                            { id: 'Yes', title: 'Yes' },
                                                            { id: 'No', title: 'No' },
                                                            { id: 'N/A', title: 'N/A' },
                                                        ]}
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {showSignboardAvailabilty && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        Sign-board of the shop available
                                                    </label>
                                                    <Select
                                                        name='Sign-board of the shop available'
                                                        value={signboardAvailabilty}
                                                        onChange={(e) => setSignboardAvailabilty(e.target.value)}
                                                        options={[
                                                            { id: 'Yes', title: 'Yes' },
                                                            { id: 'No', title: 'No' },
                                                            { id: 'N/A', title: 'N/A' },
                                                        ]}
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {showNeighbourRemarks && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        Neighbour Checks Remarks
                                                    </label>
                                                    <Input
                                                        placeholder='Neighbour Checks Remarks'
                                                        value={neighbourRemarks}
                                                        onChange={(e) =>
                                                            setNeighbourRemarks(e.target.value)
                                                        }
                                                        disabled={!tasksUpdateOption}
                                                    />
                                                </div>
                                            )}
                                            {showTaskFirstNeighbourName && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        1st Neighbour Name
                                                    </label>
                                                    <Input
                                                        placeholder='1st Neighbour Name'
                                                        value={taskFirstNeighbourName}
                                                        onChange={(e) =>
                                                            setTaskFirstNeighbourName(e.target.value)
                                                        }
                                                        disabled={!tasksUpdateOption}
                                                    />
                                                </div>
                                            )}
                                            {showTaskFirstNeighbourAge && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        1st Neighbour Age (approx.)
                                                    </label>
                                                    <Input
                                                        placeholder='1st Neighbour Age (approx.)'
                                                        value={taskFirstNeighbourAge}
                                                        onChange={(e) => setTaskFirstNeighbourAge(e.target.value)}
                                                        type='number'
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {showTaskFirstNeighbourAddress && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        1st Neighbour Address
                                                    </label>
                                                    <Input
                                                        placeholder='1st Neighbour Address'
                                                        value={taskFirstNeighbourAddress}
                                                        onChange={(e) =>
                                                            setTaskFirstNeighbourAddress(e.target.value)
                                                        }
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {showTaskFirstNeighbourFeedback && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        1st Neighbour Feedback
                                                    </label>
                                                    <Input
                                                        placeholder='1st Neighbour Feedback'
                                                        value={taskFirstNeighbourFeedback}
                                                        onChange={(e) =>
                                                            setTaskFirstNeighbourFeedback(e.target.value)
                                                        }
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {showTaskSecondNeighbourName && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        2nd Neighbour Name
                                                    </label>
                                                    <Input
                                                        placeholder='2nd Neighbour Name'
                                                        value={taskSecondNeighbourName}
                                                        onChange={(e) =>
                                                            setTaskSecondNeighbourName(e.target.value)
                                                        }
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {showTaskSecondNeighbourAge && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        2nd Neighbour Age (approx.)
                                                    </label>
                                                    <Input
                                                        placeholder='2nd Neighbour Age (approx.)'
                                                        value={taskSecondNeighbourAge}
                                                        onChange={(e) =>
                                                            setTaskSecondNeighbourAge(e.target.value)
                                                        }
                                                        type='number'
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {showTaskSecondNeighbourAddress && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        2nd Neighbour Address
                                                    </label>
                                                    <Input
                                                        placeholder='2nd Neighbour Address'
                                                        value={taskSecondNeighbourAddress}
                                                        onChange={(e) =>
                                                            setTaskSecondNeighbourAddress(e.target.value)
                                                        }
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {showTaskSecondNeighbourFeedback && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        2nd Neighbour Feedback
                                                    </label>
                                                    <Input
                                                        placeholder='2nd Neighbour Feedback'
                                                        value={taskSecondNeighbourFeedback}
                                                        onChange={(e) =>
                                                            setTaskSecondNeighbourFeedback(e.target.value)
                                                        }
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {showTaskPersonMet && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        Name of Person Met
                                                    </label>
                                                    <Input
                                                        placeholder='Name of Person Met'
                                                        value={taskPersonMet}
                                                        onChange={(e) => setTaskPersonMet(e.target.value)}
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {taskData &&
                                                taskData.type === 'Residence' &&
                                                showTaskRelationshipWithApplicant && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Relationship with Applicant
                                                        </label>
                                                        <Select
                                                            name='Relationship with Applicant *'
                                                            value={taskRelationshipWithApplicant}
                                                            onChange={(e) =>
                                                                setTaskRelationshipWithApplicant(e.target.value)
                                                            }
                                                            options={[
                                                                { id: 'Self', title: 'Self' },
                                                                { id: 'Father', title: 'Father' },
                                                                { id: 'Mother', title: 'Mother' },
                                                                { id: 'Brother', title: 'Brother' },
                                                                { id: 'Sister', title: 'Sister' },
                                                                { id: 'Cousin', title: 'Cousin' },
                                                                { id: 'Spouse', title: 'Spouse' },
                                                                { id: 'Son', title: 'Son' },
                                                                { id: 'Daughter', title: 'Daughter' },
                                                                { id: 'Others', title: 'Others' },
                                                            ]}
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Residence' &&
                                                showTaskRelationshipWithApplicantDetails && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Relationship with Applicant Details
                                                        </label>
                                                        <Input
                                                            placeholder='Relationship with Applicant Details'
                                                            value={taskRelationshipWithApplicantDetails}
                                                            onChange={(e) =>
                                                                setTaskRelationshipWithApplicantDetails(
                                                                    e.target.value
                                                                )
                                                            }
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Office' &&
                                                showTaskDesignationOfPersonMet && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Designation of Person Met
                                                        </label>
                                                        <Input
                                                            placeholder='Designation of Person Met'
                                                            value={taskDesignationOfPersonMet}
                                                            onChange={(e) =>
                                                                setTaskDesignationOfPersonMet(e.target.value)
                                                            }
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {showTaskApplicantAge && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        Applicant Age
                                                    </label>
                                                    <Input
                                                        placeholder='Applicant Age'
                                                        value={taskApplicantAge}
                                                        onChange={(e) => setTaskApplicantAge(e.target.value)}
                                                        type='number'
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {showTaskAddressChange && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        Address Change
                                                    </label>
                                                    <Input
                                                        placeholder='Address Change'
                                                        value={taskAddressChange}
                                                        onChange={(e) => setTaskAddressChange(e.target.value)}
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {showTaskEducationQualification && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        Education Qualification
                                                    </label>
                                                    <Select
                                                        name='Education Qualification'
                                                        value={taskEducationQualification}
                                                        onChange={(e) =>
                                                            setTaskEducationQualification(e.target.value)
                                                        }
                                                        options={[
                                                            { id: 'Metric', title: 'Metric' },
                                                            { id: 'Graduate', title: 'Graduate' },
                                                            { id: 'Post Graduate', title: 'Post Graduate' },
                                                            { id: 'Professional', title: 'Professional' },
                                                            { id: 'Others', title: 'Others' },
                                                        ]}
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {showTaskIDSeen && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        ID Seen
                                                    </label>
                                                    <Select
                                                        name='ID Seen'
                                                        value={taskIDSeen}
                                                        onChange={(e) => setTaskIDSeen(e.target.value)}
                                                        options={[
                                                            { id: 'Yes', title: 'Yes' },
                                                            { id: 'No', title: 'No' },
                                                        ]}
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {showTaskIDProofType && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        ID Proof Type
                                                    </label>
                                                    <Input
                                                        placeholder='ID Proof Type'
                                                        value={taskIDProofType}
                                                        onChange={(e) => setTaskIDProofType(e.target.value)}
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {taskData &&
                                                taskData.type === 'Office' &&
                                                showTaskNameBoardSeen && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Name Board Seen
                                                        </label>
                                                        <Select
                                                            name='Name Board Seen'
                                                            value={taskNameBoardSeen}
                                                            onChange={(e) => setTaskNameBoardSeen(e.target.value)}
                                                            options={[
                                                                { id: 'Yes', title: 'Yes' },
                                                                { id: 'No', title: 'No' },
                                                            ]}
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Office' &&
                                                showTaskNameMentionedOnNameBoard && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Name Mentioned on Name Board
                                                        </label>
                                                        <Input
                                                            placeholder='ID Proof Type'
                                                            value={taskNameMentionedOnNameBoard}
                                                            onChange={(e) =>
                                                                setTaskNameMentionedOnNameBoard(e.target.value)
                                                            }
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Residence' &&
                                                showTaskAddressProofSeen && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Address Proof Seen
                                                        </label>
                                                        <Select
                                                            name='Address Proof Seen'
                                                            value={taskAddressProofSeen}
                                                            onChange={(e) =>
                                                                setTaskAddressProofSeen(e.target.value)
                                                            }
                                                            options={[
                                                                { id: 'Yes', title: 'Yes' },
                                                                { id: 'No', title: 'No' },
                                                                {
                                                                    id: 'Same as ID Proof',
                                                                    title: 'Same as ID Proof',
                                                                },
                                                            ]}
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Residence' &&
                                                showTaskAddressProofType && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Address Proof Type
                                                        </label>
                                                        <Input
                                                            placeholder='Address Proof Type'
                                                            value={taskAddressProofType}
                                                            onChange={(e) =>
                                                                setTaskAddressProofType(e.target.value)
                                                            }
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Residence' &&
                                                showTaskMaritalStatus && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Marital Status
                                                        </label>
                                                        <Select
                                                            name='Marital Status'
                                                            value={taskMaritalStatus}
                                                            onChange={(e) => setTaskMaritalStatus(e.target.value)}
                                                            options={[
                                                                { id: 'Single', title: 'Single' },
                                                                { id: 'Married', title: 'Married' },
                                                                { id: 'Divorced', title: 'Divorced' },
                                                                { id: 'Widowed', title: 'Widowed' },
                                                            ]}
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Residence' &&
                                                showTaskNumberOfFamilyMembers && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Number of Family Members
                                                        </label>
                                                        <Input
                                                            placeholder='Number of Family Members'
                                                            value={taskNumberOfFamilyMembers}
                                                            onChange={(e) =>
                                                                setTaskNumberOfFamilyMembers(e.target.value)
                                                            }
                                                            type='number'
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Residence' &&
                                                showTaskNumberOfDependents && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Number of Working
                                                        </label>
                                                        <Input
                                                            placeholder='Number of Working'
                                                            value={taskNumberOfDependents}
                                                            onChange={(e) =>
                                                                setTaskNumberOfDependents(e.target.value)
                                                            }
                                                            type='number'
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Residence' &&
                                                showTaskTypeOfFamily && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Type of Family
                                                        </label>
                                                        <Select
                                                            name='Type of Family'
                                                            value={taskTypeOfFamily}
                                                            onChange={(e) => setTaskTypeOfFamily(e.target.value)}
                                                            options={[
                                                                { id: 'Nuclear Family', title: 'Nuclear Family' },
                                                                { id: 'Joint Family', title: 'Joint Family' },
                                                                { id: 'Bachelor', title: 'Bachelor' },
                                                                { id: 'Paying Guest', title: 'Paying Guest' },
                                                                { id: 'Others', title: 'Others' },
                                                            ]}
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}

                                            {taskData &&
                                                taskData.type === 'Residence' &&
                                                showTaskOccupation && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Occupation
                                                        </label>
                                                        <Select
                                                            name='Occupation'
                                                            value={taskOccupation}
                                                            onChange={(e) => setTaskOccupation(e.target.value)}
                                                            options={[
                                                                { id: 'Private Job', title: 'Private Job' },
                                                                { id: 'Government Job', title: 'Government Job' },
                                                                { id: 'Self Employed', title: 'Self Employed' },
                                                                { id: 'Student', title: 'Student' },
                                                                { id: 'House Wife', title: 'House Wife' },
                                                                { id: 'Others', title: 'Others' },
                                                            ]}
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Residence' &&
                                                showTaskOccupationDetails && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Occupation Details
                                                        </label>
                                                        <Input
                                                            placeholder='Occupation Details'
                                                            value={taskOccupationDetails}
                                                            onChange={(e) =>
                                                                setTaskOccupationDetails(e.target.value)
                                                            }
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Residence' &&
                                                showTaskResidenceOwnedBy && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Residence Owned By
                                                        </label>
                                                        <Select
                                                            name='Residence Owned By'
                                                            value={taskResidenceOwnedBy}
                                                            onChange={(e) =>
                                                                setTaskResidenceOwnedBy(e.target.value)
                                                            }
                                                            options={[
                                                                { id: 'Self', title: 'Self' },
                                                                {
                                                                    id: 'Owned By Parents',
                                                                    title: 'Owned By Parents',
                                                                },
                                                                { id: 'Owned By Spouse', title: 'Owned By Spouse' },
                                                                { id: 'Company Alloted', title: 'Company Alloted' },
                                                                { id: 'Rented', title: 'Rented' },
                                                                { id: 'Others', title: 'Others' },
                                                            ]}
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Residence' &&
                                                showTaskResidenceOwnedByDetails && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Residence Owned By Details
                                                        </label>
                                                        <Input
                                                            placeholder='Residence Owned By Details'
                                                            value={taskResidenceOwnedByDetails}
                                                            onChange={(e) =>
                                                                setTaskResidenceOwnedByDetails(e.target.value)
                                                            }
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskResidenceOwnedBy === 'Rented' && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        Rent Amount
                                                    </label>
                                                    <Input
                                                        placeholder='Rent Amount'
                                                        value={taskRentAmount}
                                                        onChange={(e) => setTaskRentAmount(e.target.value)}
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {taskResidenceOwnedBy === 'Rented' && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        Landlord Name
                                                    </label>
                                                    <Input
                                                        placeholder='Landlord Name'
                                                        value={taskLandlordName}
                                                        onChange={(e) => setTaskLandlordName(e.target.value)}
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}

                                            {taskData &&
                                                taskData.type === 'Residence' &&
                                                showTaskTenureOfStay && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Tenure of Stay
                                                        </label>
                                                        <Input
                                                            placeholder='Tenure of Stay'
                                                            value={taskTenureOfStay}
                                                            onChange={(e) => setTaskTenureOfStay(e.target.value)}
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Residence' &&
                                                showTaskNamePlateSeen && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Name Plate Seen
                                                        </label>
                                                        <Select
                                                            name='Name Plate Seen'
                                                            value={taskNamePlateSeen}
                                                            onChange={(e) => setTaskNamePlateSeen(e.target.value)}
                                                            options={[
                                                                { id: 'Yes', title: 'Yes' },
                                                                { id: 'No', title: 'No' },
                                                            ]}
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Residence' &&
                                                showTaskNameMentionedOnNamePlate && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Name Mentioned on Plate
                                                        </label>
                                                        <Input
                                                            placeholder='Name Mentioned on Plate'
                                                            value={taskNameMentionedOnNamePlate}
                                                            onChange={(e) =>
                                                                setTaskNameMentionedOnNamePlate(e.target.value)
                                                            }
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {showTaskArea && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        Area (in sq ft.)
                                                    </label>
                                                    <Input
                                                        placeholder='Area (in sq ft.)'
                                                        value={taskArea}
                                                        onChange={(e) => setTaskArea(e.target.value)}
                                                        type='number'
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {taskData &&
                                                taskData.type === 'Office' &&
                                                showTaskOccupationOffice && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Occupation
                                                        </label>
                                                        <Select
                                                            name='Occupation'
                                                            value={taskOccupationOffice}
                                                            onChange={(e) =>
                                                                setTaskOccupationOffice(e.target.value)
                                                            }
                                                            options={[
                                                                { id: 'Salaried', title: 'Salaried' },
                                                                {
                                                                    id: 'Business / Self Employed',
                                                                    title: 'Business / Self Employed',
                                                                },
                                                                { id: 'Others', title: 'Others' },
                                                            ]}
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Office' &&
                                                showTaskOccupationOthers && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Occupation Details
                                                        </label>
                                                        <Input
                                                            placeholder='Occupation Details'
                                                            value={taskOccupationOthers}
                                                            onChange={(e) =>
                                                                setTaskOccupationOthers(e.target.value)
                                                            }
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Office' &&
                                                showTaskBusinessPremisesOwnedBy && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Business Premises Owned By
                                                        </label>
                                                        <Select
                                                            name='Business Premises Owned By'
                                                            value={taskBusinessPremisesOwnedBy}
                                                            onChange={(e) =>
                                                                setTaskBusinessPremisesOwnedBy(e.target.value)
                                                            }
                                                            options={[
                                                                { id: 'Self', title: 'Self' },
                                                                {
                                                                    id: 'Leased',
                                                                    title: 'Leased',
                                                                },
                                                                { id: 'Rented', title: 'Rented' },
                                                                { id: 'Others', title: 'Others' },
                                                            ]}
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData && showTaskRentAmount && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        Rent Amount
                                                    </label>
                                                    <Input
                                                        placeholder='Rent Amount'
                                                        value={taskRentAmount}
                                                        onChange={(e) => setTaskRentAmount(e.target.value)}
                                                        type='number'
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {taskData && showTaskLandloadName && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        Landlord Name
                                                    </label>
                                                    <Input
                                                        placeholder='Landlord Name'
                                                        value={taskLandlordName}
                                                        onChange={(e) => setTaskLandlordName(e.target.value)}
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {taskData &&
                                                taskData.type === 'Office' &&
                                                showTaskApplicantDesignation && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Applicant Desingation
                                                        </label>
                                                        <Input
                                                            placeholder='Applicant Desingation'
                                                            value={taskApplicantDesignation}
                                                            onChange={(e) =>
                                                                setTaskApplicantDesignation(e.target.value)
                                                            }
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Office' &&
                                                showTaskApplicantDepartment && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Applicant Department
                                                        </label>
                                                        <Input
                                                            placeholder='Applicant Department'
                                                            value={taskApplicantDepartment}
                                                            onChange={(e) =>
                                                                setTaskApplicantDepartment(e.target.value)
                                                            }
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Office' &&
                                                showTaskTypeOfOrganisation && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Type of Organisation
                                                        </label>
                                                        <Select
                                                            name='Type of Organisation'
                                                            value={taskTypeOfOrganisation}
                                                            onChange={(e) =>
                                                                setTaskTypeOfOrganisation(e.target.value)
                                                            }
                                                            options={[
                                                                {
                                                                    id: 'Proprietorship',
                                                                    title: 'Proprietorship',
                                                                },
                                                                { id: 'Partnership', title: 'Partnership' },
                                                                { id: 'Directorship', title: 'Directorship' },
                                                                {
                                                                    id: 'Public Limited',
                                                                    title: 'Public Limited',
                                                                },
                                                                { id: 'Other', title: 'Other' },
                                                            ]}
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Office' &&
                                                showTaskEntryRestricted && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Entry Restricted
                                                        </label>
                                                        <Select
                                                            name='Entry Restricted'
                                                            value={taskEntryRestricted}
                                                            onChange={(e) => setTaskEntryRestricted(e.target.value)}
                                                            options={[
                                                                {
                                                                    id: 'Yes',
                                                                    title: 'Yes',
                                                                },
                                                                { id: 'No', title: 'No' },
                                                            ]}
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Office' &&
                                                showTaskWorkingSince && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Working Since
                                                        </label>
                                                        <Input
                                                            placeholder='Working Since'
                                                            value={taskWorkingSince}
                                                            onChange={(e) => setTaskWorkingSince(e.target.value)}
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Office' &&
                                                showTaskTotalEmployees && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Total Employees
                                                        </label>
                                                        <Input
                                                            placeholder='Total Employees'
                                                            value={taskTotalEmployees}
                                                            onChange={(e) => setTaskTotalEmployees(e.target.value)}
                                                            type='number'
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Office' &&
                                                showTaskEmployeesSeen && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Employees Seen
                                                        </label>
                                                        <Input
                                                            placeholder='Employees Seen'
                                                            value={taskEmployeesSeen}
                                                            onChange={(e) => setTaskEmployeesSeen(e.target.value)}
                                                            type='number'
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Office' &&
                                                showTaskNatureOfBusiness && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Nature of Business
                                                        </label>
                                                        <Select
                                                            name='Nature of Business'
                                                            value={taskNatureOfBusiness}
                                                            onChange={(e) =>
                                                                setTaskNatureOfBusiness(e.target.value)
                                                            }
                                                            options={[
                                                                {
                                                                    id: 'Manufacturing',
                                                                    title: 'Manufacturing',
                                                                },
                                                                { id: 'Trading', title: 'Trading' },
                                                                { id: 'Services', title: 'Services' },
                                                                { id: 'Consultancy', title: 'Consultancy' },
                                                                { id: 'Others', title: 'Others' },
                                                            ]}
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Office' &&
                                                showTaskNatureOfBusinessDetails && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Nature of Business Details
                                                        </label>
                                                        <Input
                                                            placeholder='Nature of Business Details'
                                                            value={taskNatureOfBusinessDetails}
                                                            onChange={(e) =>
                                                                setTaskNatureOfBusinessDetails(e.target.value)
                                                            }
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Office' &&
                                                showTaskTypeOfOffice && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Type of Office
                                                        </label>
                                                        <Select
                                                            name='Type of Office'
                                                            value={taskTypeOfOffice}
                                                            onChange={(e) => setTaskTypeOfOffice(e.target.value)}
                                                            options={[
                                                                {
                                                                    id: 'Office Building',
                                                                    title: 'Office Building',
                                                                },
                                                                { id: 'Converted Flat', title: 'Converted Flat' },
                                                                { id: 'Shop', title: 'Shop' },
                                                                {
                                                                    id: 'Residence',
                                                                    title: 'Residence',
                                                                },
                                                                { id: 'Factory', title: 'Factory' },
                                                                { id: 'Godown', title: 'Godown' },
                                                                {
                                                                    id: 'Residence Cum Office',
                                                                    title: 'Residence Cum Office',
                                                                },
                                                                { id: 'Temporary Shed', title: 'Temporary Shed' },
                                                            ]}
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Residence' &&
                                                showTaskFloorVisited && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Floor Visited
                                                        </label>
                                                        <Select
                                                            name='Floor Visited'
                                                            value={taskFloorVisited}
                                                            onChange={(e) => setTaskFloorVisited(e.target.value)}
                                                            options={[
                                                                {
                                                                    id: 'Ground',
                                                                    title: 'Ground',
                                                                },
                                                                { id: 'Upper Ground', title: 'Upper Ground' },
                                                                { id: '1', title: '1' },
                                                                {
                                                                    id: '2',
                                                                    title: '2',
                                                                },
                                                                { id: '3', title: '3' },
                                                                { id: '4', title: '4' },
                                                                { id: '5', title: '5' },
                                                                { id: '6', title: '6' },
                                                                { id: '7', title: '7' },
                                                                { id: '8', title: '8' },
                                                                { id: '9', title: '9' },
                                                                { id: '10', title: '10' },
                                                                { id: '11', title: '11' },
                                                                { id: '12', title: '12' },
                                                                { id: '13', title: '13' },
                                                                { id: '14', title: '14' },
                                                                { id: '15', title: '15' },
                                                                { id: '16', title: '16' },
                                                                { id: '17', title: '17' },
                                                                { id: '18', title: '18' },
                                                                { id: '19', title: '19' },
                                                                { id: '20', title: '20' },
                                                                { id: '21', title: '21' },
                                                                { id: '22', title: '22' },
                                                                { id: '23', title: '23' },
                                                                { id: '24', title: '24' },
                                                                { id: '25', title: '25' },
                                                                { id: '26', title: '26' },
                                                                { id: '27', title: '27' },
                                                                { id: '28', title: '28' },
                                                                { id: '29', title: '29' },
                                                                { id: '30', title: '30' },
                                                                { id: '31', title: '31' },
                                                                { id: '32', title: '32' },
                                                                { id: '33', title: '33' },
                                                                { id: '34', title: '34' },
                                                                { id: '35', title: '35' },
                                                                { id: '36', title: '36' },
                                                                { id: '37', title: '37' },
                                                                { id: '38', title: '38' },
                                                                { id: '39', title: '39' },
                                                                { id: '40', title: '40' },
                                                            ]}
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Residence' &&
                                                showTaskTypeOfHouse && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Type of House
                                                        </label>
                                                        <Select
                                                            name='Type of House'
                                                            value={taskTypeOfHouse}
                                                            onChange={(e) => setTaskTypeOfHouse(e.target.value)}
                                                            options={[
                                                                {
                                                                    id: 'Independent House',
                                                                    title: 'Independent House',
                                                                },
                                                                { id: 'Flat', title: 'Flat' },
                                                                { id: 'Bunglow', title: 'Bunglow' },
                                                                {
                                                                    id: 'Part of Independent House',
                                                                    title: 'Part of Independent House',
                                                                },
                                                                { id: 'Simple House', title: 'Simple House' },
                                                                { id: 'Chawl', title: 'Chawl' },
                                                                { id: 'Slum', title: 'Slum' },
                                                                { id: 'Temporary Shed', title: 'Temporary Shed' },
                                                            ]}
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Residence' &&
                                                showTaskFurnishingOfTheHouse && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Furnishing of the House
                                                        </label>
                                                        <Select
                                                            name='Furnishing of the House'
                                                            value={taskFurnishingOfTheHouse}
                                                            onChange={(e) =>
                                                                setTaskFurnishingOfTheHouse(e.target.value)
                                                            }
                                                            options={[
                                                                { id: 'Excellent', title: 'Excellent' },
                                                                { id: 'Good', title: 'Good' },
                                                                { id: 'Average', title: 'Average' },
                                                                {
                                                                    id: 'Poor',
                                                                    title: 'Poor',
                                                                },
                                                                {
                                                                    id: 'Door Step Verification',
                                                                    title: 'Door Step Verification',
                                                                },
                                                            ]}
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}

                                            {taskData &&
                                                taskData.type === 'Residence' &&
                                                showTaskAssetsSeen && (
                                                    <div className='flex flex-wrap md:flex-row justify-between py-2 gap-2 w-full'>
                                                        <div className='flex flex-row items-center'>
                                                            <label class='text-gray-500 font-bold'>
                                                                <input
                                                                    class='mr-2 leading-tight'
                                                                    type='checkbox'
                                                                    onChange={(e) =>
                                                                        e.target.checked === true
                                                                            ? setTaskTelevision(true)
                                                                            : setTaskTelevision(false)
                                                                    }
                                                                    checked={taskTelevision === true ? true : false}
                                                                />
                                                                <span class='text-sm'>Television</span>
                                                            </label>
                                                        </div>
                                                        <div className='flex flex-row items-center'>
                                                            <label class='text-gray-500 font-bold'>
                                                                <input
                                                                    class='mr-2 leading-tight'
                                                                    type='checkbox'
                                                                    onChange={(e) =>
                                                                        e.target.checked === true
                                                                            ? setTaskLaptop(true)
                                                                            : setTaskLaptop(false)
                                                                    }
                                                                    checked={taskLaptop === true ? true : false}
                                                                />
                                                                <span class='text-sm'>Laptop</span>
                                                            </label>
                                                        </div>
                                                        <div className='flex flex-row items-center'>
                                                            <label class='text-gray-500 font-bold'>
                                                                <input
                                                                    class='mr-2 leading-tight'
                                                                    type='checkbox'
                                                                    onChange={(e) =>
                                                                        e.target.checked === true
                                                                            ? setTaskRefrigerator(true)
                                                                            : setTaskRefrigerator(false)
                                                                    }
                                                                    checked={taskRefrigerator === true ? true : false}
                                                                />
                                                                <span class='text-sm'>Refrigerator</span>
                                                            </label>
                                                        </div>
                                                        <div className='flex flex-row items-center'>
                                                            <label class='text-gray-500 font-bold'>
                                                                <input
                                                                    class='mr-2 leading-tight'
                                                                    type='checkbox'
                                                                    onChange={(e) =>
                                                                        e.target.checked === true
                                                                            ? setTaskComputer(true)
                                                                            : setTaskComputer(false)
                                                                    }
                                                                    checked={taskComputer === true ? true : false}
                                                                />
                                                                <span class='text-sm'>Computer</span>
                                                            </label>
                                                        </div>
                                                        <div className='flex flex-row items-center'>
                                                            <label class='text-gray-500 font-bold'>
                                                                <input
                                                                    class='mr-2 leading-tight'
                                                                    type='checkbox'
                                                                    onChange={(e) =>
                                                                        e.target.checked === true
                                                                            ? setTaskAirConditioner(true)
                                                                            : setTaskAirConditioner(false)
                                                                    }
                                                                    checked={taskAirConditioner === true ? true : false}
                                                                />
                                                                <span class='text-sm'>Air Conditioner</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Office' &&
                                                showTaskFurnishingOfOffice && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Furnishing of Office
                                                        </label>
                                                        <Select
                                                            name='Furnishing of Office'
                                                            value={taskFurnishingOfOffice}
                                                            onChange={(e) =>
                                                                setTaskFurnishingOfOffice(e.target.value)
                                                            }
                                                            options={[
                                                                { id: 'Excellent', title: 'Excellent' },
                                                                { id: 'Good', title: 'Good' },
                                                                { id: 'Average', title: 'Average' },
                                                                {
                                                                    id: 'Poor',
                                                                    title: 'Poor',
                                                                },
                                                                {
                                                                    id: 'Door Step Verification',
                                                                    title: 'Door Step Verification',
                                                                },
                                                            ]}
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData && taskData.type === 'Office' && showTaskAssetsSeen && (
                                                <div className='flex flex-wrap md:flex-row justify-between py-2 gap-2 w-full'>
                                                    <div className='flex flex-row items-center'>
                                                        <label class='text-gray-500 font-bold'>
                                                            <input
                                                                class='mr-2 leading-tight'
                                                                type='checkbox'
                                                                onChange={(e) =>
                                                                    e.target.checked === true
                                                                        ? setTaskTelephone(true)
                                                                        : setTaskTelephone(false)
                                                                }
                                                                checked={taskTelephone === true ? true : false}
                                                            />
                                                            <span class='text-sm'>Telephone</span>
                                                        </label>
                                                    </div>
                                                    <div className='flex flex-row items-center'>
                                                        <label class='text-gray-500 font-bold'>
                                                            <input
                                                                class='mr-2 leading-tight'
                                                                type='checkbox'
                                                                onChange={(e) =>
                                                                    e.target.checked === true
                                                                        ? setTaskLaptop(true)
                                                                        : setTaskLaptop(false)
                                                                }
                                                                checked={taskLaptop === true ? true : false}
                                                            />
                                                            <span class='text-sm'>Laptop</span>
                                                        </label>
                                                    </div>
                                                    <div className='flex flex-row items-center'>
                                                        <label class='text-gray-500 font-bold'>
                                                            <input
                                                                class='mr-2 leading-tight'
                                                                type='checkbox'
                                                                onChange={(e) =>
                                                                    e.target.checked === true
                                                                        ? setTaskFax(true)
                                                                        : setTaskFax(false)
                                                                }
                                                                checked={taskFax === true ? true : false}
                                                            />
                                                            <span class='text-sm'>Fax</span>
                                                        </label>
                                                    </div>
                                                    <div className='flex flex-row items-center'>
                                                        <label class='text-gray-500 font-bold'>
                                                            <input
                                                                class='mr-2 leading-tight'
                                                                type='checkbox'
                                                                onChange={(e) =>
                                                                    e.target.checked === true
                                                                        ? setTaskComputer(true)
                                                                        : setTaskComputer(false)
                                                                }
                                                                checked={taskComputer === true ? true : false}
                                                            />
                                                            <span class='text-sm'>Computer</span>
                                                        </label>
                                                    </div>
                                                    <div className='flex flex-row items-center'>
                                                        <label class='text-gray-500 font-bold'>
                                                            <input
                                                                class='mr-2 leading-tight'
                                                                type='checkbox'
                                                                onChange={(e) =>
                                                                    e.target.checked === true
                                                                        ? setTaskAirConditioner(true)
                                                                        : setTaskAirConditioner(false)
                                                                }
                                                                checked={taskAirConditioner === true ? true : false}
                                                            />
                                                            <span class='text-sm'>Air Conditioner</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            )}
                                            {showTaskLocalityStatus && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        Locality Status
                                                    </label>
                                                    <Select
                                                        name='Locality Status'
                                                        value={taskLocalityStatus}
                                                        onChange={(e) => setTaskLocalityStatus(e.target.value)}
                                                        options={[
                                                            { id: 'Residential', title: 'Residential' },
                                                            { id: 'Commercial', title: 'Commercial' },
                                                            {
                                                                id: 'Residential Cum Commercial',
                                                                title: 'Residential Cum Commercial',
                                                            },
                                                            { id: 'Industrial', title: 'Industrial' },
                                                        ]}
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {showTaskLocalityType && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        Locality Type
                                                    </label>
                                                    <Select
                                                        name='Locality Type'
                                                        value={taskLocalityType}
                                                        onChange={(e) => setTaskLocalityType(e.target.value)}
                                                        options={[
                                                            { id: 'Posh', title: 'Posh' },
                                                            {
                                                                id: 'Upper Middle Class',
                                                                title: 'Upper Middle Class',
                                                            },
                                                            {
                                                                id: 'Middle Class',
                                                                title: 'Middle Class',
                                                            },
                                                            {
                                                                id: 'Lower Middle Class',
                                                                title: 'Lower Middle Class',
                                                            },
                                                            { id: 'Slum', title: 'Slum' },
                                                            { id: 'Village Area', title: 'Village Area' },
                                                        ]}
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {taskData &&
                                                taskData.type === 'Office' &&
                                                showTaskLevelOfActivity && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Level of Activity
                                                        </label>
                                                        <Select
                                                            name='Level of Activity'
                                                            value={taskLevelOfActivity}
                                                            onChange={(e) => setTaskLevelOfActivity(e.target.value)}
                                                            options={[
                                                                { id: 'Very High', title: 'Very High' },
                                                                {
                                                                    id: 'High',
                                                                    title: 'High',
                                                                },
                                                                {
                                                                    id: 'Medium',
                                                                    title: 'Medium',
                                                                },
                                                                {
                                                                    id: 'Low',
                                                                    title: 'Low',
                                                                },
                                                                { id: 'None', title: 'None' },
                                                            ]}
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData && taskData.type === 'Office' && showTaskStockSeen && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        Stock Seen
                                                    </label>
                                                    <Select
                                                        name='Stock Seen'
                                                        value={taskStockSeen}
                                                        onChange={(e) => setTaskStockSeen(e.target.value)}
                                                        options={[
                                                            { id: 'Heavy', title: 'Heavy' },
                                                            {
                                                                id: 'Average',
                                                                title: 'Average',
                                                            },
                                                            {
                                                                id: 'Low',
                                                                title: 'Low',
                                                            },
                                                            {
                                                                id: 'No Stock',
                                                                title: 'No Stock',
                                                            },
                                                            { id: 'Not Applicable', title: 'Not Applicable' },
                                                        ]}
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {showTaskLocatingTheAddress && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        Locating the Address
                                                    </label>
                                                    <Select
                                                        name='Locating the Address'
                                                        value={taskLocatingTheAddress}
                                                        onChange={(e) =>
                                                            setTaskLocatingTheAddress(e.target.value)
                                                        }
                                                        options={[
                                                            { id: 'Easy', title: 'Easy' },
                                                            { id: 'Difficult', title: 'Difficult' },
                                                            {
                                                                id: 'Landmark Required',
                                                                title: 'Landmark Required',
                                                            },
                                                        ]}
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}

                                            {taskData && taskData.type === 'Residence' && showTaskAreaType && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        Area Type
                                                    </label>
                                                    <Select
                                                        name='Area Type'
                                                        value={taskAreaType}
                                                        onChange={(e) => setTaskAreaType(e.target.value)}
                                                        options={[
                                                            { id: 'Normal Area', title: 'Normal Area' },
                                                            {
                                                                id: 'Community Dominated Area',
                                                                title: 'Community Dominated Area',
                                                            },
                                                            { id: 'Negative Area', title: 'Negative Area' },
                                                        ]}
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {taskData &&
                                                taskData.type === 'Residence' &&
                                                showTaskResidenceAccessedBy && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Residence Accessed By
                                                        </label>
                                                        <Select
                                                            name='Residence Accessed By'
                                                            value={taskResidenceAccessedBy}
                                                            onChange={(e) =>
                                                                setTaskResidenceAccessedBy(e.target.value)
                                                            }
                                                            options={[
                                                                { id: 'Car', title: 'Car' },
                                                                {
                                                                    id: 'Two Wheeler',
                                                                    title: 'Two Wheeler',
                                                                },
                                                                { id: 'Metro', title: 'Metro' },
                                                                { id: 'Bus', title: 'Bus' },
                                                                { id: 'Walk', title: 'Walk' },
                                                                { id: 'Others', title: 'Others' },
                                                            ]}
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {taskData &&
                                                taskData.type === 'Residence' &&
                                                showTaskAreaTypeDetails && (
                                                    <div className='flex flex-col'>
                                                        <label className='text-sm mb-2' htmlFor='name'>
                                                            Area Type Details
                                                        </label>
                                                        <Input
                                                            placeholder='Area Type Details'
                                                            value={taskAreaTypeDetails}
                                                            onChange={(e) => setTaskAreaTypeDetails(e.target.value)}
                                                            disabled={!taskSummaryOption}
                                                        />
                                                    </div>
                                                )}
                                            {showTaskPreviousVisitDone && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        Previous Visit Done
                                                    </label>
                                                    <Select
                                                        name='Previous Visit Done'
                                                        value={taskPreviousVisitDone}
                                                        onChange={(e) => setTaskPreviousVisitDone(e.target.value)}
                                                        options={[
                                                            { id: 'Yes', title: 'Yes' },
                                                            { id: 'No', title: 'No' },
                                                        ]}
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}

                                            {showTaskColorOfBuilding && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        Color of Building
                                                    </label>
                                                    <Input
                                                        placeholder='Color of Building'
                                                        value={taskColorOfBuilding}
                                                        onChange={(e) => setTaskColorOfBuilding(e.target.value)}
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {showTaskColorOfGate && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        Color of Gate
                                                    </label>
                                                    <Input
                                                        placeholder='Color of Gate'
                                                        value={taskColorOfGate}
                                                        onChange={(e) => setTaskColorOfGate(e.target.value)}
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {showTaskInfoAction && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        Status
                                                    </label>
                                                    <Select
                                                        name='Status'
                                                        value={taskInfoAction}
                                                        onChange={(e) => setTaskInfoAction(e.target.value)}
                                                        options={[
                                                            { id: 'Positive', title: 'Positive' },
                                                            { id: 'Negative', title: 'Negative' },
                                                            { id: 'Negative Red Flag', title: 'Negative Red Flag' },
                                                        ]}
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {showTaskRouteMap && (
                                                <div className='flex flex-col w-full'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        Route Map
                                                    </label>
                                                    <textarea
                                                        className='block appearance-none w-full bg-gray-100 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 text-sm'
                                                        placeholder='Notes'
                                                        rows={4}
                                                        onChange={(e) => setTaskRouteMap(e.target.value)}
                                                        disabled={!taskSummaryOption}
                                                        value={taskRouteMap}
                                                    >
                                                        {taskRouteMap}
                                                    </textarea>
                                                </div>
                                            )}
                                            {showTaskReason && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        Reason
                                                    </label>
                                                    <Select
                                                        name='Reason'
                                                        value={taskReason}
                                                        onChange={(e) => setTaskReason(e.target.value)}
                                                        options={[
                                                            {
                                                                id: 'Address Not Found',
                                                                title: 'Address Not Found',
                                                            },
                                                            { id: 'Wrong Address', title: 'Wrong Address' },
                                                            { id: 'Incomplete Address', title: 'Incomplete Address' },
                                                            { id: 'Tranfser', title: 'Tranfser' },
                                                        ]}
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {showIncompleteAddress && (
                                                <div className='flex flex-col'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        Incomplete Address Reason
                                                    </label>
                                                    <Select
                                                        name='Incomplete Address Reason'
                                                        value={taskIncompleteAddress}
                                                        onChange={(e) => setTaskIncompleteAddress(e.target.value)}
                                                        options={[
                                                            {
                                                                id: 'House Number',
                                                                title: 'House Number',
                                                            },
                                                            { id: 'Block Number', title: 'Block Number' },
                                                            { id: 'Father Name', title: 'Father Name' },
                                                            { id: 'Landlord Name', title: 'Landlord Name' },
                                                            { id: 'Gali Number', title: 'Gali Number' },
                                                            { id: 'Sector', title: 'Sector' },
                                                            { id: 'Sub Locality', title: 'Sub Locality' },
                                                            { id: 'Locality', title: 'Locality' },
                                                            { id: 'Other', title: 'Other' }
                                                        ]}
                                                        disabled={!taskSummaryOption}
                                                    />
                                                </div>
                                            )}
                                            {showTaskNotes && (
                                                <div className='flex flex-col w-full'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        Notes
                                                    </label>
                                                    <textarea
                                                        className='block appearance-none w-full bg-gray-100 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 text-sm'
                                                        placeholder='Notes'
                                                        rows={4}
                                                        onChange={(e) => setTaskNotes(e.target.value)}
                                                        disabled={!taskSummaryOption}
                                                        value={taskNotes}
                                                    >
                                                        {taskNotes}
                                                    </textarea>
                                                </div>
                                            )}
                                            {showTaskFeedback && (
                                                <div className='flex flex-col w-full'>
                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                        Feedback
                                                    </label>
                                                    <textarea
                                                        className='block appearance-none w-full bg-gray-100 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 text-sm'
                                                        placeholder='Feedback'
                                                        rows={3}
                                                        onChange={(e) => setFeedback(e.target.value)}
                                                        disabled={!taskSummaryOption}
                                                        value={taskFeedback}
                                                    >
                                                        {taskFeedback}
                                                    </textarea>
                                                </div>
                                            )}
                                        </div>
                                        {taskData.type === 'Residence' || taskData.type === 'Short' ? (
                                            <Button
                                                text='Update'
                                                custom='py-2'
                                                onClick={updateResidence}
                                                disabled={!taskSummaryOption || loadingUpdateSubmitTask}
                                            />
                                        ) : (
                                            <Button
                                                text='Update'
                                                custom='py-2'
                                                onClick={updateOffice}
                                                disabled={!taskSummaryOption || loadingUpdateSubmitTask}
                                            />
                                        )}
                                    </div>
                                    <div className='bg-white shadow-md rounded px-8 py-4 w-full mb-4'>
                                        <h3 className='font-semibold text-md'>Documents</h3>
                                        <div className='flex flex-wrap py-4 gap-5'>
                                            {taskData && taskData.documents && taskData.documents.length > 0 ? (
                                                taskData.documents.map((item, index) => (
                                                    <div
                                                        className='relative'
                                                        style={{
                                                            width: 200,
                                                            height: 300,
                                                            borderRadius: 5,
                                                            cursor: 'pointer',
                                                        }}
                                                        key={index}
                                                        onClick={() => openImageModal(item)}
                                                    >
                                                        <img
                                                            src={`data:image/jpeg;base64, ${item}`}
                                                            alt={`Document ${index + 1}`}
                                                            style={{ width: 200, height: 300, borderRadius: 5 }}
                                                        />
                                                        {taskData.information &&
                                                            taskData.information.documentDetails &&
                                                            taskData.information.documentDetails[index] && (
                                                                <div
                                                                    className="absolute bottom-0 left-0 p-2 w-100 text-center"
                                                                    style={{ backgroundColor: 'rgba(0, 0, 0, 0.54)', color: 'white' }}
                                                                >
                                                                    <p className='text-sm'>Lat: {taskData.information.documentDetails[index].latitude}</p>
                                                                    <p className='text-sm'>Long: {taskData.information.documentDetails[index].longitude}</p>
                                                                    <p className='text-sm'>Time: {taskData.information.documentDetails[index].timestamp}</p>
                                                                </div>
                                                            )}
                                                    </div>
                                                ))
                                            ) : (
                                                <p>No documents available</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className='bg-white shadow-md rounded px-8 py-4 w-full mb-4'>
                                        <h3 className='font-semibold text-md'>Photographs</h3>
                                        <div className='flex flex-wrap py-4 gap-5 relative'>
                                            {taskData && taskData.photographs && taskData.photographs.length > 0 ? (
                                                taskData.photographs.map((item, index) => {
                                                    // Get the corresponding details for this photograph
                                                    const photoDetails = taskData.information?.photographsDetails?.[index];
                                                    // Create a stable key using the timestamp or other unique data
                                                    const stableKey = photoDetails ?
                                                        `photo-${photoDetails.timestamp}-${index}` :
                                                        `photo-${index}`;

                                                    return (
                                                        <div
                                                            className="relative"
                                                            style={{
                                                                width: 200,
                                                                height: 300,
                                                                borderRadius: 5,
                                                                cursor: 'pointer',
                                                            }}
                                                            key={stableKey}
                                                            onClick={() => openImageModal(item)}
                                                        >
                                                            <img
                                                                src={`data:image/jpeg;base64, ${item}`}
                                                                alt={`Photograph ${index + 1}`}
                                                                style={{ width: 200, height: 300, borderRadius: 5 }}
                                                            />
                                                            {taskData.information &&
                                                                taskData.information.photographsDetails &&
                                                                taskData.information.photographsDetails[index] && (
                                                                    <div
                                                                        className="absolute bottom-0 left-0 p-2 w-100 text-center"
                                                                        style={{ backgroundColor: 'rgba(0, 0, 0, 0.54)', color: 'white' }}
                                                                    >
                                                                        <p className='text-sm'>Lat: {photoDetails.latitude}</p>
                                                                        <p className='text-sm'>Long: {photoDetails.longitude}</p>
                                                                        <p className='text-sm'>Time: {photoDetails.timestamp}</p>
                                                                    </div>
                                                                )}
                                                        </div>
                                                    );
                                                })
                                            ) : (
                                                <p>No photographs available</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className='bg-white shadow-md rounded px-8 py-4 w-full mb-4'>
                                        <h3 className='font-semibold text-md'>Final Remark</h3>
                                        <textarea
                                            className='block appearance-none w-full bg-gray-100 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 text-sm my-4'
                                            placeholder='Final Remark'
                                            rows={6}
                                            onChange={(e) => setTaskRemark(e.target.value)}
                                            disabled={!isEditing || !taskSummaryOption}
                                            value={taskRemark}
                                            onCopy={(e) => e.preventDefault()}
                                            readOnly={!isEditing}
                                        >
                                            {taskRemark}
                                        </textarea>
                                        <div className='flex justify-end'>
                                            {!isEditing ? (
                                                <Button
                                                    text='Edit'
                                                    custom='py-2'
                                                    onClick={() => setIsEditing(true)}
                                                    disabled={!taskSummaryOption}
                                                />
                                            ) : (
                                                <>
                                                    <Button
                                                        text='Cancel'
                                                        custom='py-2 mr-2'
                                                        onClick={() => setIsEditing(false)}
                                                    />
                                                    <Button
                                                        text='Update'
                                                        custom='py-2'
                                                        onClick={() => {
                                                            updateRemarks();
                                                            setIsEditing(false);
                                                        }}
                                                        disabled={loadingUpdateRemarksTask}
                                                    />
                                                </>
                                            )}
                                            <Button
                                                text='Copy'
                                                custom='py-2 ml-2'
                                                onClick={() => {
                                                    if (taskRemark) {
                                                        navigator.clipboard.writeText(taskRemark)
                                                            .then(() => {
                                                                console.log('Text successfully copied');
                                                                // You can add a toast notification here if you want
                                                                // For example: toast.success('Text copied to clipboard!');
                                                            })
                                                            .catch(err => {
                                                                console.error('Failed to copy text: ', err);
                                                                // You can add an error toast here
                                                                // For example: toast.error('Failed to copy text');
                                                            });
                                                    }
                                                    openFinalModal();
                                                }}
                                                disabled={!taskRemark}
                                            />
                                        </div>
                                    </div>
                                    <div className='bg-white shadow-md rounded px-8 py-4 w-full mb-4'>
                                        <h3 className='font-semibold text-md'>Finalisation</h3>
                                        <div className='flex flex-col py-4'>
                                            <label className='text-sm mb-2' htmlFor='name'>
                                                Final Status
                                            </label>
                                            <Select
                                                name='Final Status'
                                                value={finalisationStatus}
                                                onChange={(e) => setFinalisationStatus(e.target.value)}
                                                options={[
                                                    {
                                                        id: 'Positive',
                                                        title: 'Positive',
                                                    },
                                                    { id: 'Negative', title: 'Negative' },
                                                    { id: 'Refer', title: 'Refer' },
                                                    { id: '-', title: '-' },
                                                ]}
                                                disabled={!isEditing || !taskSummaryOption}
                                            />
                                        </div>
                                        {showFinalisationRemarks && (
                                            <div className='flex flex-col'>
                                                <label className='text-sm mb-2' htmlFor='name'>
                                                    Final Remark
                                                </label>
                                                <textarea
                                                    className='block appearance-none w-full bg-gray-100 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 text-sm'
                                                    placeholder='Final Remark'
                                                    rows={4}
                                                    onChange={(e) => setFinalisationRemarks(e.target.value)}
                                                    disabled={!isEditing || !taskSummaryOption}
                                                    value={finalisationRemarks}
                                                >
                                                    {finalisationRemarks}
                                                </textarea>
                                            </div>
                                        )}
                                        {showSubReason && (
                                            <div className='flex flex-col mt-2'>
                                                <label className='text-sm mb-2' htmlFor='name'>
                                                    Sub Reason
                                                </label>
                                                <textarea
                                                    className='block appearance-none w-full bg-gray-100 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 text-sm'
                                                    placeholder='Sub Reason'
                                                    rows={4}
                                                    onChange={(e) => setSubReason(e.target.value)}
                                                    disabled={!isEditing || !taskSummaryOption}
                                                    value={subReason}
                                                >
                                                    {finalisationRemarks}
                                                </textarea>
                                            </div>
                                        )}
                                    </div>
                                    {finalModal && (
                                        <>
                                            <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
                                                <div style={{ width: '500px' }} className='relative my-6 mx-auto'>
                                                    <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none'>
                                                        <div className='flex items-center justify-between py-3 px-3 border-b border-solid border-blueGray-200 rounded-t'>
                                                            <h3 className='text-lg font-semibold'>Finalisation</h3>
                                                        </div>
                                                        <div className='bg-white shadow-md rounded px-8 py-4 w-full mb-4'>
                                                            <div className='flex flex-col py-4'>
                                                                <label className='text-sm mb-2' htmlFor='name'>
                                                                    Final Status
                                                                </label>
                                                                <Select
                                                                    width='w-full'
                                                                    name='Final Status'
                                                                    value={finalisationStatus}
                                                                    onChange={(e) => setFinalisationStatus(e.target.value)}
                                                                    options={[
                                                                        { id: 'Positive', title: 'Positive' },
                                                                        { id: 'Negative', title: 'Negative' },
                                                                        { id: 'Refer', title: 'Refer' },
                                                                        { id: '-', title: '-' },
                                                                    ]}
                                                                    disabled={!taskSummaryOption}
                                                                />
                                                            </div>
                                                            {showNegativeDropdown && (
                                                                <>
                                                                    <div className='flex flex-col mt-2'>
                                                                        <label className='text-sm mb-2' htmlFor='negativeReason'>
                                                                            Negative Reason
                                                                        </label>
                                                                        <Select
                                                                            width='w-full'
                                                                            name='Negative Reason'
                                                                            value={finalisationRemarks}
                                                                            onChange={(e) => handleReasonChange(e.target.value)}
                                                                            options={getNegativeOptions()}
                                                                            disabled={!taskSummaryOption}
                                                                        />
                                                                    </div>
                                                                    {hasSubOptions() && (
                                                                        <div className='flex flex-col mt-4'>
                                                                            <label className='text-sm mb-2' htmlFor='subReason'>
                                                                                Sub Reason
                                                                            </label>
                                                                            <Select
                                                                                width='w-full'
                                                                                name='Sub Reason'
                                                                                value={subReason}
                                                                                onChange={(e) => handleSubReasonChange(e.target.value)}
                                                                                options={getSelectedOption().subOptions.map(option => ({ id: option, title: option }))}
                                                                                disabled={!taskSummaryOption}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                    {finalisationRemarks === 'OTHERS' && (
                                                                        <div className='flex flex-col mt-4'>
                                                                            <label className='text-sm mb-2' htmlFor='otherReason'>
                                                                                Other Reason
                                                                            </label>
                                                                            <textarea
                                                                                className='block appearance-none w-full bg-gray-100 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 text-sm'
                                                                                placeholder='Specify other reason'
                                                                                rows={2}
                                                                                onChange={(e) => setSubReason(e.target.value)}
                                                                                disabled={!taskSummaryOption}
                                                                                value={subReason}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </>
                                                            )}
                                                            {(finalisationStatus === 'Refer') && (
                                                                <div className='flex flex-col mt-2'>
                                                                    <label className='text-sm mb-2' htmlFor='name'>
                                                                        Final Remark
                                                                    </label>
                                                                    <textarea
                                                                        className='block appearance-none w-full bg-gray-100 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 text-sm'
                                                                        placeholder='Final Remark'
                                                                        rows={4}
                                                                        onChange={(e) => setFinalisationRemarks(e.target.value)}
                                                                        disabled={!taskSummaryOption}
                                                                        value={finalisationRemarks}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className='flex items-center justify-end py-2 px-3 border-t border-solid border-blueGray-200 rounded-b'>
                                                            <button
                                                                className='text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150'
                                                                type='button'
                                                                onClick={closeFinalModal}
                                                            >
                                                                Close
                                                            </button>
                                                            <button
                                                                className='bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 disabled:bg-gray-300'
                                                                type='button'
                                                                onClick={updateFinalisation}
                                                                disabled={!taskSummaryOption || loadingTaskFinalisation}
                                                            >
                                                                Update
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='opacity-25 fixed inset-0 z-40 bg-black'></div>
                                        </>
                                    )}

                                </>
                            )}
                            <div className='bg-white shadow-md rounded px-8 py-4 w-full mb-4'>
                                <div
                                    id='vendorReport'
                                    style={{
                                        display: 'none',
                                        flexDirection: 'column',
                                        paddingTop: '30px',
                                        paddingLeft: '20px',
                                    }}
                                >
                                    <table style={{ width: '550px' }}>
                                        <tr
                                            style={{
                                                borderColor: 'black',
                                                borderWidth: 0.5,
                                            }}
                                        >
                                            <td
                                                style={{
                                                    width: '230px',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <img
                                                    style={{ marginLeft: '16px' }}
                                                    width='70px'
                                                    height='32px'
                                                    src={
                                                        taskData &&
                                                            taskData.customer.logo === 'Management Services'
                                                            ? 'data:image/png;base64,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'
                                                            : 'data:image/png;base64,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'
                                                    }
                                                />
                                            </td>
                                            <td
                                                style={{
                                                    width: '245px',
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        fontWeight: 'bold',
                                                        textDecoration: 'none',
                                                        fontSize: 9,
                                                        textAlign: 'center',
                                                        paddingBottom: '5px',
                                                    }}
                                                >

                                                </p>
                                            </td>
                                            <td
                                                style={{
                                                    width: '230px',
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        fontWeight: 'bold',
                                                        textDecoration: 'none',
                                                        fontSize: 9,
                                                        textAlign: 'center',
                                                        paddingBottom: '5px',
                                                    }}
                                                >
                                                    {taskData && taskData.customer.name.toUpperCase()}
                                                </p>
                                            </td>
                                        </tr>
                                    </table>
                                    <table style={{ width: '550px' }}>
                                        <tr>
                                            <td
                                                style={{
                                                    // backgroundColor: '#BFBFBF',
                                                    textAlign: 'center',
                                                    borderColor: 'black',
                                                    borderBottomWidth: 0.5,
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    height: '12px',
                                                }}
                                                colspan='6'
                                            >
                                                <p
                                                    style={{
                                                        marginTop: '10px',
                                                        color: 'black',
                                                        fontSize: 12,
                                                        fontWeight: 'bold',
                                                        fontFamily: 'Arial, sans-serif',
                                                        textDecoration: 'none',
                                                    }}
                                                >
                                                    Vendor Field Investigation Report
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'center',
                                                    width: '85px',
                                                    height: '24px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        fontWeight: 'bold',
                                                        textDecoration: 'none',
                                                        fontSize: 10,
                                                        textAlign: 'center',
                                                        marginTop: '10px',
                                                    }}
                                                >
                                                    Date of Visit
                                                </p>
                                            </td>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'left',
                                                    width: '425px',
                                                    height: '24px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        textDecoration: 'none',
                                                        fontSize: 10,
                                                        marginTop: '10px',
                                                        marginLeft: '20px',
                                                    }}
                                                >
                                                    {taskData && taskData.visitFinishedOn.split(' ')[0]}
                                                </p>
                                            </td>
                                        </tr>
                                    </table>
                                    <table style={{ width: '550px' }}>
                                        <tr>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'center',
                                                    width: '85px',
                                                    height: '24px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        fontWeight: 'bold',
                                                        textDecoration: 'none',
                                                        fontSize: 10,
                                                        textAlign: 'center',
                                                        marginTop: '10px',
                                                    }}
                                                >
                                                    Vendor Name
                                                </p>
                                            </td>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'left',
                                                    width: '425px',
                                                    height: '24px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        textDecoration: 'none',
                                                        fontSize: 10,
                                                        marginTop: '10px',
                                                        marginLeft: '20px',
                                                    }}
                                                >
                                                    {taskData && taskData.customer.logo.toUpperCase()}
                                                </p>
                                            </td>
                                        </tr>
                                    </table>
                                    <table style={{ width: '550px' }}>
                                        <tr>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'center',
                                                    width: '85px',
                                                    height: '24px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        fontWeight: 'bold',
                                                        textDecoration: 'none',
                                                        fontSize: 10,
                                                        textAlign: 'center',
                                                        marginTop: '10px',
                                                    }}
                                                >
                                                    Customer Name
                                                </p>
                                            </td>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'left',
                                                    width: '425px',
                                                    height: '24px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        textDecoration: 'none',
                                                        fontSize: 10,
                                                        marginTop: '10px',
                                                        marginLeft: '20px',
                                                    }}
                                                >
                                                    {name && name.toUpperCase()}
                                                </p>
                                            </td>
                                        </tr>
                                    </table>
                                    <table style={{ width: '550px' }}>
                                        <tr>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'center',
                                                    width: '85px',
                                                    height: '24px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        fontWeight: 'bold',
                                                        textDecoration: 'none',
                                                        fontSize: 10,
                                                        textAlign: 'center',
                                                        marginTop: '10px',
                                                    }}
                                                >
                                                    Address
                                                </p>
                                            </td>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'left',
                                                    width: '425px',
                                                    height: '24px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        textDecoration: 'none',
                                                        fontSize: 10,
                                                        marginTop: '10px',
                                                        marginLeft: '20px',
                                                    }}
                                                >
                                                    {address && address.toUpperCase()}
                                                </p>
                                            </td>
                                        </tr>
                                    </table>
                                    <table style={{ width: '550px' }}>
                                        <tr>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'center',
                                                    width: '85px',
                                                    height: '24px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        fontWeight: 'bold',
                                                        textDecoration: 'none',
                                                        fontSize: 10,
                                                        textAlign: 'center',
                                                        marginTop: '10px',
                                                    }}
                                                >
                                                    Contact Number
                                                </p>
                                            </td>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'left',
                                                    width: '425px',
                                                    height: '24px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        textDecoration: 'none',
                                                        fontSize: 10,
                                                        marginTop: '10px',
                                                        marginLeft: '20px',
                                                    }}
                                                >
                                                    {mobile && mobile}
                                                </p>
                                            </td>
                                        </tr>
                                    </table>
                                    <table style={{ width: '550px' }}>
                                        <tr>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'center',
                                                    width: '85px',
                                                    height: '24px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        fontWeight: 'bold',
                                                        textDecoration: 'none',
                                                        fontSize: 10,
                                                        textAlign: 'center',
                                                        marginTop: '10px',
                                                    }}
                                                >
                                                    Customer Availability
                                                </p>
                                            </td>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'left',
                                                    width: '425px',
                                                    height: '24px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        textDecoration: 'none',
                                                        fontSize: 10,
                                                        marginTop: '10px',
                                                        marginLeft: '20px',
                                                    }}
                                                >
                                                    {(taskData &&
                                                        taskData.information.customerAvailability) ||
                                                        'N/A'}
                                                </p>
                                            </td>
                                        </tr>
                                    </table>
                                    <table style={{ width: '550px' }}>
                                        <tr>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'center',
                                                    width: '85px',
                                                    height: '24px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        fontWeight: 'bold',
                                                        textDecoration: 'none',
                                                        fontSize: 10,
                                                        textAlign: 'center',
                                                        marginTop: '10px',
                                                    }}
                                                >
                                                    Shop / Establishment Availability
                                                </p>
                                            </td>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'left',
                                                    width: '425px',
                                                    height: '24px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        textDecoration: 'none',
                                                        fontSize: 10,
                                                        marginTop: '10px',
                                                        marginLeft: '20px',
                                                    }}
                                                >
                                                    {(taskData &&
                                                        taskData.information.shopAvailability) ||
                                                        'N/A'}
                                                </p>
                                            </td>
                                        </tr>
                                    </table>
                                    <table style={{ width: '550px' }}>
                                        <tr>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'center',
                                                    width: '85px',
                                                    height: '24px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        fontWeight: 'bold',
                                                        textDecoration: 'none',
                                                        fontSize: 10,
                                                        textAlign: 'center',
                                                        marginTop: '10px',
                                                    }}
                                                >
                                                    Sign-board of the shop available
                                                </p>
                                            </td>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'left',
                                                    width: '425px',
                                                    height: '24px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        textDecoration: 'none',
                                                        fontSize: 10,
                                                        marginTop: '10px',
                                                        marginLeft: '20px',
                                                    }}
                                                >
                                                    {(taskData &&
                                                        taskData.information.signboardAvailabilty) ||
                                                        'N/A'}
                                                </p>
                                            </td>
                                        </tr>
                                    </table>
                                    <table style={{ width: '550px' }}>
                                        <tr>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'center',
                                                    width: '85px',
                                                    height: '24px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        fontWeight: 'bold',
                                                        textDecoration: 'none',
                                                        fontSize: 10,
                                                        textAlign: 'center',
                                                        marginTop: '10px',
                                                    }}
                                                >
                                                    Shop / Business Set up description
                                                </p>
                                            </td>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'left',
                                                    width: '425px',
                                                    height: '24px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        textDecoration: 'none',
                                                        fontSize: 10,
                                                        marginTop: '10px',
                                                        marginLeft: '20px',
                                                    }}
                                                >
                                                    {(taskData &&
                                                        taskData.information.notes) ||
                                                        'N/A'}
                                                </p>
                                            </td>
                                        </tr>
                                    </table>
                                    <table style={{ width: '550px' }}>
                                        <tr>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'center',
                                                    width: '85px',
                                                    height: '24px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        fontWeight: 'bold',
                                                        textDecoration: 'none',
                                                        fontSize: 10,
                                                        textAlign: 'center',
                                                        marginTop: '10px',
                                                    }}
                                                >
                                                    CPV Remarks
                                                </p>
                                            </td>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'left',
                                                    width: '425px',
                                                    height: '24px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        textDecoration: 'none',
                                                        fontSize: 10,
                                                        marginTop: '10px',
                                                        marginLeft: '20px',
                                                    }}
                                                >
                                                    {taskData.remarks}
                                                </p>
                                            </td>
                                        </tr>
                                    </table>
                                    <table style={{ width: '550px' }}>
                                        <tr>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'center',
                                                    width: '85px',
                                                    height: '24px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        fontWeight: 'bold',
                                                        textDecoration: 'none',
                                                        fontSize: 10,
                                                        textAlign: 'center',
                                                        marginTop: '10px',
                                                    }}
                                                >
                                                    Neighbour Checks Remarks
                                                </p>
                                            </td>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'left',
                                                    width: '425px',
                                                    height: '24px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        textDecoration: 'none',
                                                        fontSize: 10,
                                                        marginTop: '10px',
                                                        marginLeft: '20px',
                                                    }}
                                                >
                                                    {(taskData &&
                                                        taskData.information.neighbourRemarks) ||
                                                        'N/A'}
                                                </p>
                                            </td>
                                        </tr>
                                    </table>
                                    <table style={{ width: '550px', marginTop: '110px' }}>
                                        <tr>
                                            <td
                                                style={{
                                                    backgroundColor: '#BFBFBF',
                                                    textAlign: 'center',
                                                    borderColor: 'black',
                                                    borderBottomWidth: 0.5,
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    height: '12px',
                                                }}
                                                colspan='6'
                                            >
                                                <p
                                                    style={{
                                                        marginTop: '10px',
                                                        color: 'black',
                                                        fontSize: 7,
                                                        fontWeight: 'bold',
                                                        fontFamily: 'Arial, sans-serif',
                                                        textDecoration: 'none',
                                                    }}
                                                >
                                                    PHOTOGRAPHS
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                style={{
                                                    textAlign: 'center',
                                                    borderColor: 'black',
                                                    borderBottomWidth: 0.5,
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    gap: '2px',
                                                }}
                                            >
                                                {taskData && taskData.photographs && taskData.photographs.map((photo, index) => (
                                                    <div
                                                        key={`pdf-photo-${index}`}
                                                        style={{
                                                            width: '107px',
                                                            height: '150px',
                                                            borderRightWidth: index % 5 === 4 ? 0 : 0.5,
                                                            borderBottomWidth: index < 5 ? 0.5 : 0,
                                                            borderColor: 'black',
                                                            position: 'relative',
                                                        }}
                                                    >
                                                        <img
                                                            src={`data:image/jpeg;base64, ${photo}`}
                                                            style={{
                                                                width: '107px',
                                                                height: '150px',
                                                            }}
                                                        />
                                                        {taskData.information &&
                                                            taskData.information.photographsDetails &&
                                                            taskData.information.photographsDetails[index] && (
                                                                <div
                                                                    style={{
                                                                        position: 'absolute',
                                                                        bottom: 1,
                                                                        left: 0,
                                                                        width: '100%',
                                                                        backgroundColor: 'rgba(0, 0, 0, 0.54)',
                                                                        color: 'white',
                                                                        padding: '4px',
                                                                        marginBottom: '1px',
                                                                        fontSize: '8px',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        lineHeight: '1',
                                                                    }}
                                                                >
                                                                    <p style={{ margin: '0', textShadow: '1px 1px 1px black' }}>Lat: {taskData.information.photographsDetails[index].latitude}</p>
                                                                    <p style={{ margin: '0', textShadow: '1px 1px 1px black' }}>Long: {taskData.information.photographsDetails[index].longitude}</p>
                                                                </div>
                                                            )}
                                                    </div>
                                                ))}
                                                {/* If no photographs available */}
                                                {(!taskData || !taskData.photographs || taskData.photographs.length === 0) && (
                                                    <p style={{ fontFamily: 'Arial, sans-serif', fontSize: '8px' }}>No photographs available</p>
                                                )}
                                            </td>
                                        </tr>
                                    </table>
                                    <table style={{ width: '550px' }}>
                                        <tr>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'center',
                                                    width: '85px',
                                                    height: '24px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        fontWeight: 'bold',
                                                        textDecoration: 'none',
                                                        fontSize: 10,
                                                        textAlign: 'center',
                                                        marginTop: '10px',
                                                    }}
                                                >
                                                    Date
                                                </p>
                                            </td>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'left',
                                                    width: '425px',
                                                    height: '24px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        textDecoration: 'none',
                                                        fontSize: 10,
                                                        marginTop: '10px',
                                                        marginLeft: '20px',
                                                    }}
                                                >
                                                    {taskData && taskData.visitFinishedOn.split(' ')[0]}
                                                </p>
                                            </td>
                                        </tr>
                                    </table>
                                    <table style={{ width: '550px' }}>
                                        <tr>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'center',
                                                    width: '125px',
                                                    height: '24px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        fontWeight: 'bold',
                                                        textDecoration: 'none',
                                                        fontSize: 10,
                                                        textAlign: 'center',
                                                        marginTop: '10px',
                                                    }}
                                                >
                                                    Vendor Sign & Stamp
                                                </p>
                                            </td>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'left',
                                                    width: '425px',
                                                    height: '100px', // Increased height to accommodate image
                                                }}
                                            >
                                                {/* Using the imported Stamp image */}
                                                <img
                                                    src={Stamp}
                                                    alt="Vendor Signature"
                                                    style={{
                                                        maxWidth: '200px',
                                                        maxHeight: '80px',
                                                        marginLeft: '20px',
                                                        marginTop: '10px'
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div className='bg-white shadow-md rounded px-8 py-4 w-full mb-4'>
                                <div
                                    id='report'
                                    style={{
                                        display: 'none',
                                        flexDirection: 'column',
                                        paddingTop: '30px',
                                        paddingLeft: '20px',
                                    }}
                                >
                                    <table style={{ width: '550px' }}>
                                        <tr
                                            style={{
                                                borderColor: 'black',
                                                borderWidth: 0.5,
                                            }}
                                        >
                                            <td
                                                style={{
                                                    width: '90px',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <img
                                                    style={{ marginLeft: '16px' }}
                                                    width='70px'
                                                    height='32px'
                                                    src={
                                                        taskData &&
                                                            taskData.customer.logo === 'Management Services'
                                                            ? 'data:image/png;base64,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'
                                                            : 'data:image/png;base64,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'
                                                    }
                                                />
                                            </td>
                                            <td
                                                style={{
                                                    width: '245px',
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        fontWeight: 'bold',
                                                        textDecoration: 'none',
                                                        fontSize: 9,
                                                        textAlign: 'center',
                                                        paddingBottom: '5px',
                                                    }}
                                                >
                                                    {type && type.toUpperCase()} VERIFICATION REPORT
                                                </p>
                                            </td>
                                            <td
                                                style={{
                                                    width: '230px',
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        fontWeight: 'bold',
                                                        textDecoration: 'none',
                                                        fontSize: 9,
                                                        textAlign: 'center',
                                                        paddingBottom: '5px',
                                                    }}
                                                >
                                                    {taskData && taskData.customer.name.toUpperCase()}
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                style={{
                                                    backgroundColor: '#BFBFBF',
                                                    textAlign: 'center',
                                                    borderColor: 'black',
                                                    borderBottomWidth: 0.5,
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    height: '12px',
                                                }}
                                                colspan='6'
                                            >
                                                <p
                                                    style={{
                                                        marginTop: '10px',
                                                        color: 'black',
                                                        fontSize: 7,
                                                        fontWeight: 'bold',
                                                        fontFamily: 'Arial, sans-serif',
                                                        textDecoration: 'none',
                                                    }}
                                                >
                                                    BASIC DETAILS
                                                </p>
                                            </td>
                                        </tr>
                                    </table>
                                    <div className='flex flex-row'>
                                        <table style={{ width: '183px' }}>
                                            <tr>
                                                <td
                                                    style={{
                                                        borderBottomWidth: 0.5,
                                                        borderLeftWidth: 0.5,
                                                        borderColor: 'black',
                                                        textAlign: 'center',
                                                        width: '85px',
                                                        height: '12px',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            fontWeight: 'bold',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '10px',
                                                        }}
                                                    >
                                                        RECEIPT DATE
                                                    </p>
                                                </td>
                                                <td
                                                    style={{
                                                        borderBottomWidth: 0.5,
                                                        borderLeftWidth: 0.5,
                                                        borderColor: 'black',
                                                        textAlign: 'center',
                                                        width: '85px',
                                                        height: '12px',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '10px',
                                                        }}
                                                    >
                                                        {receiptDate}
                                                    </p>
                                                </td>
                                            </tr>
                                        </table>
                                        <table style={{ width: '183px' }}>
                                            <tr>
                                                <td
                                                    style={{
                                                        borderBottomWidth: 0.5,
                                                        borderLeftWidth: 0.5,
                                                        borderColor: 'black',
                                                        textAlign: 'center',
                                                        width: '85px',
                                                        height: '12px',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            fontWeight: 'bold',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '10px',
                                                        }}
                                                    >
                                                        BRANCH
                                                    </p>
                                                </td>
                                                <td
                                                    style={{
                                                        borderBottomWidth: 0.5,
                                                        borderLeftWidth: 0.5,
                                                        borderColor: 'black',
                                                        textAlign: 'center',
                                                        width: '85px',
                                                        height: '12px',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '10px',
                                                        }}
                                                    >
                                                        {branch && branch.toUpperCase()}
                                                    </p>
                                                </td>
                                            </tr>
                                        </table>
                                        <table style={{ width: '184px' }}>
                                            <tr>
                                                <td
                                                    style={{
                                                        borderBottomWidth: 0.5,
                                                        borderLeftWidth: 0.5,
                                                        borderColor: 'black',
                                                        textAlign: 'center',
                                                        width: '85px',
                                                        height: '12px',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            fontWeight: 'bold',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '10px',
                                                        }}
                                                    >
                                                        FI TYPE
                                                    </p>
                                                </td>
                                                <td
                                                    style={{
                                                        borderBottomWidth: 0.5,
                                                        borderRightWidth: 0.5,
                                                        borderLeftWidth: 0.5,
                                                        borderColor: 'black',
                                                        textAlign: 'center',
                                                        width: '85px',
                                                        height: '12px',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '10px',
                                                        }}
                                                    >
                                                        {loanType && loanType.toUpperCase()}
                                                    </p>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div className='flex flex-row'>
                                        <table style={{ width: '183px' }}>
                                            <tr>
                                                <td
                                                    style={{
                                                        borderBottomWidth: 0.5,
                                                        borderLeftWidth: 0.5,
                                                        borderColor: 'black',
                                                        textAlign: 'center',
                                                        width: '85px',
                                                        height: '12px',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            fontWeight: 'bold',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '10px',
                                                        }}
                                                    >
                                                        APPLICANT'S NAME
                                                    </p>
                                                </td>
                                                <td
                                                    style={{
                                                        borderBottomWidth: 0.5,
                                                        borderLeftWidth: 0.5,
                                                        borderColor: 'black',
                                                        textAlign: 'center',
                                                        width: '85px',
                                                        height: '12px',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '10px',
                                                        }}
                                                    >
                                                        {name && name.toUpperCase()}
                                                    </p>
                                                </td>
                                            </tr>
                                        </table>
                                        <table style={{ width: '183px' }}>
                                            <tr>
                                                <td
                                                    style={{
                                                        borderBottomWidth: 0.5,
                                                        borderLeftWidth: 0.5,
                                                        borderColor: 'black',
                                                        textAlign: 'center',
                                                        width: '85px',
                                                        height: '12px',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            fontWeight: 'bold',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '10px',
                                                        }}
                                                    >
                                                        LOAN NO
                                                    </p>
                                                </td>
                                                <td
                                                    style={{
                                                        borderBottomWidth: 0.5,
                                                        borderLeftWidth: 0.5,
                                                        borderColor: 'black',
                                                        textAlign: 'center',
                                                        width: '85px',
                                                        height: '12px',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '10px',
                                                        }}
                                                    >
                                                        {loanNumber}
                                                    </p>
                                                </td>
                                            </tr>
                                        </table>
                                        <table style={{ width: '184px' }}>
                                            <tr>
                                                <td
                                                    style={{
                                                        borderBottomWidth: 0.5,
                                                        borderLeftWidth: 0.5,
                                                        borderColor: 'black',
                                                        textAlign: 'center',
                                                        width: '85px',
                                                        height: '12px',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            fontWeight: 'bold',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '10px',
                                                        }}
                                                    >
                                                        FINANCE AMOUNT
                                                    </p>
                                                </td>
                                                <td
                                                    style={{
                                                        borderBottomWidth: 0.5,
                                                        borderRightWidth: 0.5,
                                                        borderLeftWidth: 0.5,
                                                        borderColor: 'black',
                                                        textAlign: 'center',
                                                        width: '85px',
                                                        height: '12px',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '10px',
                                                        }}
                                                    >
                                                        {financeAmount}
                                                    </p>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <table style={{ width: '550px' }}>
                                        <tr>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'center',
                                                    width: '85px',
                                                    height: '24px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        fontWeight: 'bold',
                                                        textDecoration: 'none',
                                                        fontSize: 7,
                                                        textAlign: 'center',
                                                        marginTop: '10px',
                                                    }}
                                                >
                                                    {type && type.toUpperCase()} ADDRESS
                                                </p>
                                            </td>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'left',
                                                    width: '425px',
                                                    height: '24px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        textDecoration: 'none',
                                                        fontSize: 7,
                                                        marginTop: '10px',
                                                        marginLeft: '20px',
                                                    }}
                                                >
                                                    {address && address.toUpperCase()}
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                style={{
                                                    backgroundColor: '#BFBFBF',
                                                    textAlign: 'center',
                                                    borderColor: 'black',
                                                    borderBottomWidth: 0.5,
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    height: '12px',
                                                }}
                                                colspan='6'
                                            >
                                                <p
                                                    style={{
                                                        marginTop: '10px',
                                                        color: 'black',
                                                        fontSize: 7,
                                                        fontWeight: 'bold',
                                                        fontFamily: 'Arial, sans-serif',
                                                        textDecoration: 'none',
                                                    }}
                                                >
                                                    APPLICANT'S INFORMATION OBTAINED BY PERSON MET
                                                </p>
                                            </td>
                                        </tr>
                                    </table>
                                    <div className='flex flex-row'>
                                        <table style={{ width: '183px' }}>
                                            <tr>
                                                <td
                                                    style={{
                                                        borderBottomWidth: 0.5,
                                                        borderLeftWidth: 0.5,
                                                        borderColor: 'black',
                                                        textAlign: 'center',
                                                        width: '85px',
                                                        height: '12px',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            fontWeight: 'bold',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '10px',
                                                        }}
                                                    >
                                                        DATE OF VISIT
                                                    </p>
                                                </td>
                                                <td
                                                    style={{
                                                        borderBottomWidth: 0.5,
                                                        borderLeftWidth: 0.5,
                                                        borderColor: 'black',
                                                        textAlign: 'center',
                                                        width: '85px',
                                                        height: '12px',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '10px',
                                                        }}
                                                    >
                                                        {taskData && taskData.visitFinishedOn.split(' ')[0]}
                                                    </p>
                                                </td>
                                            </tr>
                                        </table>
                                        <table style={{ width: '183px' }}>
                                            <tr>
                                                <td
                                                    style={{
                                                        borderBottomWidth: 0.5,
                                                        borderLeftWidth: 0.5,
                                                        borderColor: 'black',
                                                        textAlign: 'center',
                                                        width: '85px',
                                                        height: '12px',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            fontWeight: 'bold',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '10px',
                                                        }}
                                                    >
                                                        TIME OF VISIT
                                                    </p>
                                                </td>
                                                <td
                                                    style={{
                                                        borderBottomWidth: 0.5,
                                                        borderLeftWidth: 0.5,
                                                        borderColor: 'black',
                                                        textAlign: 'center',
                                                        width: '85px',
                                                        height: '12px',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '10px',
                                                        }}
                                                    >
                                                        {taskData && taskData.visitFinishedOn.split(' ')[1]}
                                                    </p>
                                                </td>
                                            </tr>
                                        </table>
                                        <table style={{ width: '184px' }}>
                                            <tr>
                                                <td
                                                    style={{
                                                        borderBottomWidth: 0.5,
                                                        borderLeftWidth: 0.5,
                                                        borderColor: 'black',
                                                        textAlign: 'center',
                                                        width: '85px',
                                                        height: '12px',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            fontWeight: 'bold',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '10px',
                                                        }}
                                                    >
                                                        ADDRESS FOUND
                                                    </p>
                                                </td>
                                                <td
                                                    style={{
                                                        borderBottomWidth: 0.5,
                                                        borderRightWidth: 0.5,
                                                        borderLeftWidth: 0.5,
                                                        borderColor: 'black',
                                                        textAlign: 'center',
                                                        width: '85px',
                                                        height: '12px',
                                                        paddingLeft: '10px',
                                                    }}
                                                >
                                                    <label
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                            marginBottom: '2px',
                                                        }}
                                                    >
                                                        <input
                                                            style={{ marginRight: '8px', marginTop: '7px' }}
                                                            type='checkbox'
                                                            checked={
                                                                taskData.information.addressFoundDropdownValue === 'Yes'
                                                                    ? true
                                                                    : false
                                                            }
                                                        />
                                                        <span
                                                            style={{
                                                                color: 'black',
                                                                fontFamily: 'Arial, sans-serif',
                                                                fontStyle: 'normal',
                                                                textDecoration: 'none',
                                                                fontSize: 7,
                                                                textAlign: 'center',
                                                                marginTop: '0px',
                                                            }}
                                                        >
                                                            YES
                                                        </span>
                                                    </label>
                                                    <label
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                        }}
                                                    >
                                                        <input
                                                            style={{ marginRight: '8px', marginTop: '7px' }}
                                                            type='checkbox'
                                                            checked={
                                                                taskData.information.addressFoundDropdownValue === 'No'
                                                                    ? true
                                                                    : false
                                                            }
                                                        />
                                                        <span
                                                            style={{
                                                                color: 'black',
                                                                fontFamily: 'Arial, sans-serif',
                                                                fontStyle: 'normal',
                                                                textDecoration: 'none',
                                                                fontSize: 7,
                                                                textAlign: 'center',
                                                                marginTop: '0px',
                                                            }}
                                                        >
                                                            NO
                                                        </span>
                                                    </label>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div className='flex flex-row'>
                                        <table style={{ width: '183px' }}>
                                            <tr>
                                                <td
                                                    style={{
                                                        borderBottomWidth: 0.5,
                                                        borderLeftWidth: 0.5,
                                                        borderColor: 'black',
                                                        textAlign: 'center',
                                                        width: '85px',
                                                        height: '24px',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            fontWeight: 'bold',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '10px',
                                                        }}
                                                    >
                                                        NAME OF PERSON MET
                                                    </p>
                                                </td>
                                                <td
                                                    style={{
                                                        borderBottomWidth: 0.5,
                                                        borderLeftWidth: 0.5,
                                                        borderColor: 'black',
                                                        textAlign: 'center',
                                                        width: '85px',
                                                        height: '24px',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '10px',
                                                        }}
                                                    >
                                                        {(taskData && taskData.information.personMet) || 'N/A'}
                                                    </p>
                                                </td>
                                            </tr>
                                        </table>
                                        <table style={{ width: '183px' }}>
                                            <tr>
                                                <td
                                                    style={{
                                                        borderBottomWidth: 0.5,
                                                        borderLeftWidth: 0.5,
                                                        borderColor: 'black',
                                                        textAlign: 'center',
                                                        width: '85px',
                                                        height: '24px',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            fontWeight: 'bold',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '10px',
                                                        }}
                                                    >
                                                        DESIGNATION OF PERSON MET
                                                    </p>
                                                </td>
                                                <td
                                                    style={{
                                                        borderBottomWidth: 0.5,
                                                        borderLeftWidth: 0.5,
                                                        borderColor: 'black',
                                                        textAlign: 'center',
                                                        width: '85px',
                                                        height: '24px',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '10px',
                                                        }}
                                                    >
                                                        {(taskData &&
                                                            taskData.information.designationOfPersonMet) ||
                                                            'N/A'}
                                                    </p>
                                                </td>
                                            </tr>
                                        </table>
                                        <table style={{ width: '184px' }}>
                                            <tr>
                                                <td
                                                    style={{
                                                        borderBottomWidth: 0.5,
                                                        borderLeftWidth: 0.5,
                                                        borderColor: 'black',
                                                        textAlign: 'center',
                                                        width: '85px',
                                                        height: '24px',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            fontWeight: 'bold',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '10px',
                                                        }}
                                                    >
                                                        APPLICANT AGE (APPROX.)
                                                    </p>
                                                </td>
                                                <td
                                                    style={{
                                                        borderBottomWidth: 0.5,
                                                        borderRightWidth: 0.5,
                                                        borderLeftWidth: 0.5,
                                                        borderColor: 'black',
                                                        textAlign: 'center',
                                                        width: '85px',
                                                        height: '24px',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '10px',
                                                        }}
                                                    >
                                                        {(taskData && taskData.information.applicantAge) || 'N/A'}
                                                    </p>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <table style={{ width: '550px' }}>
                                        <tr>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'center',
                                                    width: '85px',
                                                    height: '12px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        fontWeight: 'bold',
                                                        textDecoration: 'none',
                                                        fontSize: 7,
                                                        textAlign: 'center',
                                                        marginTop: '10px',
                                                    }}
                                                >
                                                    ADDRESS CHANGE
                                                </p>
                                            </td>
                                            <td
                                                style={{
                                                    borderBottomWidth: 0.5,
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderColor: 'black',
                                                    textAlign: 'left',
                                                    width: '425px',
                                                    height: '12px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        color: 'black',
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontStyle: 'normal',
                                                        textDecoration: 'none',
                                                        fontSize: 7,
                                                        marginTop: '10px',
                                                        marginLeft: '20px',
                                                    }}
                                                >
                                                    {(taskData && taskData.information.addressChange) || 'N/A'}
                                                </p>
                                            </td>
                                        </tr>
                                    </table>
                                    {taskData && taskData.type === 'Office' && (
                                        <>
                                            <div className='flex flex-row'>
                                                <table style={{ width: '183px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                backgroundColor: '#BFBFBF',
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                height: '12px',
                                                            }}
                                                            colspan='6'
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                BUSINESS PREMISES OWNED BY
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                paddingRight: '10px',
                                                                paddingLeft: '10px',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.businessPremisesOwnedBy ===
                                                                            'Self'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    SELF
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.businessPremisesOwnedBy ===
                                                                            'Leased'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    LEASED
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.businessPremisesOwnedBy ===
                                                                            'Rented'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    RENTED
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.businessPremisesOwnedBy ===
                                                                            'Others'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    OTHERS
                                                                </span>
                                                            </label>

                                                            <table
                                                                style={{
                                                                    width: '100%',
                                                                    marginTop: '5px',
                                                                    marginBottom: '5px',
                                                                }}
                                                            >
                                                                <tr>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderWidth: 0.5,
                                                                            height: '12px',
                                                                        }}
                                                                        colspan={2}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontWeight: 'bold',
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            IF RENTED
                                                                        </p>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderBottomWidth: 0.5,
                                                                            borderRightWidth: 0.5,
                                                                            borderLeftWidth: 0.5,
                                                                            height: '12px',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontWeight: 'bold',
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            RENT AMOUNT
                                                                        </p>
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderBottomWidth: 0.5,
                                                                            borderRightWidth: 0.5,
                                                                            height: '12px',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            {(taskData &&
                                                                                taskData.information.rentAmount) ||
                                                                                'N/A'}
                                                                        </p>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderBottomWidth: 0.5,
                                                                            borderRightWidth: 0.5,
                                                                            borderLeftWidth: 0.5,
                                                                            height: '12px',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontWeight: 'bold',
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            NAME OF LANDLORD
                                                                        </p>
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderBottomWidth: 0.5,
                                                                            borderRightWidth: 0.5,
                                                                            height: '12px',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            {(taskData &&
                                                                                taskData.information.landlordName) ||
                                                                                'N/A'}
                                                                        </p>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table style={{ width: '183px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                backgroundColor: '#BFBFBF',
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                height: '12px',
                                                            }}
                                                            colspan='6'
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                EDUCATION QUALIFICATION
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                paddingRight: '10px',
                                                                paddingLeft: '10px',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.educationQualification ===
                                                                            'Metric'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    METRIC
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.educationQualification ===
                                                                            'Graduate'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    GRADUATE
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.educationQualification ===
                                                                            'Post Graduate'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    POST GRADUATE
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.educationQualification ===
                                                                            'Professional'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginBottom: '2px',
                                                                    }}
                                                                >
                                                                    PROFESSIONAL
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.educationQualification ===
                                                                            'Others'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    OTHERS
                                                                </span>
                                                            </label>
                                                            <table
                                                                style={{
                                                                    width: '100%',
                                                                    marginTop: '2px',
                                                                    marginBottom: '5px',
                                                                }}
                                                            >
                                                                <tr>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderWidth: 0.5,
                                                                            height: '12px',
                                                                        }}
                                                                        colspan={2}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontWeight: 'bold',
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            WORKING SINCE
                                                                        </p>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderBottomWidth: 0.5,
                                                                            borderRightWidth: 0.5,
                                                                            borderLeftWidth: 0.5,
                                                                            height: '12px',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            {(taskData &&
                                                                                taskData.information.workingSince) ||
                                                                                'N/A'}
                                                                        </p>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table style={{ width: '184px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                backgroundColor: '#BFBFBF',
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                height: '12px',
                                                            }}
                                                            colspan='6'
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                OCCUPATION TYPE
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                paddingRight: '10px',
                                                                paddingLeft: '10px',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.occupation === 'Salaried'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    SALARIED
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.occupation ===
                                                                            'Business / Self Employed'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    BUSINESS / SELF EMPLOYED
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.occupation === 'Others'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    OTHERS
                                                                </span>
                                                            </label>
                                                            <table
                                                                style={{
                                                                    width: '100%',
                                                                    marginTop: '5px',
                                                                    marginBottom: '5px',
                                                                }}
                                                            >
                                                                <tr>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderWidth: 0.5,
                                                                            height: '12px',
                                                                        }}
                                                                        colspan={2}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontWeight: 'bold',
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            IF SALARIED
                                                                        </p>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderBottomWidth: 0.5,
                                                                            borderRightWidth: 0.5,
                                                                            borderLeftWidth: 0.5,
                                                                            height: '20px',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontWeight: 'bold',
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            APPLICANT DESIGNATION
                                                                        </p>
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderBottomWidth: 0.5,
                                                                            borderRightWidth: 0.5,
                                                                            height: '12px',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            {(taskData &&
                                                                                taskData.information.applicantDesignation) ||
                                                                                'N/A'}
                                                                        </p>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderBottomWidth: 0.5,
                                                                            borderRightWidth: 0.5,
                                                                            borderLeftWidth: 0.5,
                                                                            height: '20px',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontWeight: 'bold',
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            APPLICANT DEPARTMENT
                                                                        </p>
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderBottomWidth: 0.5,
                                                                            borderRightWidth: 0.5,
                                                                            height: '12px',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            {(taskData &&
                                                                                taskData.information.applicantDepartment) ||
                                                                                'N/A'}
                                                                        </p>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <table style={{ width: '550px' }}>
                                                <tr>
                                                    <td
                                                        style={{
                                                            backgroundColor: '#BFBFBF',
                                                            textAlign: 'center',
                                                            borderColor: 'black',
                                                            borderBottomWidth: 0.5,
                                                            borderRightWidth: 0.5,
                                                            borderLeftWidth: 0.5,
                                                            height: '12px',
                                                        }}
                                                        colspan='6'
                                                    >
                                                        <p
                                                            style={{
                                                                marginTop: '10px',
                                                                color: 'black',
                                                                fontSize: 7,
                                                                fontWeight: 'bold',
                                                                fontFamily: 'Arial, sans-serif',
                                                                textDecoration: 'none',
                                                            }}
                                                        >
                                                            VERIFIER OBSERVATION
                                                        </p>
                                                    </td>
                                                </tr>
                                            </table>
                                            <div className='flex flex-row'>
                                                <table style={{ width: '183px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                height: '12px',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    color: 'black',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    fontStyle: 'normal',
                                                                    fontWeight: 'bold',
                                                                    textDecoration: 'none',
                                                                    fontSize: 7,
                                                                    textAlign: 'center',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                NAME BOARD SEEN
                                                            </p>
                                                        </td>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                height: '12px',
                                                                paddingLeft: '10px',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.nameBoardSeen === 'Yes'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    YES
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.nameBoardSeen === 'No'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    NO
                                                                </span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table style={{ width: '183px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                height: '12px',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    color: 'black',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    fontStyle: 'normal',
                                                                    fontWeight: 'bold',
                                                                    textDecoration: 'none',
                                                                    fontSize: 7,
                                                                    textAlign: 'center',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                NAME MENTIONED ON NAME BOARD
                                                            </p>
                                                        </td>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                height: '12px',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    color: 'black',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    fontStyle: 'normal',
                                                                    textDecoration: 'none',
                                                                    fontSize: 7,
                                                                    textAlign: 'center',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                {(taskData &&
                                                                    taskData.information.nameMentionedOnNameBoard) ||
                                                                    'N/A'}
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table style={{ width: '184px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                height: '12px',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    color: 'black',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    fontStyle: 'normal',
                                                                    fontWeight: 'bold',
                                                                    textDecoration: 'none',
                                                                    fontSize: 7,
                                                                    textAlign: 'center',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                AREA (IN SQUARE FEET)
                                                            </p>
                                                        </td>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                height: '12px',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    color: 'black',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    fontStyle: 'normal',
                                                                    textDecoration: 'none',
                                                                    fontSize: 7,
                                                                    textAlign: 'center',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                {(taskData && taskData.information.area) || 'N/A'}
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div className='flex flex-row'>
                                                <table style={{ width: '183px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                height: '12px',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    color: 'black',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    fontStyle: 'normal',
                                                                    fontWeight: 'bold',
                                                                    textDecoration: 'none',
                                                                    fontSize: 7,
                                                                    textAlign: 'center',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                FLOOR VISITED
                                                            </p>
                                                        </td>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                height: '12px',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    color: 'black',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    fontStyle: 'normal',
                                                                    textDecoration: 'none',
                                                                    fontSize: 7,
                                                                    textAlign: 'center',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                {(taskData && taskData.information.floorVisited) ||
                                                                    'N/A'}
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table style={{ width: '183px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                height: '12px',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    color: 'black',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    fontStyle: 'normal',
                                                                    fontWeight: 'bold',
                                                                    textDecoration: 'none',
                                                                    fontSize: 7,
                                                                    textAlign: 'center',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                COLOR OF BUILDING
                                                            </p>
                                                        </td>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                height: '12px',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    color: 'black',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    fontStyle: 'normal',
                                                                    textDecoration: 'none',
                                                                    fontSize: 7,
                                                                    textAlign: 'center',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                {(taskData && taskData.information.colorOfBuilding) ||
                                                                    'N/A'}
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table style={{ width: '184px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                height: '12px',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    color: 'black',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    fontStyle: 'normal',
                                                                    fontWeight: 'bold',
                                                                    textDecoration: 'none',
                                                                    fontSize: 7,
                                                                    textAlign: 'center',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                COLOR OF GATE
                                                            </p>
                                                        </td>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                height: '12px',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    color: 'black',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    fontStyle: 'normal',
                                                                    textDecoration: 'none',
                                                                    fontSize: 7,
                                                                    textAlign: 'center',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                {(taskData && taskData.information.colorOfGate) ||
                                                                    'N/A'}
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div className='flex flex-row' style={{ marginTop: '85px' }}>
                                                <table style={{ width: '183px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                backgroundColor: '#BFBFBF',
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                height: '12px',
                                                            }}
                                                            colspan='6'
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                TYPE OF ORGANISATION
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                paddingRight: '10px',
                                                                paddingLeft: '10px',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.typeOfOrganisation ===
                                                                            'Proprietorship'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '-5px',
                                                                    }}
                                                                >
                                                                    PROPRIETORSHIP
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.typeOfOrganisation ===
                                                                            'Partnership'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '-5px',
                                                                    }}
                                                                >
                                                                    PARTNERSHIP
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.typeOfOrganisation ===
                                                                            'Directorship'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '-5px',
                                                                    }}
                                                                >
                                                                    DIRECTORSHIP
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.typeOfOrganisation ===
                                                                            'Public Limited'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '-5px',
                                                                    }}
                                                                >
                                                                    PUBLIC LIMITED
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.typeOfOrganisation ===
                                                                            'Others'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '-5px',
                                                                    }}
                                                                >
                                                                    OTHERS
                                                                </span>
                                                            </label>

                                                            <table
                                                                style={{
                                                                    width: '100%',
                                                                    marginTop: '5px',
                                                                    marginBottom: '5px',
                                                                }}
                                                            >
                                                                <tr>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderWidth: 0.5,
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontWeight: 'bold',
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            IS ENTRY RESTRICTED
                                                                        </p>
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderRightWidth: 0.5,
                                                                            borderTopWidth: 0.5,
                                                                            borderBottomWidth: 0.5,
                                                                            paddingLeft: '8px',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <label
                                                                            style={{
                                                                                display: 'flex',
                                                                                flexDirection: 'row',
                                                                                alignItems: 'center',
                                                                                marginBottom: '2px',
                                                                            }}
                                                                        >
                                                                            <input
                                                                                style={{ marginRight: '8px', marginTop: '7px' }}
                                                                                type='checkbox'
                                                                                checked={
                                                                                    taskData.information.entryRestricted ===
                                                                                        'Yes'
                                                                                        ? true
                                                                                        : false
                                                                                }
                                                                            />
                                                                            <span
                                                                                style={{
                                                                                    color: 'black',
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    fontStyle: 'normal',
                                                                                    textDecoration: 'none',
                                                                                    fontSize: 7,
                                                                                    textAlign: 'center',
                                                                                    marginTop: '0px',
                                                                                }}
                                                                            >
                                                                                YES
                                                                            </span>
                                                                        </label>
                                                                        <label
                                                                            style={{
                                                                                display: 'flex',
                                                                                flexDirection: 'row',
                                                                                alignItems: 'center',
                                                                                marginBottom: '2px',
                                                                            }}
                                                                        >
                                                                            <input
                                                                                style={{ marginRight: '8px', marginTop: '7px' }}
                                                                                type='checkbox'
                                                                                checked={
                                                                                    taskData.information.entryRestricted ===
                                                                                        'No'
                                                                                        ? true
                                                                                        : false
                                                                                }
                                                                            />
                                                                            <span
                                                                                style={{
                                                                                    color: 'black',
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    fontStyle: 'normal',
                                                                                    textDecoration: 'none',
                                                                                    fontSize: 7,
                                                                                    textAlign: 'center',
                                                                                    marginTop: '0px',
                                                                                }}
                                                                            >
                                                                                NO
                                                                            </span>
                                                                        </label>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table style={{ width: '183px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                backgroundColor: '#BFBFBF',
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                height: '12px',
                                                            }}
                                                            colspan='6'
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                NATURE OF BUSINESS
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                paddingRight: '10px',
                                                                paddingLeft: '10px',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    marginTop: '0px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.natureOfBusiness ===
                                                                            'Manufacturing'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    MANUFACTURING
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.natureOfBusiness ===
                                                                            'Trading'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    TRADING
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.natureOfBusiness ===
                                                                            'Services'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    SERVICES
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.natureOfBusiness ===
                                                                            'Consultancy'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    CONSULTANCY
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.natureOfBusiness === 'Others'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    OTHERS
                                                                </span>
                                                            </label>
                                                            <table
                                                                style={{
                                                                    width: '100%',
                                                                    marginTop: '2px',
                                                                    marginBottom: '5px',
                                                                }}
                                                            >
                                                                <tr>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderWidth: 0.5,
                                                                            height: '12px',
                                                                        }}
                                                                        colspan={2}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontWeight: 'bold',
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            DETAILS
                                                                        </p>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderBottomWidth: 0.5,
                                                                            borderRightWidth: 0.5,
                                                                            borderLeftWidth: 0.5,
                                                                            height: '12px',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            {(taskData &&
                                                                                taskData.information
                                                                                    .natureOfBusinessDetails) ||
                                                                                'N/A'}
                                                                        </p>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table style={{ width: '183px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                backgroundColor: '#BFBFBF',
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                height: '12px',
                                                            }}
                                                            colspan='6'
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                DETAILS OF ID PROOF
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                paddingRight: '10px',
                                                                paddingLeft: '10px',
                                                            }}
                                                        >
                                                            <table
                                                                style={{
                                                                    width: '100%',
                                                                    marginTop: '5px',
                                                                    marginBottom: '5px',
                                                                    marginTop: '-55px',
                                                                }}
                                                            >
                                                                <tr>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderLeftWidth: 0.5,
                                                                            borderTopWidth: 0.5,
                                                                            borderBottomWidth: 0.5,
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontWeight: 'bold',
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            ID SEEN
                                                                        </p>
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderWidth: 0.5,
                                                                            borderRightColor: 'black',
                                                                            paddingLeft: '8px',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <label
                                                                            style={{
                                                                                display: 'flex',
                                                                                flexDirection: 'row',
                                                                                alignItems: 'center',
                                                                                marginBottom: '2px',
                                                                            }}
                                                                        >
                                                                            <input
                                                                                style={{ marginRight: '8px', marginTop: '7px' }}
                                                                                type='checkbox'
                                                                                checked={
                                                                                    taskData.information.idSeen === 'Yes'
                                                                                        ? true
                                                                                        : false
                                                                                }
                                                                            />
                                                                            <span
                                                                                style={{
                                                                                    color: 'black',
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    fontStyle: 'normal',
                                                                                    textDecoration: 'none',
                                                                                    fontSize: 7,
                                                                                    textAlign: 'center',
                                                                                    marginTop: '0px',
                                                                                }}
                                                                            >
                                                                                YES
                                                                            </span>
                                                                        </label>
                                                                        <label
                                                                            style={{
                                                                                display: 'flex',
                                                                                flexDirection: 'row',
                                                                                alignItems: 'center',
                                                                                marginBottom: '2px',
                                                                            }}
                                                                        >
                                                                            <input
                                                                                style={{ marginRight: '8px', marginTop: '7px' }}
                                                                                type='checkbox'
                                                                                checked={
                                                                                    taskData.information.idSeen === 'No'
                                                                                        ? true
                                                                                        : false
                                                                                }
                                                                            />
                                                                            <span
                                                                                style={{
                                                                                    color: 'black',
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    fontStyle: 'normal',
                                                                                    textDecoration: 'none',
                                                                                    fontSize: 7,
                                                                                    textAlign: 'center',
                                                                                    marginTop: '0px',
                                                                                }}
                                                                            >
                                                                                NO
                                                                            </span>
                                                                        </label>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderBottomWidth: 0.5,
                                                                            borderRightWidth: 0.5,
                                                                            borderLeftWidth: 0.5,
                                                                            height: '12px',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontWeight: 'bold',
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            ID TYPE (IF YES)
                                                                        </p>
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderBottomWidth: 0.5,
                                                                            borderRightWidth: 0.5,
                                                                            height: '12px',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            {(taskData &&
                                                                                taskData.information.idProofType) ||
                                                                                'N/A'}
                                                                        </p>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div className='flex flex-row'>
                                                <table style={{ width: '183px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                backgroundColor: '#BFBFBF',
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                height: '12px',
                                                            }}
                                                            colspan='6'
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                TYPE OF OFFICE
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                paddingRight: '10px',
                                                                paddingLeft: '10px',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.typeOfOffice ===
                                                                            'Office Building'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    OFFICE BUILDING
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.typeOfOffice ===
                                                                            'Converted Flat'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    CONVERTED FLAT
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.typeOfOffice === 'Shop'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    SHOP
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.typeOfOffice === 'Residence'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    RESIDENCE
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.typeOfOffice === 'Factory'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    FACTORY
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.typeOfOffice === 'Godown'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    GODOWN
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.typeOfOffice ===
                                                                            'Residence Cum Office'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    RESIDENCE CUM OFFICE
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.typeOfOffice ===
                                                                            'Temporary Shed'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    TEMPORARY SHED
                                                                </span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table style={{ width: '183px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                backgroundColor: '#BFBFBF',
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                height: '12px',
                                                            }}
                                                            colspan='6'
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                LOCALITY STATUS
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                paddingRight: '10px',
                                                                paddingLeft: '10px',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    marginTop: '-45px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.localityStatus ===
                                                                            'Residential'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    RESIDENTIAL
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.localityStatus ===
                                                                            'Commercial'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    COMMERCIAL
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.localityStatus ===
                                                                            'Residential Cum Commercial'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    RESIDENTIAL CUM COMMERCIAL
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.localityStatus ===
                                                                            'Industrial'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    INDUSTRIAL
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.localityStatus === 'Slum'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    SLUM
                                                                </span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table style={{ width: '184px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                backgroundColor: '#BFBFBF',
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                height: '12px',
                                                            }}
                                                            colspan='6'
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                LOCALITY TYPE
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                paddingRight: '10px',
                                                                paddingLeft: '10px',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    marginTop: '-30px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.localityType === 'Posh'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    POSH
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.localityType ===
                                                                            'Upper Middle Class'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    UPPER MIDDLE CLASS
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.localityType ===
                                                                            'Middle Class'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    MIDDLE CLASS
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.localityType ===
                                                                            'Lower Middle Class'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    LOWER MIDDLE CLASS
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.localityType ===
                                                                            'Village Area'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    VILLAGE AREA
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.localityType ===
                                                                            'Remote Area'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    REMOTE
                                                                </span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div className='flex flex-row'>
                                                <table style={{ width: '183px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                backgroundColor: '#BFBFBF',
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                height: '12px',
                                                            }}
                                                            colspan='6'
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                LEVEL OF ACTIVITY
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                paddingRight: '10px',
                                                                paddingLeft: '10px',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.levelOfActivity ===
                                                                            'Very High'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    VERY HIGH
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.levelOfActivity === 'High'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    HIGH
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.levelOfActivity === 'Medium'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    MEDIUM
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.levelOfActivity === 'Low'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    LOW
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.levelOfActivity === 'None'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    NONE
                                                                </span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table style={{ width: '183px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                backgroundColor: '#BFBFBF',
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                height: '12px',
                                                            }}
                                                            colspan='6'
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                STOCK SEEN
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                paddingRight: '10px',
                                                                paddingLeft: '10px',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.stockSeen === 'Heavy'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    HEAVY
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.stockSeen === 'Average'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    AVERAGE
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.stockSeen === 'Low'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    LOW
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.stockSeen === 'No Stock'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    NO STOCK
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.stockSeen ===
                                                                            'Not Applicable'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    NOT APPLICABLE
                                                                </span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table style={{ width: '184px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                backgroundColor: '#BFBFBF',
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                height: '12px',
                                                            }}
                                                            colspan='6'
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                FURNISHING OF OFFICE
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                paddingRight: '10px',
                                                                paddingLeft: '10px',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.furnishingOfOffice ===
                                                                            'Excellent'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    EXCELLENT
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.furnishingOfOffice === 'Good'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    GOOD
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.furnishingOfOffice ===
                                                                            'Average'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    AVERAGE
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.furnishingOfOffice === 'Poor'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    POOR
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.furnishingOfOffice ===
                                                                            'Door Step Verification'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    DOOR STEP VERIFICATION
                                                                </span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div className='flex flex-row'>
                                                <table style={{ width: '183px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                backgroundColor: '#BFBFBF',
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                height: '12px',
                                                            }}
                                                            colspan='6'
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                EMPLOYEES
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                paddingRight: '10px',
                                                                paddingLeft: '10px',
                                                            }}
                                                        >
                                                            <table
                                                                style={{
                                                                    width: '100%',
                                                                    marginTop: '5px',
                                                                    marginBottom: '5px',
                                                                }}
                                                            >
                                                                <tr>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderWidth: 0.5,
                                                                            height: '12px',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontWeight: 'bold',
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            TOTAL EMPLOYEES
                                                                        </p>
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderTopWidth: 0.5,
                                                                            borderBottomWidth: 0.5,
                                                                            borderRightWidth: 0.5,
                                                                            height: '12px',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            {(taskData &&
                                                                                taskData.information.totalEmployees) ||
                                                                                'N/A'}
                                                                        </p>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderBottomWidth: 0.5,
                                                                            borderRightWidth: 0.5,
                                                                            borderLeftWidth: 0.5,
                                                                            height: '12px',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontWeight: 'bold',
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            EMPLOYEES SEEN
                                                                        </p>
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderBottomWidth: 0.5,
                                                                            borderRightWidth: 0.5,
                                                                            height: '12px',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            {(taskData &&
                                                                                taskData.information.employeesSeen) ||
                                                                                'N/A'}
                                                                        </p>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table style={{ width: '367px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                backgroundColor: '#BFBFBF',
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                height: '12px',
                                                            }}
                                                            colspan='6'
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                ASSET SEEN
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                paddingRight: '10px',
                                                                paddingLeft: '10px',
                                                                display: 'flex',
                                                                flexWrap: 'wrap',
                                                                rowGap: '4px',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    width: '110px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.computerChecked === true
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    COMPUTER
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    width: '110px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.laptopChecked === true
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    LAPTOP
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    width: '110px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.airConditionerChecked === true
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    AIR CONDITIONER
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    width: '110px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.telephoneChecked === true
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    TELEPHONE
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    width: '110px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.faxChecked === true ? true : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    FAX
                                                                </span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div
                                                className='flex flex-col'
                                                style={{ width: '100%', height: '100px' }}
                                            ></div>
                                            <div className='flex flex-row' style={{ marginTop: '30px' }}>
                                                <table style={{ width: '183px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                backgroundColor: '#BFBFBF',
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderWidth: 0.5,
                                                                height: '12px',
                                                            }}
                                                            colspan='6'
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                LOCATING THE ADDRESS
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                paddingRight: '10px',
                                                                paddingLeft: '10px',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.locatingTheAddress === 'Easy'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    EASY
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.locatingTheAddress ===
                                                                            'Difficult'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    DIFFICULT
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px', marginTop: '7px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.locatingTheAddress ===
                                                                            'Landmark Required'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '0px',
                                                                    }}
                                                                >
                                                                    LANDMARK REQUIRED
                                                                </span>
                                                            </label>

                                                            <table
                                                                style={{
                                                                    width: '100%',
                                                                    marginTop: '5px',
                                                                    marginBottom: '5px',
                                                                }}
                                                            >
                                                                <tr>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderWidth: 0.5,
                                                                            height: '12px',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontWeight: 'bold',
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            LANDMARK
                                                                        </p>
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderTopWidth: 0.5,
                                                                            borderBottomWidth: 0.5,
                                                                            borderRightWidth: 0.5,
                                                                            height: '12px',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            {(taskData && taskData.information.landmark) ||
                                                                                'N/A'}
                                                                        </p>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table style={{ width: '367px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                backgroundColor: '#BFBFBF',
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderTopWidth: 0.5,
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                height: '12px',
                                                            }}
                                                            colspan='6'
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                NEIGHBOUR / COLLEAGUE INFORMATION
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                paddingRight: '10px',
                                                                paddingLeft: '10px',
                                                            }}
                                                        >
                                                            <div className='flex flex-row justify-between'>
                                                                <table style={{ width: '100%' }}>
                                                                    <tr>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontWeight: 'bold',
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                NAME
                                                                            </p>
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderTopWidth: 0.5,
                                                                                borderBottomWidth: 0.5,
                                                                                borderRightWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                {(taskData &&
                                                                                    taskData.information.firstNeighbourName) ||
                                                                                    'N/A'}
                                                                            </p>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderBottomWidth: 0.5,
                                                                                borderRightWidth: 0.5,
                                                                                borderLeftWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontWeight: 'bold',
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                AGE (APPROX.)
                                                                            </p>
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderBottomWidth: 0.5,
                                                                                borderRightWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                {(taskData &&
                                                                                    taskData.information.firstNeighbourAge) ||
                                                                                    'N/A'}
                                                                            </p>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderBottomWidth: 0.5,
                                                                                borderRightWidth: 0.5,
                                                                                borderLeftWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontWeight: 'bold',
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                ADDRESS
                                                                            </p>
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderBottomWidth: 0.5,
                                                                                borderRightWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                {(taskData &&
                                                                                    taskData.information
                                                                                        .firstNeighbourAddress) ||
                                                                                    'N/A'}
                                                                            </p>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderBottomWidth: 0.5,
                                                                                borderRightWidth: 0.5,
                                                                                borderLeftWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontWeight: 'bold',
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                FEEDBACK
                                                                            </p>
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderBottomWidth: 0.5,
                                                                                borderRightWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                {(taskData &&
                                                                                    taskData.information
                                                                                        .firstNeighbourFeedback) ||
                                                                                    'N/A'}
                                                                            </p>
                                                                        </td>
                                                                    </tr>
                                                                </table>
                                                                <div
                                                                    style={{
                                                                        width: 0.5,
                                                                        backgroundColor: 'black',
                                                                        height: '65px',
                                                                        marginLeft: '5px',
                                                                        marginRight: '5px',
                                                                    }}
                                                                ></div>
                                                                <table style={{ width: '100%' }}>
                                                                    <tr>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontWeight: 'bold',
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                NAME
                                                                            </p>
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderTopWidth: 0.5,
                                                                                borderBottomWidth: 0.5,
                                                                                borderRightWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                {(taskData &&
                                                                                    taskData.information.secondNeighbourName) ||
                                                                                    'N/A'}
                                                                            </p>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderBottomWidth: 0.5,
                                                                                borderRightWidth: 0.5,
                                                                                borderLeftWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontWeight: 'bold',
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                AGE (APPROX.)
                                                                            </p>
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderBottomWidth: 0.5,
                                                                                borderRightWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                {(taskData &&
                                                                                    taskData.information.secondNeighbourAge) ||
                                                                                    'N/A'}
                                                                            </p>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderBottomWidth: 0.5,
                                                                                borderRightWidth: 0.5,
                                                                                borderLeftWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontWeight: 'bold',
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                ADDRESS
                                                                            </p>
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderBottomWidth: 0.5,
                                                                                borderRightWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                {(taskData &&
                                                                                    taskData.information
                                                                                        .secondNeighbourAddress) ||
                                                                                    'N/A'}
                                                                            </p>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderBottomWidth: 0.5,
                                                                                borderRightWidth: 0.5,
                                                                                borderLeftWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontWeight: 'bold',
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                FEEDBACK
                                                                            </p>
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderBottomWidth: 0.5,
                                                                                borderRightWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                {(taskData &&
                                                                                    taskData.information
                                                                                        .secondNeighbourFeedback) ||
                                                                                    'N/A'}
                                                                            </p>
                                                                        </td>
                                                                    </tr>
                                                                </table>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </>
                                    )}
                                    {taskData && taskData.type === 'Residence' && (
                                        <>
                                            <div className='flex flex-row'>
                                                <table style={{ width: '275px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                backgroundColor: '#BFBFBF',
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                height: '12px',
                                                            }}
                                                            colspan='6'
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                RESIDENCE OWNED BY
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '100%',
                                                                paddingRight: '10px',
                                                                paddingLeft: '10px',
                                                                display: 'flex',
                                                                flexWrap: 'wrap',
                                                                rowGap: '2px',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    width: '125px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.residenceOwnedBy === 'Self'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    SELF
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    width: '125px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.residenceOwnedBy ===
                                                                            'Owned By Parents'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    OWNED BY PARENTS
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    width: '125px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.residenceOwnedBy ===
                                                                            'Owned By Spouse'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    OWNED BY SPOUSE
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    width: '125px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.residenceOwnedBy ===
                                                                            'Company Alloted'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    COMPANY ALLOTED
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    width: '125px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.residenceOwnedBy === 'Rented'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    RENTED
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    width: '125px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.residenceOwnedBy === 'Others'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    OTHERS
                                                                </span>
                                                            </label>
                                                            <table
                                                                style={{
                                                                    width: '100%',
                                                                    marginTop: '5px',
                                                                    marginBottom: '5px',
                                                                }}
                                                            >
                                                                <tr>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderTopWidth: 0.5,
                                                                            borderRightWidth: 0.5,
                                                                            borderLeftWidth: 0.5,
                                                                            height: '12px',
                                                                            width: '50%',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontWeight: 'bold',
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            IF OTHERS
                                                                        </p>
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderTopWidth: 0.5,
                                                                            borderRightWidth: 0.5,
                                                                            height: '12px',
                                                                            width: '50%',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            {(taskData &&
                                                                                taskData.information
                                                                                    .residenceOwnedByDetails) ||
                                                                                'N/A'}
                                                                        </p>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderWidth: 0.5,
                                                                            height: '12px',
                                                                        }}
                                                                        colspan={2}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontWeight: 'bold',
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            IF RENTED
                                                                        </p>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderBottomWidth: 0.5,
                                                                            borderRightWidth: 0.5,
                                                                            borderLeftWidth: 0.5,
                                                                            height: '12px',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontWeight: 'bold',
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            RENT AMOUNT
                                                                        </p>
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderBottomWidth: 0.5,
                                                                            borderRightWidth: 0.5,
                                                                            height: '12px',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            {(taskData &&
                                                                                taskData.information.rentAmount) ||
                                                                                'N/A'}
                                                                        </p>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderBottomWidth: 0.5,
                                                                            borderRightWidth: 0.5,
                                                                            borderLeftWidth: 0.5,
                                                                            height: '12px',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontWeight: 'bold',
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            NAME OF LANDLORD
                                                                        </p>
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderBottomWidth: 0.5,
                                                                            borderRightWidth: 0.5,
                                                                            height: '12px',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            {(taskData &&
                                                                                taskData.information.landlordName) ||
                                                                                'N/A'}
                                                                        </p>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table style={{ width: '275px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                backgroundColor: '#BFBFBF',
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                height: '12px',
                                                            }}
                                                            colspan='6'
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                EDUCATION QUALIFICATION
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '100%',
                                                                paddingRight: '10px',
                                                                paddingLeft: '10px',
                                                                display: 'flex',
                                                                flexWrap: 'wrap',
                                                                rowGap: '2px',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    width: '125px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.educationQualification ===
                                                                            'Metric'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    METRIC
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    width: '125px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.educationQualification ===
                                                                            'Graduate'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    GRADUATE
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    width: '125px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.educationQualification ===
                                                                            'Post Graduate'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    POST GRADUATE
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    width: '125px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.educationQualification ===
                                                                            'Professional'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    PROFESSIONAL
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    width: '125px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.educationQualification ===
                                                                            'Others'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    OTHERS
                                                                </span>
                                                            </label>
                                                            <table
                                                                style={{
                                                                    width: '100%',
                                                                    marginTop: '5px',
                                                                    marginBottom: '5px',
                                                                }}
                                                            >
                                                                <tr>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderWidth: 0.5,
                                                                            height: '48px',
                                                                            width: '50%',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontWeight: 'bold',
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            TENURE OF STAY
                                                                        </p>
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderTopWidth: 0.5,
                                                                            borderBottomWidth: 0.5,
                                                                            borderRightWidth: 0.5,
                                                                            height: '48px',
                                                                            width: '50%',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            {(taskData &&
                                                                                taskData.information.tenureOfStay) ||
                                                                                'N/A'}
                                                                        </p>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <table style={{ width: '550px' }}>
                                                <tr>
                                                    <td
                                                        style={{
                                                            backgroundColor: '#BFBFBF',
                                                            textAlign: 'center',
                                                            borderColor: 'black',
                                                            borderBottomWidth: 0.5,
                                                            borderRightWidth: 0.5,
                                                            borderLeftWidth: 0.5,
                                                            height: '12px',
                                                        }}
                                                        colspan='6'
                                                    >
                                                        <p
                                                            style={{
                                                                marginTop: '10px',
                                                                color: 'black',
                                                                fontSize: 7,
                                                                fontWeight: 'bold',
                                                                fontFamily: 'Arial, sans-serif',
                                                                textDecoration: 'none',
                                                            }}
                                                        >
                                                            APPLICANT'S FAMILY DETAILS
                                                        </p>
                                                    </td>
                                                </tr>
                                            </table>
                                            <div className='flex flex-row'>
                                                <table style={{ width: '183px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderRightWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                borderBottomWidth: 0.5,
                                                                height: '12px',
                                                                width: '50%',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                MARITAL STATUS
                                                            </p>
                                                        </td>
                                                        <td
                                                            style={{
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                height: '12px',
                                                                width: '50%',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    marginLeft: '8px',
                                                                    marginTop: '-4px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.maritalStatus === 'Single'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    SINGLE
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    marginLeft: '8px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.maritalStatus === 'Married'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    MARRIED
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    marginLeft: '8px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.maritalStatus === 'Divorced'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    DIVORCED
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    marginLeft: '8px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.maritalStatus === 'Widowed'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    WIDOWED
                                                                </span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderRightWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                borderBottomWidth: 0.5,
                                                                height: '20px',
                                                                width: '50%',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                NUMBER OF FAMILY MEMBERS
                                                            </p>
                                                        </td>
                                                        <td
                                                            style={{
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                height: '20px',
                                                                width: '50%',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                {(taskData &&
                                                                    taskData.information.numberOfFamilyMembers) ||
                                                                    'N/A'}
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderRightWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                borderBottomWidth: 0.5,
                                                                height: '20px',
                                                                width: '50%',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                NUMBER OF DEPENDENTS
                                                            </p>
                                                        </td>
                                                        <td
                                                            style={{
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                height: '20px',
                                                                width: '50%',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                {(taskData &&
                                                                    taskData.information.numberOfDependents) ||
                                                                    'N/A'}
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table style={{ width: '183px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderRightWidth: 0.5,
                                                                borderBottomWidth: 0.5,
                                                                height: '12px',
                                                                width: '50%',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                TYPE OF FAMILY
                                                            </p>
                                                        </td>
                                                        <td
                                                            style={{
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                height: '12px',
                                                                width: '50%',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    marginLeft: '4px',
                                                                    marginTop: '-8px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.typeOfFamily ===
                                                                            'Nuclear Family'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    NUCLEAR FAMILY
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    marginLeft: '4px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.typeOfFamily ===
                                                                            'Joint Family'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    JOINT FAMILY
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    marginLeft: '4px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.typeOfFamily === 'Bachelor'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    BACHELOR
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    marginLeft: '4px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.typeOfFamily ===
                                                                            'Paying Guest'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    PAYING GUEST
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    marginLeft: '4px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.typeOfFamily === 'Others'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    OTHERS
                                                                </span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderRightWidth: 0.5,
                                                                borderBottomWidth: 0.5,
                                                                height: '20px',
                                                                width: '50%',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                IF OTHERS
                                                            </p>
                                                        </td>
                                                        <td
                                                            style={{
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                height: '20px',
                                                                width: '50%',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                {(taskData &&
                                                                    taskData.information.typeOfFamilyDetails) ||
                                                                    'N/A'}
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table style={{ width: '184px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderRightWidth: 0.5,
                                                                borderBottomWidth: 0.5,
                                                                height: '12px',
                                                                width: '50%',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                OCCUPATION
                                                            </p>
                                                        </td>
                                                        <td
                                                            style={{
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                height: '12px',
                                                                width: '50%',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    marginLeft: '4px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.occupation === 'Private Job'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    PRIVATE JOB
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    marginLeft: '4px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.occupation ===
                                                                            'Government Job'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    GOVT JOB
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    marginLeft: '4px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.occupation ===
                                                                            'Self Employed'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    SELF EMPLOYED
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    marginLeft: '4px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.occupation === 'Student'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    STUDENT
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    marginLeft: '4px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.occupation === 'House Wife'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    HOUSE WIFE
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    marginLeft: '4px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.occupation === 'Others'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    OTHERS
                                                                </span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderRightWidth: 0.5,
                                                                borderBottomWidth: 0.5,
                                                                height: '20px',
                                                                width: '50%',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                IF OTHERS
                                                            </p>
                                                        </td>
                                                        <td
                                                            style={{
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                height: '20px',
                                                                width: '50%',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                {(taskData &&
                                                                    taskData.information.occupationDetails) ||
                                                                    'N/A'}
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <table style={{ width: '550px' }}>
                                                <tr>
                                                    <td
                                                        style={{
                                                            backgroundColor: '#BFBFBF',
                                                            textAlign: 'center',
                                                            borderColor: 'black',
                                                            borderBottomWidth: 0.5,
                                                            borderRightWidth: 0.5,
                                                            borderLeftWidth: 0.5,
                                                            height: '12px',
                                                        }}
                                                        colspan='6'
                                                    >
                                                        <p
                                                            style={{
                                                                marginTop: '10px',
                                                                color: 'black',
                                                                fontSize: 7,
                                                                fontWeight: 'bold',
                                                                fontFamily: 'Arial, sans-serif',
                                                                textDecoration: 'none',
                                                            }}
                                                        >
                                                            VERIFIER OBSERVATION
                                                        </p>
                                                    </td>
                                                </tr>
                                            </table>
                                            <div className='flex flex-row'>
                                                <table style={{ width: '183px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                height: '12px',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    color: 'black',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    fontStyle: 'normal',
                                                                    fontWeight: 'bold',
                                                                    textDecoration: 'none',
                                                                    fontSize: 7,
                                                                    textAlign: 'center',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                NAME PLATE SEEN
                                                            </p>
                                                        </td>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                height: '12px',
                                                                paddingLeft: '10px',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.namePlateSeen === 'Yes'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    YES
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.namePlateSeen === 'No'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    NO
                                                                </span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table style={{ width: '183px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                height: '12px',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    color: 'black',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    fontStyle: 'normal',
                                                                    fontWeight: 'bold',
                                                                    textDecoration: 'none',
                                                                    fontSize: 7,
                                                                    textAlign: 'center',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                NAME MENTIONED ON NAME PLATE
                                                            </p>
                                                        </td>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                height: '12px',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    color: 'black',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    fontStyle: 'normal',
                                                                    textDecoration: 'none',
                                                                    fontSize: 7,
                                                                    textAlign: 'center',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                {(taskData &&
                                                                    taskData.information.nameMentionedOnNamePlate) ||
                                                                    'N/A'}
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table style={{ width: '184px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                height: '12px',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    color: 'black',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    fontStyle: 'normal',
                                                                    fontWeight: 'bold',
                                                                    textDecoration: 'none',
                                                                    fontSize: 7,
                                                                    textAlign: 'center',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                AREA (IN SQUARE FEET)
                                                            </p>
                                                        </td>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                height: '12px',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    color: 'black',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    fontStyle: 'normal',
                                                                    textDecoration: 'none',
                                                                    fontSize: 7,
                                                                    textAlign: 'center',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                {(taskData && taskData.information.area) || 'N/A'}
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div className='flex flex-row'>
                                                <table style={{ width: '183px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                height: '12px',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    color: 'black',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    fontStyle: 'normal',
                                                                    fontWeight: 'bold',
                                                                    textDecoration: 'none',
                                                                    fontSize: 7,
                                                                    textAlign: 'center',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                FLOOR VISITED
                                                            </p>
                                                        </td>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                height: '12px',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    color: 'black',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    fontStyle: 'normal',
                                                                    textDecoration: 'none',
                                                                    fontSize: 7,
                                                                    textAlign: 'center',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                {(taskData && taskData.information.floorVisited) ||
                                                                    'N/A'}
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table style={{ width: '183px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                height: '12px',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    color: 'black',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    fontStyle: 'normal',
                                                                    fontWeight: 'bold',
                                                                    textDecoration: 'none',
                                                                    fontSize: 7,
                                                                    textAlign: 'center',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                COLOR OF BUILDING
                                                            </p>
                                                        </td>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                height: '12px',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    color: 'black',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    fontStyle: 'normal',
                                                                    textDecoration: 'none',
                                                                    fontSize: 7,
                                                                    textAlign: 'center',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                {(taskData && taskData.information.colorOfBuilding) ||
                                                                    'N/A'}
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table style={{ width: '184px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                height: '12px',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    color: 'black',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    fontStyle: 'normal',
                                                                    fontWeight: 'bold',
                                                                    textDecoration: 'none',
                                                                    fontSize: 7,
                                                                    textAlign: 'center',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                COLOR OF GATE
                                                            </p>
                                                        </td>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                height: '12px',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    color: 'black',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    fontStyle: 'normal',
                                                                    textDecoration: 'none',
                                                                    fontSize: 7,
                                                                    textAlign: 'center',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                {(taskData && taskData.information.colorOfGate) ||
                                                                    'N/A'}
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <table style={{ width: '550px' }}>
                                                <tr>
                                                    <td
                                                        style={{
                                                            backgroundColor: '#BFBFBF',
                                                            textAlign: 'center',
                                                            borderColor: 'black',
                                                            borderBottomWidth: 0.5,
                                                            borderRightWidth: 0.5,
                                                            borderLeftWidth: 0.5,
                                                            height: '12px',
                                                        }}
                                                        colspan='6'
                                                    >
                                                        <p
                                                            style={{
                                                                marginTop: '10px',
                                                                color: 'black',
                                                                fontSize: 7,
                                                                fontWeight: 'bold',
                                                                fontFamily: 'Arial, sans-serif',
                                                                textDecoration: 'none',
                                                            }}
                                                        >
                                                            DETAILS OF ADDRESS AND ID PROOF
                                                        </p>
                                                    </td>
                                                </tr>
                                            </table>
                                            <div className='flex flex-row'>
                                                <table style={{ width: '275px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderRightWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                borderBottomWidth: 0.5,
                                                                height: '12px',
                                                                width: '50%',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                ID SEEN
                                                            </p>
                                                        </td>
                                                        <td
                                                            style={{
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                height: '12px',
                                                                width: '50%',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    marginLeft: '8px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.idSeen === 'Yes'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    YES
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    marginLeft: '8px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.idSeen === 'No'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    NO
                                                                </span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderRightWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                borderBottomWidth: 0.5,
                                                                height: '20px',
                                                                width: '50%',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                ID PROOF TYPE
                                                            </p>
                                                        </td>
                                                        <td
                                                            style={{
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                height: '20px',
                                                                width: '50%',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                {(taskData && taskData.information.idProofType) ||
                                                                    'N/A'}
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table style={{ width: '275px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderRightWidth: 0.5,
                                                                borderBottomWidth: 0.5,
                                                                height: '12px',
                                                                width: '50%',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                ADDRESS PROOF SEEN
                                                            </p>
                                                        </td>
                                                        <td
                                                            style={{
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                height: '12px',
                                                                width: '50%',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    marginLeft: '8px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.addressProofSeen === 'Yes'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    YES
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    marginLeft: '8px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.addressProofSeen === 'No'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    NO
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    marginLeft: '8px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.addressProofSeen ===
                                                                            'Same as ID Proof'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    SAME AS ID PROOF
                                                                </span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderRightWidth: 0.5,
                                                                borderBottomWidth: 0.5,
                                                                height: '20px',
                                                                width: '50%',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                ADDRESS PROOF TYPE
                                                            </p>
                                                        </td>
                                                        <td
                                                            style={{
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                height: '20px',
                                                                width: '50%',
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                {(taskData &&
                                                                    taskData.information.addressProofType) ||
                                                                    'N/A'}
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div className='flex flex-row'>
                                                <table style={{ width: '183px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                backgroundColor: '#BFBFBF',
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                height: '12px',
                                                            }}
                                                            colspan='6'
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                TYPE OF HOUSE
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                paddingRight: '10px',
                                                                paddingLeft: '10px',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.typeOfHouse ===
                                                                            'Independent House'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    INDEPENDENT HOUSE
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.typeOfHouse === 'Flat'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    FLAT
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.typeOfHouse === 'Bunglow'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    BUNGLOW
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.typeOfHouse ===
                                                                            'Part of Independent House'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    PART OF INDEPENDENT HOUSE
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.typeOfHouse ===
                                                                            'Simple House'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    SIMPLE HOUSE
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.typeOfHouse === 'Chawl'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    CHAWL
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.typeOfHouse === 'Slum'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    SLUM
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.typeOfHouse ===
                                                                            'Temporary Shed'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    TEMPORARY SHED
                                                                </span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table style={{ width: '183px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                backgroundColor: '#BFBFBF',
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                height: '12px',
                                                            }}
                                                            colspan='6'
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                LOCALITY STATUS
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                paddingRight: '10px',
                                                                paddingLeft: '10px',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    marginTop: '-60px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.localityStatus ===
                                                                            'Residential'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    RESIDENTIAL
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.localityStatus ===
                                                                            'Commercial'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    COMMERCIAL
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.localityStatus ===
                                                                            'Residential Cum Commercial'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    RESIDENTIAL CUM COMMERCIAL
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.localityStatus ===
                                                                            'Industrial'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    INDUSTRIAL
                                                                </span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table style={{ width: '184px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                backgroundColor: '#BFBFBF',
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                height: '12px',
                                                            }}
                                                            colspan='6'
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                LOCALITY TYPE
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                paddingRight: '10px',
                                                                paddingLeft: '10px',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    marginTop: '-30px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.localityType === 'Posh'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    POSH
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.localityType ===
                                                                            'Upper Middle Class'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    UPPER MIDDLE CLASS
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.localityType ===
                                                                            'Middle Class'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    MIDDLE CLASS
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.localityType ===
                                                                            'Lower Middle Class'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    LOWER MIDDLE CLASS
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.localityType === 'Slum'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    SLUM
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.localityType ===
                                                                            'Village Area'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    VILLAGE AREA
                                                                </span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div className='flex flex-row' style={{ marginBottom: '50px' }}>
                                                <table style={{ width: '183px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                backgroundColor: '#BFBFBF',
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                height: '12px',
                                                            }}
                                                            colspan='6'
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                FURNISHING OF THE HOUSE
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                paddingRight: '10px',
                                                                paddingLeft: '10px',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.furnishingOfTheHouse ===
                                                                            'Excellent'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    EXCELLENT
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.furnishingOfTheHouse ===
                                                                            'Good'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    GOOD
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.furnishingOfTheHouse ===
                                                                            'Average'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    AVERAGE
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.furnishingOfTheHouse ===
                                                                            'Poor'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    POOR
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.furnishingOfTheHouse ===
                                                                            'Door Step Verification'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    DOOR STEP VERIFICATION
                                                                </span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table style={{ width: '183px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                backgroundColor: '#BFBFBF',
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                height: '12px',
                                                            }}
                                                            colspan='6'
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                AREA TYPE
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                paddingRight: '10px',
                                                                paddingLeft: '10px',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    marginTop: '-30px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.areaType === 'Normal Area'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    NORMAL AREA
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.areaType ===
                                                                            'Community Dominated Area'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    COMMUNITY DOMINATED AREA
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.areaType === 'Negative Area'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    NEGATIVE AREA
                                                                </span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table style={{ width: '184px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                backgroundColor: '#BFBFBF',
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                height: '12px',
                                                            }}
                                                            colspan='6'
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                LOCATING THE ADDRESS
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                paddingRight: '10px',
                                                                paddingLeft: '10px',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.locatingTheAddress === 'Easy'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    EASY
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.locatingTheAddress ===
                                                                            'Difficult'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    DIFFICULT
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.locatingTheAddress ===
                                                                            'Landmark Required'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    LANDMARK REQUIRED
                                                                </span>
                                                            </label>

                                                            <table
                                                                style={{
                                                                    width: '100%',
                                                                    marginTop: '5px',
                                                                    marginBottom: '5px',
                                                                }}
                                                            >
                                                                <tr>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderWidth: 0.5,
                                                                            height: '12px',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontWeight: 'bold',
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            LANDMARK
                                                                        </p>
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderColor: 'black',
                                                                            borderTopWidth: 0.5,
                                                                            borderBottomWidth: 0.5,
                                                                            borderRightWidth: 0.5,
                                                                            height: '12px',
                                                                        }}
                                                                        colspan={1}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginTop: '10px',
                                                                                color: 'black',
                                                                                fontSize: 7,
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                textDecoration: 'none',
                                                                            }}
                                                                        >
                                                                            {(taskData && taskData.information.landmark) ||
                                                                                'N/A'}
                                                                        </p>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <table style={{ width: '550px' }}>
                                                <tr>
                                                    <td
                                                        style={{
                                                            backgroundColor: '#BFBFBF',
                                                            textAlign: 'center',
                                                            borderColor: 'black',
                                                            borderWidth: 0.5,
                                                            height: '12px',
                                                        }}
                                                        colspan='6'
                                                    >
                                                        <p
                                                            style={{
                                                                marginTop: '10px',
                                                                color: 'black',
                                                                fontSize: 7,
                                                                fontWeight: 'bold',
                                                                fontFamily: 'Arial, sans-serif',
                                                                textDecoration: 'none',
                                                            }}
                                                        >
                                                            ASSET SEEN
                                                        </p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        style={{
                                                            textAlign: 'center',
                                                            borderColor: 'black',
                                                            borderBottomWidth: 0.5,
                                                            borderRightWidth: 0.5,
                                                            borderLeftWidth: 0.5,
                                                            display: 'flex',
                                                            flexWrap: 'wrap',
                                                            rowGap: '2px',
                                                        }}
                                                        colspan='6'
                                                    >
                                                        <label
                                                            style={{
                                                                display: 'flex',
                                                                flexDirection: 'row',
                                                                alignItems: 'center',
                                                                marginBottom: '2px',
                                                                marginLeft: '8px',
                                                                width: '170px',
                                                            }}
                                                        >
                                                            <input
                                                                style={{ marginRight: '8px' }}
                                                                type='checkbox'
                                                                checked={
                                                                    taskData.information.television === true
                                                                        ? true
                                                                        : false
                                                                }
                                                            />
                                                            <span
                                                                style={{
                                                                    color: 'black',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    fontStyle: 'normal',
                                                                    textDecoration: 'none',
                                                                    fontSize: 7,
                                                                    textAlign: 'center',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                TELEVISION
                                                            </span>
                                                        </label>
                                                        <label
                                                            style={{
                                                                display: 'flex',
                                                                flexDirection: 'row',
                                                                alignItems: 'center',
                                                                marginBottom: '2px',
                                                                marginLeft: '8px',
                                                                width: '170px',
                                                            }}
                                                        >
                                                            <input
                                                                style={{ marginRight: '8px' }}
                                                                type='checkbox'
                                                                checked={
                                                                    taskData.information.laptop === true ? true : false
                                                                }
                                                            />
                                                            <span
                                                                style={{
                                                                    color: 'black',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    fontStyle: 'normal',
                                                                    textDecoration: 'none',
                                                                    fontSize: 7,
                                                                    textAlign: 'center',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                LAPTOP
                                                            </span>
                                                        </label>
                                                        <label
                                                            style={{
                                                                display: 'flex',
                                                                flexDirection: 'row',
                                                                alignItems: 'center',
                                                                marginBottom: '2px',
                                                                marginLeft: '8px',
                                                                width: '170px',
                                                            }}
                                                        >
                                                            <input
                                                                style={{ marginRight: '8px' }}
                                                                type='checkbox'
                                                                checked={
                                                                    taskData.information.refrigerator === true
                                                                        ? true
                                                                        : false
                                                                }
                                                            />
                                                            <span
                                                                style={{
                                                                    color: 'black',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    fontStyle: 'normal',
                                                                    textDecoration: 'none',
                                                                    fontSize: 7,
                                                                    textAlign: 'center',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                REFRIGERATOR
                                                            </span>
                                                        </label>
                                                        <label
                                                            style={{
                                                                display: 'flex',
                                                                flexDirection: 'row',
                                                                alignItems: 'center',
                                                                marginBottom: '2px',
                                                                marginLeft: '8px',
                                                                width: '170px',
                                                            }}
                                                        >
                                                            <input
                                                                style={{ marginRight: '8px' }}
                                                                type='checkbox'
                                                                checked={
                                                                    taskData.information.computer === true
                                                                        ? true
                                                                        : false
                                                                }
                                                            />
                                                            <span
                                                                style={{
                                                                    color: 'black',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    fontStyle: 'normal',
                                                                    textDecoration: 'none',
                                                                    fontSize: 7,
                                                                    textAlign: 'center',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                COMPUTER
                                                            </span>
                                                        </label>
                                                        <label
                                                            style={{
                                                                display: 'flex',
                                                                flexDirection: 'row',
                                                                alignItems: 'center',
                                                                marginBottom: '2px',
                                                                marginLeft: '8px',
                                                                width: '170px',
                                                            }}
                                                        >
                                                            <input
                                                                style={{ marginRight: '8px' }}
                                                                type='checkbox'
                                                                checked={
                                                                    taskData.information.airConditioner === true
                                                                        ? true
                                                                        : false
                                                                }
                                                            />
                                                            <span
                                                                style={{
                                                                    color: 'black',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    fontStyle: 'normal',
                                                                    textDecoration: 'none',
                                                                    fontSize: 7,
                                                                    textAlign: 'center',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                AIR CONDITIONER
                                                            </span>
                                                        </label>
                                                    </td>
                                                </tr>
                                            </table>
                                            <div className='flex flex-row'>
                                                <table style={{ width: '183px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                backgroundColor: '#BFBFBF',
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                height: '12px',
                                                            }}
                                                            colspan='6'
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                RESIDENCE ACCESSED BY
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderLeftWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                width: '85px',
                                                                paddingRight: '10px',
                                                                paddingLeft: '10px',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.residenceAccessedBy === 'Car'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    CAR
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.residenceAccessedBy ===
                                                                            'Two Wheeler'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    TWO WHEELER
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.residenceAccessedBy ===
                                                                            'Metro'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    METRO
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.residenceAccessedBy === 'Bus'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    BUS
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.residenceAccessedBy ===
                                                                            'Walk'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    WALK
                                                                </span>
                                                            </label>
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    marginBottom: '2px',
                                                                }}
                                                            >
                                                                <input
                                                                    style={{ marginRight: '8px' }}
                                                                    type='checkbox'
                                                                    checked={
                                                                        taskData.information.residenceAccessedBy ===
                                                                            'Others'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <span
                                                                    style={{
                                                                        color: 'black',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        fontStyle: 'normal',
                                                                        textDecoration: 'none',
                                                                        fontSize: 7,
                                                                        textAlign: 'center',
                                                                        marginTop: '10px',
                                                                    }}
                                                                >
                                                                    OTHERS
                                                                </span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table style={{ width: '367px' }}>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                backgroundColor: '#BFBFBF',
                                                                textAlign: 'center',
                                                                borderColor: 'black',
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                height: '12px',
                                                            }}
                                                            colspan='6'
                                                        >
                                                            <p
                                                                style={{
                                                                    marginTop: '10px',
                                                                    color: 'black',
                                                                    fontSize: 7,
                                                                    fontWeight: 'bold',
                                                                    fontFamily: 'Arial, sans-serif',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                NEIGHBOUR INFORMATION
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                borderBottomWidth: 0.5,
                                                                borderRightWidth: 0.5,
                                                                borderColor: 'black',
                                                                textAlign: 'center',
                                                                paddingRight: '10px',
                                                                paddingLeft: '10px',
                                                            }}
                                                        >
                                                            <div className='flex flex-row justify-between'>
                                                                <table style={{ width: '100%' }}>
                                                                    <tr>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontWeight: 'bold',
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                NAME
                                                                            </p>
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderTopWidth: 0.5,
                                                                                borderBottomWidth: 0.5,
                                                                                borderRightWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                {(taskData &&
                                                                                    taskData.information.firstNeighbourName) ||
                                                                                    'N/A'}
                                                                            </p>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderBottomWidth: 0.5,
                                                                                borderRightWidth: 0.5,
                                                                                borderLeftWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontWeight: 'bold',
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                AGE (APPROX.)
                                                                            </p>
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderBottomWidth: 0.5,
                                                                                borderRightWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                {(taskData &&
                                                                                    taskData.information.firstNeighbourAge) ||
                                                                                    'N/A'}
                                                                            </p>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderBottomWidth: 0.5,
                                                                                borderRightWidth: 0.5,
                                                                                borderLeftWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontWeight: 'bold',
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                ADDRESS
                                                                            </p>
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderBottomWidth: 0.5,
                                                                                borderRightWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                {(taskData &&
                                                                                    taskData.information
                                                                                        .firstNeighbourAddress) ||
                                                                                    'N/A'}
                                                                            </p>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderBottomWidth: 0.5,
                                                                                borderRightWidth: 0.5,
                                                                                borderLeftWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontWeight: 'bold',
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                FEEDBACK
                                                                            </p>
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderBottomWidth: 0.5,
                                                                                borderRightWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                {(taskData &&
                                                                                    taskData.information
                                                                                        .firstNeighbourFeedback) ||
                                                                                    'N/A'}
                                                                            </p>
                                                                        </td>
                                                                    </tr>
                                                                </table>
                                                                <div
                                                                    style={{
                                                                        width: 0.5,
                                                                        backgroundColor: 'black',
                                                                        height: '80px',
                                                                        marginLeft: '5px',
                                                                        marginRight: '5px',
                                                                    }}
                                                                ></div>
                                                                <table style={{ width: '100%' }}>
                                                                    <tr>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontWeight: 'bold',
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                NAME
                                                                            </p>
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderTopWidth: 0.5,
                                                                                borderBottomWidth: 0.5,
                                                                                borderRightWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                {(taskData &&
                                                                                    taskData.information.secondNeighbourName) ||
                                                                                    'N/A'}
                                                                            </p>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderBottomWidth: 0.5,
                                                                                borderRightWidth: 0.5,
                                                                                borderLeftWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontWeight: 'bold',
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                AGE (APPROX.)
                                                                            </p>
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderBottomWidth: 0.5,
                                                                                borderRightWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                {(taskData &&
                                                                                    taskData.information.secondNeighbourAge) ||
                                                                                    'N/A'}
                                                                            </p>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderBottomWidth: 0.5,
                                                                                borderRightWidth: 0.5,
                                                                                borderLeftWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontWeight: 'bold',
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                ADDRESS
                                                                            </p>
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderBottomWidth: 0.5,
                                                                                borderRightWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                {(taskData &&
                                                                                    taskData.information
                                                                                        .secondNeighbourAddress) ||
                                                                                    'N/A'}
                                                                            </p>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderBottomWidth: 0.5,
                                                                                borderRightWidth: 0.5,
                                                                                borderLeftWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontWeight: 'bold',
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                FEEDBACK
                                                                            </p>
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                borderColor: 'black',
                                                                                borderBottomWidth: 0.5,
                                                                                borderRightWidth: 0.5,
                                                                                height: '12px',
                                                                                width: '50%',
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginTop: '10px',
                                                                                    color: 'black',
                                                                                    fontSize: 7,
                                                                                    fontFamily: 'Arial, sans-serif',
                                                                                    textDecoration: 'none',
                                                                                }}
                                                                            >
                                                                                {(taskData &&
                                                                                    taskData.information
                                                                                        .secondNeighbourFeedback) ||
                                                                                    'N/A'}
                                                                            </p>
                                                                        </td>
                                                                    </tr>
                                                                </table>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </>
                                    )}
                                    <table style={{ width: '550px' }}>
                                        <tr>
                                            <td
                                                style={{
                                                    backgroundColor: '#BFBFBF',
                                                    textAlign: 'center',
                                                    borderColor: 'black',
                                                    borderBottomWidth: 0.5,
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    height: '12px',
                                                }}
                                                colspan='6'
                                            >
                                                <p
                                                    style={{
                                                        marginTop: '10px',
                                                        color: 'black',
                                                        fontSize: 7,
                                                        fontWeight: 'bold',
                                                        fontFamily: 'Arial, sans-serif',
                                                        textDecoration: 'none',
                                                    }}
                                                >
                                                    PREVIOUS VISIT
                                                </p>
                                            </td>
                                        </tr>
                                    </table>
                                    <div className='flex flex-row'>
                                        <table style={{ width: '183px' }}>
                                            <tr>
                                                <td
                                                    style={{
                                                        textAlign: 'center',
                                                        borderColor: 'black',
                                                        borderRightWidth: 0.5,
                                                        borderLeftWidth: 0.5,
                                                        borderBottomWidth: 0.5,
                                                        height: '12px',
                                                        width: '50%',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            marginTop: '10px',
                                                            color: 'black',
                                                            fontSize: 7,
                                                            fontWeight: 'bold',
                                                            fontFamily: 'Arial, sans-serif',
                                                            textDecoration: 'none',
                                                        }}
                                                    >
                                                        PREVIOUS VISIT DONE ON ADDRESS
                                                    </p>
                                                </td>
                                                <td
                                                    style={{
                                                        textAlign: 'center',
                                                        borderColor: 'black',
                                                        borderBottomWidth: 0.5,
                                                        borderRightWidth: 0.5,
                                                        height: '12px',
                                                        width: '50%',
                                                    }}
                                                >
                                                    <label
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                            marginBottom: '2px',
                                                            marginLeft: '8px',
                                                        }}
                                                    >
                                                        <input
                                                            style={{ marginRight: '8px', marginTop: '7px' }}
                                                            type='checkbox'
                                                            checked={
                                                                taskData.information.previousVisitDoneOnThisAddress === 'Yes'
                                                                    ? true
                                                                    : false
                                                            }
                                                        />
                                                        <span
                                                            style={{
                                                                color: 'black',
                                                                fontFamily: 'Arial, sans-serif',
                                                                fontStyle: 'normal',
                                                                textDecoration: 'none',
                                                                fontSize: 7,
                                                                textAlign: 'center',
                                                                marginTop: '0px',
                                                            }}
                                                        >
                                                            YES
                                                        </span>
                                                    </label>
                                                    <label
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                            marginBottom: '2px',
                                                            marginLeft: '8px',
                                                        }}
                                                    >
                                                        <input
                                                            style={{ marginRight: '8px', marginTop: '7px' }}
                                                            type='checkbox'
                                                            checked={
                                                                taskData.information.previousVisitDoneOnThisAddress === 'No'
                                                                    ? true
                                                                    : false
                                                            }
                                                        />
                                                        <span
                                                            style={{
                                                                color: 'black',
                                                                fontFamily: 'Arial, sans-serif',
                                                                fontStyle: 'normal',
                                                                textDecoration: 'none',
                                                                fontSize: 7,
                                                                textAlign: 'center',
                                                                marginTop: '0px',
                                                            }}
                                                        >
                                                            NO
                                                        </span>
                                                    </label>
                                                </td>
                                            </tr>
                                        </table>
                                        <table style={{ width: '183px' }}>
                                            <tr>
                                                <td
                                                    style={{
                                                        textAlign: 'center',
                                                        borderColor: 'black',
                                                        borderRightWidth: 0.5,
                                                        borderBottomWidth: 0.5,
                                                        height: '12px',
                                                        width: '50%',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            marginTop: '10px',
                                                            color: 'black',
                                                            fontSize: 7,
                                                            fontWeight: 'bold',
                                                            fontFamily: 'Arial, sans-serif',
                                                            textDecoration: 'none',
                                                        }}
                                                    >
                                                        NUMBER OF TIMES VISITED
                                                    </p>
                                                </td>
                                                <td
                                                    style={{
                                                        textAlign: 'center',
                                                        borderColor: 'black',
                                                        borderBottomWidth: 0.5,
                                                        borderRightWidth: 0.5,
                                                        height: '12px',
                                                        width: '50%',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            marginTop: '10px',
                                                            color: 'black',
                                                            fontSize: 7,
                                                            fontFamily: 'Arial, sans-serif',
                                                            textDecoration: 'none',
                                                        }}
                                                    >
                                                        {(taskData && taskData.information.numberOfTimesVisited) ||
                                                            'N/A'}
                                                    </p>
                                                </td>
                                            </tr>
                                        </table>
                                        <table style={{ width: '184px' }}>
                                            <tr>
                                                <td
                                                    style={{
                                                        textAlign: 'center',
                                                        borderColor: 'black',
                                                        borderRightWidth: 0.5,
                                                        borderBottomWidth: 0.5,
                                                        height: '12px',
                                                        width: '50%',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            marginTop: '10px',
                                                            color: 'black',
                                                            fontSize: 7,
                                                            fontWeight: 'bold',
                                                            fontFamily: 'Arial, sans-serif',
                                                            textDecoration: 'none',
                                                        }}
                                                    >
                                                        MET PERSON IN PREVIOUS VISIT
                                                    </p>
                                                </td>
                                                <td
                                                    style={{
                                                        textAlign: 'center',
                                                        borderColor: 'black',
                                                        borderBottomWidth: 0.5,
                                                        borderRightWidth: 0.5,
                                                        height: '12px',
                                                        width: '50%',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            marginTop: '10px',
                                                            color: 'black',
                                                            fontSize: 7,
                                                            fontFamily: 'Arial, sans-serif',
                                                            textDecoration: 'none',
                                                        }}
                                                    >
                                                        {(taskData &&
                                                            taskData.information.previousVisitMetPerson) ||
                                                            'N/A'}
                                                    </p>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <table style={{ width: '550px' }}>
                                        <tr>
                                            <td
                                                style={{
                                                    backgroundColor: '#BFBFBF',
                                                    textAlign: 'center',
                                                    borderColor: 'black',
                                                    borderBottomWidth: 0.5,
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    height: '12px',
                                                }}
                                                colspan='6'
                                            >
                                                <p
                                                    style={{
                                                        marginTop: '10px',
                                                        color: 'black',
                                                        fontSize: 7,
                                                        fontWeight: 'bold',
                                                        fontFamily: 'Arial, sans-serif',
                                                        textDecoration: 'none',
                                                    }}
                                                >
                                                    ADDITIONAL INFORMATION
                                                </p>
                                            </td>
                                        </tr>
                                    </table>
                                    <table style={{ width: '550px' }}>
                                        <tr>
                                            <td
                                                style={{
                                                    textAlign: 'center',
                                                    borderColor: 'black',
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderBottomWidth: 0.5,
                                                    height: '12px',
                                                    width: '92px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginTop: '10px',
                                                        color: 'black',
                                                        fontSize: 7,
                                                        fontWeight: 'bold',
                                                        fontFamily: 'Arial, sans-serif',
                                                        textDecoration: 'none',
                                                    }}
                                                >
                                                    ACTION (VERIFIER)
                                                </p>
                                            </td>
                                            <td
                                                style={{
                                                    textAlign: 'center',
                                                    borderColor: 'black',
                                                    borderBottomWidth: 0.5,
                                                    borderRightWidth: 0.5,
                                                    width: '458px',
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    rowGap: '4px',
                                                }}
                                            >
                                                <label
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        alignItems: 'center',
                                                        marginBottom: '2px',
                                                        marginLeft: '8px',
                                                        width: '142px',
                                                    }}
                                                >
                                                    <input
                                                        style={{ marginRight: '8px', marginTop: '7px' }}
                                                        type='checkbox'
                                                        checked={
                                                            taskData.information.actionDropdownValue === 'Address Not Found'
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                    <span
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '0px',
                                                        }}
                                                    >
                                                        ADDRESS NOT FOUND
                                                    </span>
                                                </label>
                                                <label
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        alignItems: 'center',
                                                        marginBottom: '2px',
                                                        marginLeft: '8px',
                                                        width: '142px',
                                                    }}
                                                >
                                                    <input
                                                        style={{ marginRight: '8px', marginTop: '7px' }}
                                                        type='checkbox'
                                                        checked={
                                                            taskData.information.actionDropdownValue === 'Wrong Address'
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                    <span
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '0px',
                                                        }}
                                                    >
                                                        WRONG ADDRESS
                                                    </span>
                                                </label>
                                                <label
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        alignItems: 'center',
                                                        marginBottom: '2px',
                                                        marginLeft: '8px',
                                                        width: '142px',
                                                    }}
                                                >
                                                    <input
                                                        style={{ marginRight: '8px', marginTop: '7px' }}
                                                        type='checkbox'
                                                        checked={
                                                            taskData.information.actionDropdownValue === 'Open Form'
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                    <span
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '0px',
                                                        }}
                                                    >
                                                        OPEN FORM
                                                    </span>
                                                </label>
                                                <label
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        alignItems: 'center',
                                                        marginBottom: '2px',
                                                        marginLeft: '8px',
                                                        width: '142px',
                                                    }}
                                                >
                                                    <input
                                                        style={{ marginRight: '8px', marginTop: '7px' }}
                                                        type='checkbox'
                                                        checked={
                                                            taskData.information.actionDropdownValue === 'Shifted' ? true : false
                                                        }
                                                    />
                                                    <span
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '0px',
                                                        }}
                                                    >
                                                        SHIFTED
                                                    </span>
                                                </label>
                                                <label
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        alignItems: 'center',
                                                        marginBottom: '2px',
                                                        marginLeft: '8px',
                                                        width: '142px',
                                                    }}
                                                >
                                                    <input
                                                        style={{ marginRight: '8px', marginTop: '7px' }}
                                                        type='checkbox'
                                                        checked={
                                                            taskData.information.actionDropdownValue === 'No Such Person'
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                    <span
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '0px',
                                                        }}
                                                    >
                                                        NO SUCH PERSON
                                                    </span>
                                                </label>
                                                <label
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        alignItems: 'center',
                                                        marginBottom: '2px',
                                                        marginLeft: '8px',
                                                        width: '142px',
                                                    }}
                                                >
                                                    <input
                                                        style={{ marginRight: '8px', marginTop: '7px' }}
                                                        type='checkbox'
                                                        checked={
                                                            taskData.information.actionDropdownValue === 'Lock' ? true : false
                                                        }
                                                    />
                                                    <span
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '0px',
                                                        }}
                                                    >
                                                        LOCK
                                                    </span>
                                                </label>
                                                <label
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        alignItems: 'center',
                                                        marginBottom: '2px',
                                                        marginLeft: '8px',
                                                        width: '142px',
                                                    }}
                                                >
                                                    <input
                                                        style={{ marginRight: '8px', marginTop: '7px' }}
                                                        type='checkbox'
                                                        checked={
                                                            taskData.information.actionDropdownValue ===
                                                                'Refused to Provide Details'
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                    <span
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '0px',
                                                        }}
                                                    >
                                                        REFUSED TO PROVIDE DETAILS
                                                    </span>
                                                </label>
                                                <label
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        alignItems: 'center',
                                                        marginBottom: '2px',
                                                        marginLeft: '8px',
                                                        width: '142px',
                                                    }}
                                                >
                                                    <input
                                                        style={{ marginRight: '8px', marginTop: '7px' }}
                                                        type='checkbox'
                                                        checked={
                                                            taskData.information.actionDropdownValue === 'Entry Not Permitted'
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                    <span
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '0px',
                                                        }}
                                                    >
                                                        ENTRY NOT PERMITTED
                                                    </span>
                                                </label>
                                                <label
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        alignItems: 'center',
                                                        marginBottom: '2px',
                                                        marginLeft: '8px',
                                                        width: '142px',
                                                    }}
                                                >
                                                    <input
                                                        style={{ marginRight: '8px', marginTop: '7px' }}
                                                        type='checkbox'
                                                        checked={
                                                            taskData.information.actionDropdownValue === 'Cancel' ? true : false
                                                        }
                                                    />
                                                    <span
                                                        style={{
                                                            color: 'black',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontStyle: 'normal',
                                                            textDecoration: 'none',
                                                            fontSize: 7,
                                                            textAlign: 'center',
                                                            marginTop: '0px',
                                                        }}
                                                    >
                                                        CANCEL
                                                    </span>
                                                </label>
                                            </td>
                                        </tr>
                                    </table>
                                    <table style={{ width: '550px' }}>
                                        <tr>
                                            <td
                                                style={{
                                                    textAlign: 'center',
                                                    borderColor: 'black',
                                                    borderRightWidth: 0.5,
                                                    borderBottomWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    height: '12px',
                                                    width: '50%',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginTop: '10px',
                                                        color: 'black',
                                                        fontSize: 7,
                                                        fontWeight: 'bold',
                                                        fontFamily: 'Arial, sans-serif',
                                                        textDecoration: 'none',
                                                    }}
                                                >
                                                    VERIFIER NOTES
                                                </p>
                                            </td>
                                            <td
                                                style={{
                                                    textAlign: 'center',
                                                    borderColor: 'black',
                                                    borderRightWidth: 0.5,
                                                    borderBottomWidth: 0.5,
                                                    height: '12px',
                                                    width: '50%',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginTop: '10px',
                                                        color: 'black',
                                                        fontSize: 7,
                                                        fontWeight: 'bold',
                                                        fontFamily: 'Arial, sans-serif',
                                                        textDecoration: 'none',
                                                    }}
                                                >
                                                    ROUTE MAP
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                style={{
                                                    textAlign: 'center',
                                                    borderColor: 'black',
                                                    borderRightWidth: 0.5,
                                                    borderBottomWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    height: '28px',
                                                    width: '50%',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginTop: '10px',
                                                        color: 'black',
                                                        fontSize: 7,
                                                        fontFamily: 'Arial, sans-serif',
                                                        textDecoration: 'none',
                                                    }}
                                                >
                                                    {(taskData && taskData.information.note) || 'N/A'}
                                                </p>
                                            </td>
                                            <td
                                                style={{
                                                    textAlign: 'center',
                                                    borderColor: 'black',
                                                    borderRightWidth: 0.5,
                                                    borderBottomWidth: 0.5,
                                                    height: '28px',
                                                    width: '50%',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginTop: '10px',
                                                        color: 'black',
                                                        fontSize: 7,
                                                        fontFamily: 'Arial, sans-serif',
                                                        textDecoration: 'none',
                                                    }}
                                                >
                                                    {(taskData && taskData.information.routeMap) || 'N/A'}
                                                </p>
                                            </td>
                                        </tr>
                                    </table>
                                    <table style={{ width: '550px' }}>
                                        <tr>
                                            <td
                                                style={{
                                                    textAlign: 'center',
                                                    borderColor: 'black',
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderBottomWidth: 0.5,
                                                    height: '12px',
                                                    width: '92px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginTop: '10px',
                                                        color: 'black',
                                                        fontSize: 7,
                                                        fontWeight: 'bold',
                                                        fontFamily: 'Arial, sans-serif',
                                                        textDecoration: 'none',
                                                    }}
                                                >
                                                    REMARKS
                                                </p>
                                            </td>
                                            <td
                                                style={{
                                                    textAlign: 'center',
                                                    borderColor: 'black',
                                                    borderBottomWidth: 0.5,
                                                    borderRightWidth: 0.5,
                                                    width: '458px',
                                                    height: 'max-content',
                                                    paddingTop: '5px',
                                                    paddingBottom: '5px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginTop: '10px',
                                                        color: 'black',
                                                        fontSize: 7,
                                                        lineHeight: 1.2,
                                                        fontFamily: 'Arial, sans-serif',
                                                        textDecoration: 'none',
                                                    }}
                                                >
                                                    {taskData.remarks}
                                                </p>
                                            </td>
                                        </tr>
                                    </table>
                                    <table style={{ width: '550px' }}>
                                        <tr>
                                            <td
                                                style={{
                                                    backgroundColor: '#BFBFBF',
                                                    textAlign: 'center',
                                                    borderColor: 'black',
                                                    borderBottomWidth: 0.5,
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    height: '12px',
                                                }}
                                                colspan='6'
                                            >
                                                <p
                                                    style={{
                                                        marginTop: '10px',
                                                        color: 'black',
                                                        fontSize: 7,
                                                        fontWeight: 'bold',
                                                        fontFamily: 'Arial, sans-serif',
                                                        textDecoration: 'none',
                                                    }}
                                                >
                                                    FINAL STATUS
                                                </p>
                                            </td>
                                        </tr>
                                    </table>
                                    <div className='flex flex-row'>
                                        <table style={{ width: '183px' }}>
                                            <tr>
                                                <td
                                                    style={{
                                                        textAlign: 'center',
                                                        borderColor: 'black',
                                                        borderBottomWidth: 0.5,
                                                        borderRightWidth: 0.5,
                                                        borderLeftWidth: 0.5,
                                                        height: '12px',
                                                    }}
                                                    colspan='6'
                                                >
                                                    <p
                                                        style={{
                                                            marginTop: '10px',
                                                            color: 'black',
                                                            fontSize: 7,
                                                            fontWeight: 'bold',
                                                            fontFamily: 'Arial, sans-serif',
                                                            textDecoration: 'none',
                                                        }}
                                                    >
                                                        STATUS
                                                    </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td
                                                    style={{
                                                        borderBottomWidth: 0.5,
                                                        borderRightWidth: 0.5,
                                                        borderLeftWidth: 0.5,
                                                        borderColor: 'black',
                                                        textAlign: 'center',
                                                        paddingRight: '10px',
                                                        paddingLeft: '10px',
                                                    }}
                                                >
                                                    <label
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                            marginBottom: '2px',
                                                        }}
                                                    >
                                                        <input
                                                            style={{ marginRight: '8px', marginTop: '7px' }}
                                                            type='checkbox'
                                                            checked={
                                                                taskData.finalisationStatus === 'Positive'
                                                                    ? true
                                                                    : false
                                                            }
                                                        />
                                                        <span
                                                            style={{
                                                                color: 'black',
                                                                fontFamily: 'Arial, sans-serif',
                                                                fontStyle: 'normal',
                                                                textDecoration: 'none',
                                                                fontSize: 7,
                                                                textAlign: 'center',
                                                                marginTop: '0px',
                                                            }}
                                                        >
                                                            POSITIVE
                                                        </span>
                                                    </label>
                                                    <label
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                            marginBottom: '2px',
                                                        }}
                                                    >
                                                        <input
                                                            style={{ marginRight: '8px', marginTop: '7px' }}
                                                            type='checkbox'
                                                            checked={
                                                                taskData.finalisationStatus === 'Negative'
                                                                    ? true
                                                                    : false
                                                            }
                                                        />
                                                        <span
                                                            style={{
                                                                color: 'black',
                                                                fontFamily: 'Arial, sans-serif',
                                                                fontStyle: 'normal',
                                                                textDecoration: 'none',
                                                                fontSize: 7,
                                                                textAlign: 'center',
                                                                marginTop: '0px',
                                                            }}
                                                        >
                                                            NEGATIVE
                                                        </span>
                                                    </label>
                                                    <label
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                            marginBottom: '2px',
                                                        }}
                                                    >
                                                        <input
                                                            style={{ marginRight: '8px', marginTop: '7px' }}
                                                            type='checkbox'
                                                            checked={
                                                                taskData.finalisationStatus === 'Refer' ? true : false
                                                            }
                                                        />
                                                        <span
                                                            style={{
                                                                color: 'black',
                                                                fontFamily: 'Arial, sans-serif',
                                                                fontStyle: 'normal',
                                                                textDecoration: 'none',
                                                                fontSize: 7,
                                                                textAlign: 'center',
                                                                marginTop: '0px',
                                                            }}
                                                        >
                                                            Refer
                                                        </span>
                                                    </label>
                                                    <label
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                            marginBottom: '2px',
                                                        }}
                                                    >
                                                        <input
                                                            style={{ marginRight: '8px', marginTop: '7px' }}
                                                            type='checkbox'
                                                            checked={
                                                                taskData.finalisationStatus === '-' ? true : false
                                                            }
                                                        />
                                                        <span
                                                            style={{
                                                                color: 'black',
                                                                fontFamily: 'Arial, sans-serif',
                                                                fontStyle: 'normal',
                                                                textDecoration: 'none',
                                                                fontSize: 7,
                                                                textAlign: 'center',
                                                                marginTop: '0px',
                                                            }}
                                                        >
                                                            -
                                                        </span>
                                                    </label>
                                                </td>
                                            </tr>
                                        </table>
                                        <table style={{ width: '183px' }}>
                                            <tr>
                                                <td
                                                    style={{
                                                        textAlign: 'center',
                                                        borderColor: 'black',
                                                        borderBottomWidth: 0.5,
                                                        borderRightWidth: 0.5,
                                                        height: '12px',
                                                    }}
                                                    colspan='6'
                                                >
                                                    <p
                                                        style={{
                                                            marginTop: '10px',
                                                            color: 'black',
                                                            fontSize: 7,
                                                            fontWeight: 'bold',
                                                            fontFamily: 'Arial, sans-serif',
                                                            textDecoration: 'none',
                                                        }}
                                                    >
                                                        REASON FOR NEGATIVE/REFER
                                                    </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td
                                                    style={{
                                                        borderBottomWidth: 0.5,
                                                        borderRightWidth: 0.5,
                                                        borderColor: 'black',
                                                        textAlign: 'center',
                                                        paddingRight: '10px',
                                                        paddingLeft: '10px',
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            marginTop: '10px',
                                                            color: 'black',
                                                            fontSize: 7,
                                                            fontFamily: 'Arial, sans-serif',
                                                            textDecoration: 'none',
                                                        }}
                                                    >
                                                        {(taskData && taskData.finalisationRemarks) || 'N/A'}
                                                    </p>
                                                </td>
                                            </tr>
                                        </table>
                                        <table style={{ width: '184px' }}>
                                            <tr>
                                                <td
                                                    style={{
                                                        textAlign: 'center',
                                                        borderColor: 'black',
                                                        borderBottomWidth: 0.5,
                                                        borderRightWidth: 0.5,
                                                        height: '12px',
                                                    }}
                                                    colspan='6'
                                                >
                                                    <p
                                                        style={{
                                                            marginTop: '10px',
                                                            color: 'black',
                                                            fontSize: 7,
                                                            fontWeight: 'bold',
                                                            fontFamily: 'Arial, sans-serif',
                                                            textDecoration: 'none',
                                                        }}
                                                    >
                                                        LOCATION CAPTURED
                                                    </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td
                                                    style={{
                                                        borderBottomWidth: 0.5,
                                                        borderRightWidth: 0.5,
                                                        borderColor: 'black',
                                                        textAlign: 'center',
                                                        paddingRight: '10px',
                                                        paddingLeft: '10px',
                                                    }}
                                                >
                                                    <table style={{ width: '100%' }}>
                                                        <tr>
                                                            <td
                                                                style={{
                                                                    textAlign: 'center',
                                                                    borderColor: 'black',
                                                                    borderWidth: 0.5,
                                                                    height: '12px',
                                                                    width: '50%',
                                                                }}
                                                            >
                                                                <p
                                                                    style={{
                                                                        marginTop: '10px',
                                                                        color: 'black',
                                                                        fontSize: 7,
                                                                        fontWeight: 'bold',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        textDecoration: 'none',
                                                                    }}
                                                                >
                                                                    LATITUDE
                                                                </p>
                                                            </td>
                                                            <td
                                                                style={{
                                                                    textAlign: 'center',
                                                                    borderColor: 'black',
                                                                    borderTopWidth: 0.5,
                                                                    borderBottomWidth: 0.5,
                                                                    borderRightWidth: 0.5,
                                                                    height: '12px',
                                                                    width: '50%',
                                                                }}
                                                            >
                                                                <p
                                                                    style={{
                                                                        marginTop: '10px',
                                                                        color: 'black',
                                                                        fontSize: 7,
                                                                        fontWeight: 'bold',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        textDecoration: 'none',
                                                                    }}
                                                                >
                                                                    LONGITUDE
                                                                </p>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                style={{
                                                                    textAlign: 'center',
                                                                    borderColor: 'black',
                                                                    borderRightWidth: 0.5,
                                                                    borderLeftWidth: 0.5,
                                                                    borderBottomWidth: 0.5,
                                                                    height: '24px',
                                                                    width: '50%',
                                                                }}
                                                            >
                                                                <p
                                                                    style={{
                                                                        marginTop: '10px',
                                                                        color: 'black',
                                                                        fontSize: 7,
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        textDecoration: 'none',
                                                                    }}
                                                                >
                                                                    {(taskData && taskData.visitLocation.latitude) ||
                                                                        'N/A'}
                                                                </p>
                                                            </td>
                                                            <td
                                                                style={{
                                                                    textAlign: 'center',
                                                                    borderColor: 'black',
                                                                    borderRightWidth: 0.5,
                                                                    borderBottomWidth: 0.5,
                                                                    height: '24px',
                                                                    width: '50%',
                                                                }}
                                                            >
                                                                <p
                                                                    style={{
                                                                        marginTop: '10px',
                                                                        color: 'black',
                                                                        fontSize: 7,
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        textDecoration: 'none',
                                                                    }}
                                                                >
                                                                    {(taskData && taskData.visitLocation.longitude) ||
                                                                        'N/A'}
                                                                </p>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <table style={{ width: '550px' }}>
                                        <tr>
                                            <td
                                                style={{
                                                    textAlign: 'center',
                                                    borderColor: 'black',
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderBottomWidth: 0.5,
                                                    height: '12px',
                                                    width: '92px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginTop: '10px',
                                                        color: 'black',
                                                        fontSize: 7,
                                                        fontWeight: 'bold',
                                                        fontFamily: 'Arial, sans-serif',
                                                        textDecoration: 'none',
                                                    }}
                                                >
                                                    ADDRESS
                                                </p>
                                            </td>
                                            <td
                                                style={{
                                                    textAlign: 'center',
                                                    borderColor: 'black',
                                                    borderBottomWidth: 0.5,
                                                    borderRightWidth: 0.5,
                                                    width: '458px',
                                                    height: '12px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        marginTop: '10px',
                                                        color: 'black',
                                                        fontSize: 7,
                                                        lineHeight: 1.2,
                                                        fontFamily: 'Arial, sans-serif',
                                                        textDecoration: 'none',
                                                    }}
                                                >
                                                    {taskData && taskData.visitLocation.address}
                                                </p>
                                            </td>
                                        </tr>
                                    </table>
                                    <table style={{ width: '550px', marginTop: '110px' }}>
                                        <tr>
                                            <td
                                                style={{
                                                    backgroundColor: '#BFBFBF',
                                                    textAlign: 'center',
                                                    borderColor: 'black',
                                                    borderBottomWidth: 0.5,
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    height: '12px',
                                                }}
                                                colspan='6'
                                            >
                                                <p
                                                    style={{
                                                        marginTop: '10px',
                                                        color: 'black',
                                                        fontSize: 7,
                                                        fontWeight: 'bold',
                                                        fontFamily: 'Arial, sans-serif',
                                                        textDecoration: 'none',
                                                    }}
                                                >
                                                    PHOTOGRAPHS
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                style={{
                                                    textAlign: 'center',
                                                    borderColor: 'black',
                                                    borderBottomWidth: 0.5,
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    gap: '2px',
                                                }}
                                            >
                                                {taskData && taskData.photographs && taskData.photographs.map((photo, index) => (
                                                    <div
                                                        key={`pdf-photo-${index}`}
                                                        style={{
                                                            width: '107px',
                                                            height: '150px',
                                                            borderRightWidth: index % 5 === 4 ? 0 : 0.5,
                                                            borderBottomWidth: index < 5 ? 0.5 : 0,
                                                            borderColor: 'black',
                                                            position: 'relative',
                                                        }}
                                                    >
                                                        <img
                                                            src={`data:image/jpeg;base64, ${photo}`}
                                                            style={{
                                                                width: '107px',
                                                                height: '150px',
                                                            }}
                                                        />
                                                        {taskData.information &&
                                                            taskData.information.photographsDetails &&
                                                            taskData.information.photographsDetails[index] && (
                                                                <div
                                                                    style={{
                                                                        position: 'absolute',
                                                                        bottom: 1,
                                                                        left: 0,
                                                                        width: '100%',
                                                                        backgroundColor: 'rgba(0, 0, 0, 0.54)',
                                                                        color: 'white',
                                                                        padding: '4px',
                                                                        marginBottom: '1px',
                                                                        fontSize: '8px',
                                                                        fontFamily: 'Arial, sans-serif',
                                                                        lineHeight: '1',
                                                                    }}
                                                                >
                                                                    <p style={{ margin: '0', textShadow: '1px 1px 1px black' }}>Lat: {taskData.information.photographsDetails[index].latitude}</p>
                                                                    <p style={{ margin: '0', textShadow: '1px 1px 1px black' }}>Long: {taskData.information.photographsDetails[index].longitude}</p>
                                                                </div>
                                                            )}
                                                    </div>
                                                ))}
                                                {/* If no photographs available */}
                                                {(!taskData || !taskData.photographs || taskData.photographs.length === 0) && (
                                                    <p style={{ fontFamily: 'Arial, sans-serif', fontSize: '8px' }}>No photographs available</p>
                                                )}

                                            </td>
                                        </tr>
                                    </table>
                                    {taskData && taskData.customer.mapOnPDF && (
                                        <div
                                            style={{
                                                width: '550px',
                                                height: '350px',
                                                marginTop: '200px',
                                            }}
                                        >
                                            <table style={{ width: '550px' }}>
                                                <tr>
                                                    <td
                                                        style={{
                                                            backgroundColor: '#BFBFBF',
                                                            textAlign: 'center',
                                                            borderColor: 'black',
                                                            borderWidth: 0.5,
                                                            height: '12px',
                                                        }}
                                                        colspan='6'
                                                    >
                                                        <p
                                                            style={{
                                                                marginTop: '10px',
                                                                color: 'black',
                                                                fontSize: 7,
                                                                fontWeight: 'bold',
                                                                fontFamily: 'Arial, sans-serif',
                                                                textDecoration: 'none',
                                                            }}
                                                        >
                                                            MAP
                                                        </p>
                                                    </td>
                                                </tr>
                                            </table>
                                            {/* Static Map */}
                                            <img
                                                style={{
                                                    borderColor: 'black',
                                                    borderRightWidth: 0.5,
                                                    borderLeftWidth: 0.5,
                                                    borderBottomWidth: 0.5,
                                                }}
                                                src={`https://maps.googleapis.com/maps/api/staticmap?center=${taskData.visitLocation.address}&zoom=13&size=550x350&maptype=roadmap&markers=color:red%7Clabel:Here%7C${taskData.visitLocation.latitude},${taskData.visitLocation.longitude}&key=AIzaSyBJNBYdkx3w2rHeXyVJ73v4wJ43dgGkEeI`}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        {confirmModal && (
                            <>
                                <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
                                    <div className='relative w-auto my-6 mx-auto max-w-3xl'>
                                        {/*content*/}
                                        <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none'>
                                            {/*header*/}
                                            <div className='flex items-center justify-between py-3 px-3 border-b border-solid border-blueGray-200 rounded-t'>
                                                <h3 className='text-lg font-semibold'>Alert!!</h3>
                                            </div>
                                            {/*body*/}
                                            <div className='relative p-6 flex-auto'>
                                                <p className='text-md'>
                                                    By clicking on Yes, you will be responsible for the
                                                    quality of the performed task. Are you sure, you want to
                                                    continue?{' '}
                                                </p>
                                            </div>
                                            {/*footer*/}
                                            <div className='flex items-center justify-end py-2 px-3 border-t border-solid border-blueGray-200 rounded-b'>
                                                <button
                                                    className='text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150'
                                                    type='button'
                                                    onClick={() => setConfirmModal(false)}
                                                >
                                                    No
                                                </button>
                                                <button
                                                    className='bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 disabled:bg-gray-300'
                                                    type='button'
                                                    onClick={summaryHandler}
                                                    disabled={loadingTaskCheckedInfo}
                                                >
                                                    Yes
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='opacity-25 fixed inset-0 z-40 bg-black'></div>
                            </>
                        )}

                        {callingModal && (
                            <>
                                <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
                                    <div className='relative w-auto my-6 mx-auto max-w-3xl'>
                                        {/*content*/}
                                        <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none'>
                                            {/*header*/}
                                            <div className='flex items-center justify-between py-3 px-3 border-b border-solid border-blueGray-200 rounded-t'>
                                                <h3 className='text-lg font-semibold'>Call</h3>
                                            </div>
                                            {/*body*/}
                                            <div className='relative p-6 flex-auto'>
                                                <Input
                                                    width='w-full mb-4'
                                                    name='Number *'
                                                    value={number}
                                                    type='number'
                                                    onChange={(e) => setNumber(e.target.value)}
                                                />
                                                <p className='text-sm mt-4'>
                                                    All the fields with * are mandatory
                                                </p>
                                            </div>
                                            {/*footer*/}
                                            <div className='flex items-center justify-end py-2 px-3 border-t border-solid border-blueGray-200 rounded-b'>
                                                <button
                                                    className='text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150'
                                                    type='button'
                                                    onClick={closeCallingModal}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    className='bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 disabled:bg-gray-300'
                                                    type='button'
                                                    onClick={callingHandler}
                                                    disabled={loadingDial}
                                                >
                                                    Dial
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='opacity-25 fixed inset-0 z-40 bg-black'></div>
                            </>
                        )}
                    </div>

                )
            }
            {imageModal && (
                <>
                    <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none z-100'>
                        <div className='relative w-auto my-6 mx-auto max-w-3xl'>
                            {/*content*/}
                            <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none'>
                                {/*header*/}
                                <div className='flex items-center justify-between py-3 px-3 border-b border-solid border-blueGray-200 rounded-t'>
                                    <h3 className='text-lg font-semibold'>Image</h3>
                                </div>
                                {/*body*/}
                                <div className='relative p-6 flex-auto'>
                                    <div style={{ width: 500, height: 500, borderRadius: 5 }}>
                                        <TransformWrapper>
                                            {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                                                <>
                                                    <TransformComponent>
                                                        <img
                                                            src={`data:image/jpeg;base64, ${imageToDisplay}`}
                                                            style={{
                                                                width: 450,
                                                                height: 450,
                                                                borderRadius: 5,
                                                            }}
                                                        />
                                                    </TransformComponent>
                                                    <div className='mt-4 flex justify-between'>
                                                        <div>
                                                            <Button
                                                                custom='py-2 mr-4'
                                                                text='Zoom In (+)'
                                                                onClick={() => zoomIn()}
                                                            />
                                                            <Button
                                                                custom='py-2 mr-4'
                                                                text='Zoom Out (-)'
                                                                onClick={() => zoomOut()}
                                                            />
                                                        </div>
                                                        <div>
                                                            <Button
                                                                custom='py-2 mr-4'
                                                                text='<-'
                                                                onClick={() => {
                                                                    if (imageIndex !== 0) {
                                                                        setImageIndex(imageIndex - 1)
                                                                    }
                                                                }}
                                                            />
                                                            <Button
                                                                custom='py-2'
                                                                text='->'
                                                                onClick={() => {
                                                                    if (imageIndex !== totalImages.length - 1) {
                                                                        setImageIndex(imageIndex + 1)
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </TransformWrapper>
                                    </div>
                                </div>

                                <div className='flex items-center justify-end py-2 px-3 border-t border-solid border-blueGray-200 rounded-b'>
                                    <button
                                        className='text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150'
                                        type='button'
                                        onClick={closeImageModal}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='opacity-25 fixed inset-0 z-40 bg-black'></div>
                </>
            )}
            {popup && (
                <>
                    <div className="justify-center items-center flex-col  overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                        <div className=" w-auto my-6 mx-auto max-w-3xl">
                            {/*content*/}
                            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                                {/*header*/}

                                {/*body*/}
                                <div className="relative p-6 flex-auto">
                                    <div className="flex flex-row">
                                        <p className=" font-semibold mr-2 mb-6 text-md">TaskID: </p>
                                        <p className=" font-semibold text-md">
                                            {taskData && taskData.taskID}
                                        </p>
                                    </div>
                                    {/* <div className="flex flex-row">
                                        <p className="text-sm mr-2">Visit address Lat/Lng: </p>
                                        <p className="text-sm font-semibold">
                                            {taskData && taskData.visitLocation.latitude}{" "}
                                            {taskData && taskData.visitLocation.longitude}
                                        </p>
                                    </div> */}
                                    {taskData.information &&
                                        taskData.information.photographsDetails &&
                                        taskData.information.photographsDetails.length > 0 && (
                                            <div

                                            >
                                                <p className='text-sm'>Lat: {taskData.information.photographsDetails[0].latitude}</p>
                                                <p className='text-sm'>Long: {taskData.information.photographsDetails[0].longitude}</p>
                                                <p className='text-sm'>Time: {taskData.information.photographsDetails[0].timestamp}</p>
                                            </div>
                                        )}

                                    <div className="bg-white shadow-md rounded py-4 w-full mb-4">
                                        <h3 className="font-semibold text-md ml-2">Photographs</h3>
                                        <div className="flex flex-wrap py-4 gap-5 ml-3">
                                            {taskData &&
                                                taskData.photographs.map((item, index) => (
                                                    <div
                                                        style={{
                                                            width: 200,
                                                            height: 300,
                                                            borderRadius: 5,
                                                            cursor: "pointer",
                                                        }}
                                                        key={index}
                                                        onClick={() => openImageModal(item)}
                                                    >
                                                        <img
                                                            src={`data:image/jpeg;base64, ${item}`}
                                                            style={{
                                                                width: 200,
                                                                height: 300,
                                                                borderRadius: 5,
                                                            }}
                                                        />
                                                    </div>
                                                ))}
                                        </div>
                                    </div>
                                </div>
                                {/*footer*/}
                                <div className="flex items-center justify-end py-2 px-3 border-t border-solid border-blueGray-200 rounded-b">
                                    <button
                                        className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={() => setPopup(false)}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            )}
        </div>
    );
};

export default TaskById;